import * as n from "@apollo/client";
import { gql as i } from "@apollo/client";
const r = {}, s = i`
    query AffiliateServiceGetAnalyticsForAgency(
        $affiliateCode: String
        $userId: String
        $startDate: DateTime
        $endDate: DateTime
    ) {
        affiliateServiceGetAnalyticsForAgency(
            affiliateCode: $affiliateCode
            userId: $userId
            startDate: $startDate
            endDate: $endDate
        ) {
            fraudulentViews
            recentViews {
                id
                affiliateCode
                affiliateUserId
                campaignId
                createdAt
                fraudReasons
                ipAddress
                isFraudulent
                reward
                sourceEvent
                sourceReference
                sourceType
                subId
                tenantId
                totalAmount
                updatedAt
                userAgent
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
                withdrawStatus
                viewedAt
                zaloId
            }
            topCampaigns {
                campaignId
                count
            }
            totalActiveLinks
            totalViews
            uniqueViews
            viewsByDay {
                count
                date
            }
            viewsBySourceJson
        }
    }
`;
function _I(e) {
  const t = { ...r, ...e };
  return n.useQuery(s, t);
}
function XI(e) {
  const t = { ...r, ...e };
  return n.useLazyQuery(s, t);
}
function e$(e) {
  const t = e === n.skipToken ? e : { ...r, ...e };
  return n.useSuspenseQuery(s, t);
}
const o = {}, a = i`
    query AffiliateServiceGetAnalyticsForOrganization(
        $affiliateCode: String
        $userId: String
        $startDate: DateTime
        $endDate: DateTime
    ) {
        affiliateServiceGetAnalyticsForOrganization(
            affiliateCode: $affiliateCode
            userId: $userId
            startDate: $startDate
            endDate: $endDate
        ) {
            fraudulentViews
            recentViews {
                id
                affiliateCode
                affiliateUserId
                campaignId
                createdAt
                fraudReasons
                ipAddress
                isFraudulent
                reward
                sourceEvent
                sourceReference
                sourceType
                subId
                tenantId
                totalAmount
                updatedAt
                userAgent
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
                withdrawStatus
                viewedAt
                zaloId
            }
            topCampaigns {
                campaignId
                count
            }
            totalActiveLinks
            totalViews
            uniqueViews
            viewsByDay {
                count
                date
            }
            viewsBySourceJson
        }
    }
`;
function t$(e) {
  const t = { ...o, ...e };
  return n.useQuery(a, t);
}
function n$(e) {
  const t = { ...o, ...e };
  return n.useLazyQuery(a, t);
}
function i$(e) {
  const t = e === n.skipToken ? e : { ...o, ...e };
  return n.useSuspenseQuery(a, t);
}
const u = {}, c = i`
    query AffiliateServiceGetCurrentConfig {
        affiliateServiceGetCurrentConfig {
            createdAt
            id
            isActive
            rewardMode
            rewardType
            rewardValue
            sourceEvent
            requireAffiliateCodeApproval
            tenantId
            updatedAt
        }
    }
`;
function r$(e) {
  const t = { ...u, ...e };
  return n.useQuery(
    c,
    t
  );
}
function s$(e) {
  const t = { ...u, ...e };
  return n.useLazyQuery(
    c,
    t
  );
}
function o$(e) {
  const t = e === n.skipToken ? e : { ...u, ...e };
  return n.useSuspenseQuery(c, t);
}
const d = {}, p = i`
    query AffiliateServiceGetMyAffiliateCode {
        affiliateServiceGetMyAffiliateCode {
            id
            code
            createdAt
            isActive
            tenantId
            updatedAt
            userId
        }
    }
`;
function a$(e) {
  const t = { ...d, ...e };
  return n.useQuery(
    p,
    t
  );
}
function u$(e) {
  const t = { ...d, ...e };
  return n.useLazyQuery(p, t);
}
function c$(e) {
  const t = e === n.skipToken ? e : { ...d, ...e };
  return n.useSuspenseQuery(p, t);
}
const l = {}, y = i`
    query AffiliateServiceGetMyAnalytics($startDate: DateTime, $endDate: DateTime, $month: Float, $year: Float) {
        affiliateServiceGetMyAnalytics(startDate: $startDate, endDate: $endDate, month: $month, year: $year) {
            fraudulentViews
            recentViews {
                id
                affiliateCode
                affiliateUserId
                campaignId
                createdAt
                fraudReasons
                ipAddress
                isFraudulent
                reward
                sourceEvent
                sourceReference
                sourceType
                subId
                tenantId
                totalAmount
                updatedAt
                userAgent
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
                withdrawStatus
                viewedAt
                zaloId
            }
            topCampaigns {
                campaignId
                count
            }
            totalActiveLinks
            totalViews
            uniqueViews
            viewsByDay {
                count
                date
            }
            viewsBySourceJson
        }
    }
`;
function d$(e) {
  const t = { ...l, ...e };
  return n.useQuery(
    y,
    t
  );
}
function p$(e) {
  const t = { ...l, ...e };
  return n.useLazyQuery(
    y,
    t
  );
}
function l$(e) {
  const t = e === n.skipToken ? e : { ...l, ...e };
  return n.useSuspenseQuery(
    y,
    t
  );
}
const S = {}, m = i`
    query AffiliateServiceGetMyTracking($input: PaginationArgs!, $month: Float, $year: Float) {
        affiliateServiceGetMyTracking(input: $input, month: $month, year: $year) {
            data {
                id
                affiliateCode
                affiliateUserId
                campaignId
                createdAt
                fraudReasons
                ipAddress
                isFraudulent
                reward
                sourceEvent
                sourceReference
                sourceType
                subId
                tenantId
                totalAmount
                updatedAt
                userAgent
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
                withdrawStatus
                viewedAt
                zaloId
            }
            total
        }
    }
`;
function y$(e) {
  const t = { ...S, ...e };
  return n.useQuery(
    m,
    t
  );
}
function S$(e) {
  const t = { ...S, ...e };
  return n.useLazyQuery(
    m,
    t
  );
}
function m$(e) {
  const t = e === n.skipToken ? e : { ...S, ...e };
  return n.useSuspenseQuery(
    m,
    t
  );
}
const v = {}, g = i`
    query AffiliateServiceGetTrackingForAgency($filter: AffiliateServiceGetTrackingFilterInput!) {
        affiliateServiceGetTrackingForAgency(filter: $filter) {
            data {
                id
                affiliateCode
                affiliateUserId
                campaignId
                createdAt
                fraudReasons
                ipAddress
                isFraudulent
                reward
                sourceEvent
                sourceReference
                sourceType
                subId
                tenantId
                totalAmount
                updatedAt
                userAgent
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
                withdrawStatus
                viewedAt
                zaloId
            }
            total
        }
    }
`;
function v$(e) {
  const t = { ...v, ...e };
  return n.useQuery(g, t);
}
function g$(e) {
  const t = { ...v, ...e };
  return n.useLazyQuery(g, t);
}
function f$(e) {
  const t = e === n.skipToken ? e : { ...v, ...e };
  return n.useSuspenseQuery(g, t);
}
const f = {}, A = i`
    query AffiliateServiceGetTrackingForOrganization($filter: AffiliateServiceGetTrackingFilterInput!) {
        affiliateServiceGetTrackingForOrganization(filter: $filter) {
            data {
                id
                affiliateCode
                affiliateUserId
                campaignId
                createdAt
                fraudReasons
                ipAddress
                isFraudulent
                reward
                sourceEvent
                sourceReference
                sourceType
                subId
                tenantId
                totalAmount
                updatedAt
                userAgent
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
                withdrawStatus
                viewedAt
                zaloId
            }
            total
        }
    }
`;
function A$(e) {
  const t = { ...f, ...e };
  return n.useQuery(A, t);
}
function I$(e) {
  const t = { ...f, ...e };
  return n.useLazyQuery(A, t);
}
function $$(e) {
  const t = e === n.skipToken ? e : { ...f, ...e };
  return n.useSuspenseQuery(A, t);
}
const Hc = {}, Nc = i`
    mutation AffiliateServiceTrack($affiliateCode: String!, $input: AffiliateServiceTrackInput!) {
        affiliateServiceTrack(affiliateCode: $affiliateCode, input: $input) {
            id
            affiliateCode
            affiliateUserId
            campaignId
            createdAt
            fraudReasons
            ipAddress
            isFraudulent
            reward
            sourceEvent
            sourceReference
            sourceType
            subId
            tenantId
            totalAmount
            updatedAt
            userAgent
            utmParameters {
                campaign
                content
                medium
                source
                term
            }
            withdrawStatus
            viewedAt
            zaloId
        }
    }
`;
function Q$(e) {
  const t = { ...Hc, ...e };
  return n.useMutation(
    Nc,
    t
  );
}
const I = {}, $ = i`
    query AffiliateServiceGetMyBalance($month: Float, $year: Float) {
        affiliateServiceGetMyBalance(month: $month, year: $year) {
            availableBalance
            totalReward
            totalWithdrawn
        }
    }
`;
function C$(e) {
  const t = { ...I, ...e };
  return n.useQuery(
    $,
    t
  );
}
function h$(e) {
  const t = { ...I, ...e };
  return n.useLazyQuery(
    $,
    t
  );
}
function k$(e) {
  const t = e === n.skipToken ? e : { ...I, ...e };
  return n.useSuspenseQuery(
    $,
    t
  );
}
const Wc = {}, jc = i`
    mutation AffiliateServiceUpsertConfig($input: AffiliateServiceUpsertConfigInput!) {
        affiliateServiceUpsertConfig(input: $input) {
            createdAt
            id
            isActive
            requireAffiliateCodeApproval
            rewardMode
            rewardType
            rewardValue
            sourceEvent
            tenantId
            updatedAt
        }
    }
`;
function D$(e) {
  const t = { ...Wc, ...e };
  return n.useMutation(
    jc,
    t
  );
}
const Kc = {}, Zc = i`
    mutation AffiliateServiceCreateCodeRequest($input: AffiliateServiceCreateCodeRequestInput!) {
        affiliateServiceCreateCodeRequest(input: $input) {
            affiliateCodeCreated
            channel
            createdAt
            email
            id
            linkGoogleDrive
            name
            phoneNumber
            reviewNote
            reviewedAt
            reviewedBy
            status
            tenantId
            updatedAt
            userId
        }
    }
`;
function P$(e) {
  const t = { ...Kc, ...e };
  return n.useMutation(Zc, t);
}
const Yc = {}, Jc = i`
    mutation AffiliateServiceCreateLink($input: AffiliateServiceCreateLinkInput!) {
        affiliateServiceCreateLink(input: $input) {
            affiliateCode
            clickCount
            conversionCount
            createdAt
            customSlug
            description
            destinationUrl
            expiresAt
            fullUrl
            id
            isActive
            shortUrl
            shortUrlKey
            shortenerProvider
            tenantId
            title
            updatedAt
            userId
            utmParameters {
                campaign
                content
                medium
                source
                term
            }
        }
    }
`;
function T$(e) {
  const t = { ...Yc, ...e };
  return n.useMutation(
    Jc,
    t
  );
}
const _c = {}, Xc = i`
    mutation AffiliateServiceDeleteCodeRequestById($id: String!) {
        affiliateServiceDeleteCodeRequestById(id: $id)
    }
`;
function M$(e) {
  const t = { ..._c, ...e };
  return n.useMutation(Xc, t);
}
const ed = {}, td = i`
    mutation AffiliateServiceDeleteLink($linkId: String!) {
        affiliateServiceDeleteLink(linkId: $linkId)
    }
`;
function b$(e) {
  const t = { ...ed, ...e };
  return n.useMutation(
    td,
    t
  );
}
const nd = {}, id = i`
    mutation AffiliateServiceReviewCodeRequest($input: AffiliateServiceReviewCodeRequestInput!) {
        affiliateServiceReviewCodeRequest(input: $input) {
            affiliateCodeCreated
            channel
            createdAt
            email
            id
            linkGoogleDrive
            name
            phoneNumber
            reviewNote
            reviewedAt
            reviewedBy
            status
            tenantId
            updatedAt
            userId
        }
    }
`;
function L$(e) {
  const t = { ...nd, ...e };
  return n.useMutation(id, t);
}
const rd = {}, sd = i`
    mutation AffiliateServiceUpdateLink($input: AffiliateServiceUpdateLinkInput!) {
        affiliateServiceUpdateLink(input: $input) {
            affiliateCode
            clickCount
            conversionCount
            createdAt
            customSlug
            description
            destinationUrl
            expiresAt
            fullUrl
            id
            isActive
            shortUrl
            shortUrlKey
            shortenerProvider
            tenantId
            title
            updatedAt
            userId
            utmParameters {
                campaign
                content
                medium
                source
                term
            }
        }
    }
`;
function B$(e) {
  const t = { ...rd, ...e };
  return n.useMutation(
    sd,
    t
  );
}
const Q = {}, C = i`
    query AffiliateServiceGetCodeRequests($filter: AffiliateServiceGetCodeRequestsFilterInput!) {
        affiliateServiceGetCodeRequests(filter: $filter) {
            data {
                affiliateCodeCreated
                channel
                createdAt
                email
                id
                linkGoogleDrive
                name
                phoneNumber
                reviewNote
                reviewedAt
                reviewedBy
                status
                tenantId
                updatedAt
                userId
            }
            limit
            skip
            total
        }
    }
`;
function U$(e) {
  const t = { ...Q, ...e };
  return n.useQuery(
    C,
    t
  );
}
function z$(e) {
  const t = { ...Q, ...e };
  return n.useLazyQuery(
    C,
    t
  );
}
function F$(e) {
  const t = e === n.skipToken ? e : { ...Q, ...e };
  return n.useSuspenseQuery(
    C,
    t
  );
}
const h = {}, k = i`
    query AffiliateServiceGetLinksForOrganization($filter: AffiliateServiceGetLinksFilterInput!) {
        affiliateServiceGetLinksForOrganization(filter: $filter) {
            data {
                affiliateCode
                clickCount
                conversionCount
                createdAt
                customSlug
                description
                destinationUrl
                expiresAt
                fullUrl
                id
                isActive
                shortUrl
                shortUrlKey
                shortenerProvider
                tenantId
                title
                updatedAt
                userId
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
            }
            limit
            skip
            total
        }
    }
`;
function R$(e) {
  const t = { ...h, ...e };
  return n.useQuery(k, t);
}
function G$(e) {
  const t = { ...h, ...e };
  return n.useLazyQuery(k, t);
}
function q$(e) {
  const t = e === n.skipToken ? e : { ...h, ...e };
  return n.useSuspenseQuery(k, t);
}
const D = {}, P = i`
    query AffiliateServiceGetMyCodeRequest {
        affiliateServiceGetMyCodeRequest {
            affiliateCodeCreated
            channel
            createdAt
            email
            id
            linkGoogleDrive
            name
            phoneNumber
            reviewNote
            reviewedAt
            reviewedBy
            status
            tenantId
            updatedAt
            userId
        }
    }
`;
function E$(e) {
  const t = { ...D, ...e };
  return n.useQuery(
    P,
    t
  );
}
function V$(e) {
  const t = { ...D, ...e };
  return n.useLazyQuery(
    P,
    t
  );
}
function O$(e) {
  const t = e === n.skipToken ? e : { ...D, ...e };
  return n.useSuspenseQuery(P, t);
}
const T = {}, M = i`
    query AffiliateServiceGetMyLink($linkId: String!) {
        affiliateServiceGetMyLink(linkId: $linkId) {
            affiliateCode
            clickCount
            conversionCount
            createdAt
            customSlug
            description
            destinationUrl
            expiresAt
            fullUrl
            id
            isActive
            shortUrl
            shortUrlKey
            shortenerProvider
            tenantId
            title
            updatedAt
            userId
            utmParameters {
                campaign
                content
                medium
                source
                term
            }
        }
    }
`;
function x$(e) {
  const t = { ...T, ...e };
  return n.useQuery(
    M,
    t
  );
}
function w$(e) {
  const t = { ...T, ...e };
  return n.useLazyQuery(
    M,
    t
  );
}
function H$(e) {
  const t = e === n.skipToken ? e : { ...T, ...e };
  return n.useSuspenseQuery(
    M,
    t
  );
}
const b = {}, L = i`
    query AffiliateServiceGetMyLinks($limit: Float, $skip: Float) {
        affiliateServiceGetMyLinks(limit: $limit, skip: $skip) {
            data {
                affiliateCode
                clickCount
                conversionCount
                createdAt
                customSlug
                description
                destinationUrl
                expiresAt
                fullUrl
                id
                isActive
                shortUrl
                shortUrlKey
                shortenerProvider
                tenantId
                title
                updatedAt
                userId
                utmParameters {
                    campaign
                    content
                    medium
                    source
                    term
                }
            }
            limit
            skip
            total
        }
    }
`;
function N$(e) {
  const t = { ...b, ...e };
  return n.useQuery(
    L,
    t
  );
}
function W$(e) {
  const t = { ...b, ...e };
  return n.useLazyQuery(
    L,
    t
  );
}
function j$(e) {
  const t = e === n.skipToken ? e : { ...b, ...e };
  return n.useSuspenseQuery(
    L,
    t
  );
}
const B = {}, U = i`
    query AffiliateServiceGetUrlShortenerProviders {
        affiliateServiceGetUrlShortenerProviders {
            defaultProvider
            providers {
                description
                isConfigured
                name
                provider
                requiresApiKey
                supportsCustomSlug
            }
        }
    }
`;
function K$(e) {
  const t = { ...B, ...e };
  return n.useQuery(U, t);
}
function Z$(e) {
  const t = { ...B, ...e };
  return n.useLazyQuery(U, t);
}
function Y$(e) {
  const t = e === n.skipToken ? e : { ...B, ...e };
  return n.useSuspenseQuery(U, t);
}
const z = {}, F = i`
    query ApiHubServiceApiProviders($filter: apiHubServiceApiProviderFilter, $params: ApiHubServicePagination) {
        apiHubServiceApiProviders(filter: $filter, params: $params) {
            providers {
                id
                providerCode
                connectorQueue
                connectorUrl
                iconUrl
                status
                credentialStrategy
                isDeleted
                createdAt
                updatedAt
                deletedAt
            }
            total
        }
    }
`;
function J$(e) {
  const t = { ...z, ...e };
  return n.useQuery(
    F,
    t
  );
}
function _$(e) {
  const t = { ...z, ...e };
  return n.useLazyQuery(
    F,
    t
  );
}
function X$(e) {
  const t = e === n.skipToken ? e : { ...z, ...e };
  return n.useSuspenseQuery(
    F,
    t
  );
}
const R = {}, G = i`
    query ApiHubServiceApiProviderByCode($providerCode: String!) {
        apiHubServiceApiProviderByCode(providerCode: $providerCode) {
            id
            providerCode
            connectorKind
            connectorQueue
            connectorUrl
            iconUrl
            status
            credentialStrategy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function eQ(e) {
  const t = { ...R, ...e };
  return n.useQuery(
    G,
    t
  );
}
function tQ(e) {
  const t = { ...R, ...e };
  return n.useLazyQuery(
    G,
    t
  );
}
function nQ(e) {
  const t = e === n.skipToken ? e : { ...R, ...e };
  return n.useSuspenseQuery(
    G,
    t
  );
}
const q = {}, E = i`
    query ApiHubServiceApiCredentialTemplates($providerCodes: [String], $params: ApiHubServicePagination) {
        apiHubServiceApiCredentialTemplates(providerCodes: $providerCodes, params: $params) {
            templates {
                id
                providerCode
                templateCode
                acquisitionMethod
                credentialType
                schema
                isActive
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function iQ(e) {
  const t = { ...q, ...e };
  return n.useQuery(
    E,
    t
  );
}
function rQ(e) {
  const t = { ...q, ...e };
  return n.useLazyQuery(E, t);
}
function sQ(e) {
  const t = e === n.skipToken ? e : { ...q, ...e };
  return n.useSuspenseQuery(E, t);
}
const V = {}, O = i`
    query ApiHubServiceApiCredentials($filter: ApiHubServiceApiCredentialFilter, $params: ApiHubServicePagination) {
        apiHubServiceApiCredentials(filter: $filter, params: $params) {
            credentials {
                id
                providerCode
                scope
                tenantId
                externalAccountId
                accountAlias
                credentialType
                fields
                expiresAt
                refreshExpiresAt
                isCurrent
                status
                createdBy
                updatedBy
                isDeleted
                createdAt
                updatedAt
                deletedAt
            }
            total
        }
    }
`;
function oQ(e) {
  const t = { ...V, ...e };
  return n.useQuery(
    O,
    t
  );
}
function aQ(e) {
  const t = { ...V, ...e };
  return n.useLazyQuery(
    O,
    t
  );
}
function uQ(e) {
  const t = e === n.skipToken ? e : { ...V, ...e };
  return n.useSuspenseQuery(
    O,
    t
  );
}
const x = {}, w = i`
    query ApiHubServiceApiCredentialsByTenant($tenantId: String!) {
        apiHubServiceApiCredentialsByTenant(tenantId: $tenantId) {
            id
            providerCode
            scope
            tenantId
            externalAccountId
            accountAlias
            credentialType
            fields
            expiresAt
            refreshExpiresAt
            isCurrent
            status
            createdBy
            updatedBy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function cQ(e) {
  const t = { ...x, ...e };
  return n.useQuery(
    w,
    t
  );
}
function dQ(e) {
  const t = { ...x, ...e };
  return n.useLazyQuery(w, t);
}
function pQ(e) {
  const t = e === n.skipToken ? e : { ...x, ...e };
  return n.useSuspenseQuery(w, t);
}
const H = {}, N = i`
    query ApiHubServiceLinks($filter: ApiHubServiceLinkFilter, $params: ApiHubServicePagination) {
        apiHubServiceLinks(filter: $filter, params: $params) {
            links {
                id
                tenantId
                providerCode
                isEnabled
                credentialRefId
                strategy
                selectionPolicy
                isDefault
                priority
                isDeleted
                createdAt
                updatedAt
                deletedAt
            }
            total
        }
    }
`;
function lQ(e) {
  const t = { ...H, ...e };
  return n.useQuery(
    N,
    t
  );
}
function yQ(e) {
  const t = { ...H, ...e };
  return n.useLazyQuery(
    N,
    t
  );
}
function SQ(e) {
  const t = e === n.skipToken ? e : { ...H, ...e };
  return n.useSuspenseQuery(
    N,
    t
  );
}
const W = {}, j = i`
    query ApiHubServiceWebhookEndpoint($id: UUID) {
        apiHubServiceWebhookEndpoint(id: $id) {
            id
            tenantId
            providerCode
            webhookUrl
            webhookSecret
            subscribedEvents
            isEnabled
            eventDeliveryType
            externalIdentifier
            externalIdentifierField
            metadata
            createdAt
            updatedAt
        }
    }
`;
function mQ(e) {
  const t = { ...W, ...e };
  return n.useQuery(
    j,
    t
  );
}
function vQ(e) {
  const t = { ...W, ...e };
  return n.useLazyQuery(
    j,
    t
  );
}
function gQ(e) {
  const t = e === n.skipToken ? e : { ...W, ...e };
  return n.useSuspenseQuery(
    j,
    t
  );
}
const K = {}, Z = i`
    query ApiHubServiceWebhookEndpoints($providerCode: String, $tenantId: String) {
        apiHubServiceWebhookEndpoints(providerCode: $providerCode, tenantId: $tenantId) {
            id
            tenantId
            providerCode
            webhookUrl
            webhookSecret
            subscribedEvents
            isEnabled
            eventDeliveryType
            externalIdentifier
            externalIdentifierField
            metadata
            createdAt
            updatedAt
        }
    }
`;
function fQ(e) {
  const t = { ...K, ...e };
  return n.useQuery(
    Z,
    t
  );
}
function AQ(e) {
  const t = { ...K, ...e };
  return n.useLazyQuery(
    Z,
    t
  );
}
function IQ(e) {
  const t = e === n.skipToken ? e : { ...K, ...e };
  return n.useSuspenseQuery(
    Z,
    t
  );
}
const Y = {}, J = i`
    query ApiHubServiceWebhookEvent($id: UUID) {
        apiHubServiceWebhookEvent(id: $id) {
            id
            webhookEndpointId
            providerCode
            tenantId
            eventId
            eventType
            subject
            externalIdentifier
            payload
            transformedPayload
            requestHeaders
            requestId
            receivedAt
            processedAt
            processingStatus
            verificationStatus
            errorMessage
            createdAt
            updatedAt
        }
    }
`;
function $Q(e) {
  const t = { ...Y, ...e };
  return n.useQuery(
    J,
    t
  );
}
function QQ(e) {
  const t = { ...Y, ...e };
  return n.useLazyQuery(
    J,
    t
  );
}
function CQ(e) {
  const t = e === n.skipToken ? e : { ...Y, ...e };
  return n.useSuspenseQuery(
    J,
    t
  );
}
const _ = {}, X = i`
    query ApiHubServiceWebhookEvents($filter: ApiHubServiceWebhookEventFilter, $params: ApiHubServicePagination) {
        apiHubServiceWebhookEvents(filter: $filter, params: $params) {
            events {
                id
                webhookEndpointId
                providerCode
                tenantId
                eventId
                eventType
                subject
                externalIdentifier
                payload
                transformedPayload
                requestHeaders
                requestId
                receivedAt
                processedAt
                processingStatus
                verificationStatus
                errorMessage
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function hQ(e) {
  const t = { ..._, ...e };
  return n.useQuery(
    X,
    t
  );
}
function kQ(e) {
  const t = { ..._, ...e };
  return n.useLazyQuery(
    X,
    t
  );
}
function DQ(e) {
  const t = e === n.skipToken ? e : { ..._, ...e };
  return n.useSuspenseQuery(
    X,
    t
  );
}
const ee = {}, te = i`
    query ApiHubServiceWebhookProvider($providerCode: String) {
        apiHubServiceWebhookProvider(providerCode: $providerCode) {
            id
            providerCode
            webhookName
            description
            webhookUrlPattern
            authenticationMethod
            authenticationConfig
            routingStrategy
            status
            supportedEventTypes
            supportedEvents {
                eventType
                eventName
                subject
                isEnabled
                eventDeliveryType
                transformTemplate
                deliveryConfig
            }
            eventIdConfig {
                fieldName
                fieldPath
                headerName
            }
            eventTypeConfig {
                fieldName
                fieldPath
                headerName
            }
            identifierExtractionConfig {
                fieldName
                fieldPath
                headerName
                example
            }
            retryConfig {
                maxRetries
                retryDelaySeconds
                maxRetryDelaySeconds
                exponentialBackoff
                retryableErrorCodes
            }
            rateLimit {
                requestsPerMinute
                burstSize
            }
            metadata
            createdAt
            updatedAt
        }
    }
`;
function PQ(e) {
  const t = { ...ee, ...e };
  return n.useQuery(
    te,
    t
  );
}
function TQ(e) {
  const t = { ...ee, ...e };
  return n.useLazyQuery(
    te,
    t
  );
}
function MQ(e) {
  const t = e === n.skipToken ? e : { ...ee, ...e };
  return n.useSuspenseQuery(
    te,
    t
  );
}
const ne = {}, ie = i`
    query ApiHubServiceWebhookProviders($filter: JSON, $params: ApiHubServicePagination) {
        apiHubServiceWebhookProviders(filter: $filter, params: $params) {
            id
            providerCode
            webhookName
            description
            webhookUrlPattern
            authenticationMethod
            authenticationConfig
            routingStrategy
            status
            supportedEventTypes
            supportedEvents {
                eventType
                eventName
                subject
                isEnabled
                eventDeliveryType
                transformTemplate
                deliveryConfig
            }
            eventIdConfig {
                fieldName
                fieldPath
                headerName
            }
            eventTypeConfig {
                fieldName
                fieldPath
                headerName
            }
            identifierExtractionConfig {
                fieldName
                fieldPath
                headerName
                example
            }
            retryConfig {
                maxRetries
                retryDelaySeconds
                maxRetryDelaySeconds
                exponentialBackoff
                retryableErrorCodes
            }
            rateLimit {
                requestsPerMinute
                burstSize
            }
            metadata
            createdAt
            updatedAt
        }
    }
`;
function bQ(e) {
  const t = { ...ne, ...e };
  return n.useQuery(
    ie,
    t
  );
}
function LQ(e) {
  const t = { ...ne, ...e };
  return n.useLazyQuery(
    ie,
    t
  );
}
function BQ(e) {
  const t = e === n.skipToken ? e : { ...ne, ...e };
  return n.useSuspenseQuery(
    ie,
    t
  );
}
const re = {}, se = i`
    query ApiHubServiceWebhookRoutingMaps($filter: JSON, $params: ApiHubServicePagination) {
        apiHubServiceWebhookRoutingMaps(filter: $filter, params: $params) {
            id
            tenantId
            providerCode
            externalIdentifier
            externalIdentifierType
            webhookEndpointId
            isActive
            metadata
            createdAt
            updatedAt
        }
    }
`;
function UQ(e) {
  const t = { ...re, ...e };
  return n.useQuery(
    se,
    t
  );
}
function zQ(e) {
  const t = { ...re, ...e };
  return n.useLazyQuery(
    se,
    t
  );
}
function FQ(e) {
  const t = e === n.skipToken ? e : { ...re, ...e };
  return n.useSuspenseQuery(
    se,
    t
  );
}
const od = {}, ad = i`
    mutation ApiHubServiceCreateApiProvider($input: ApiHubServiceCreateApiProviderInput!) {
        apiHubServiceCreateApiProvider(input: $input)
    }
`;
function RQ(e) {
  const t = { ...od, ...e };
  return n.useMutation(
    ad,
    t
  );
}
const ud = {}, cd = i`
    mutation ApiHubServiceUpdateApiProvider($input: ApiHubServiceUpdateApiProviderInput!) {
        apiHubServiceUpdateApiProvider(input: $input) {
            id
            providerCode
            connectorKind
            connectorQueue
            connectorUrl
            iconUrl
            status
            credentialStrategy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function GQ(e) {
  const t = { ...ud, ...e };
  return n.useMutation(
    cd,
    t
  );
}
const dd = {}, pd = i`
    mutation ApiHubServiceSetApiProviderStatus($providerCode: String!, $status: apiHubServiceApiProviderStatus!) {
        apiHubServiceSetApiProviderStatus(providerCode: $providerCode, status: $status) {
            id
            providerCode
            connectorKind
            connectorQueue
            connectorUrl
            iconUrl
            status
            credentialStrategy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function qQ(e) {
  const t = { ...dd, ...e };
  return n.useMutation(pd, t);
}
const ld = {}, yd = i`
    mutation ApiHubServiceUpsertApiCredentialTemplate($input: ApiHubServiceUpsertApiCredentialTemplateInput!) {
        apiHubServiceUpsertApiCredentialTemplate(input: $input) {
            id
            providerCode
            templateCode
            acquisitionMethod
            credentialType
            schema
            isActive
            createdAt
            updatedAt
        }
    }
`;
function EQ(e) {
  const t = { ...ld, ...e };
  return n.useMutation(yd, t);
}
const Sd = {}, md = i`
    mutation ApiHubServiceCreateApiCredential($input: ApiHubServiceCreateApiCredentialInput!) {
        apiHubServiceCreateApiCredential(input: $input) {
            id
            providerCode
            scope
            tenantId
            externalAccountId
            accountAlias
            credentialType
            fields
            expiresAt
            refreshExpiresAt
            isCurrent
            status
            createdBy
            updatedBy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function VQ(e) {
  const t = { ...Sd, ...e };
  return n.useMutation(md, t);
}
const vd = {}, gd = i`
    mutation ApiHubServiceUpdateApiCredential($input: ApiHubServiceUpdateApiCredentialInput!) {
        apiHubServiceUpdateApiCredential(input: $input) {
            id
            providerCode
            scope
            tenantId
            externalAccountId
            accountAlias
            credentialType
            fields
            expiresAt
            refreshExpiresAt
            isCurrent
            status
            createdBy
            updatedBy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function OQ(e) {
  const t = { ...vd, ...e };
  return n.useMutation(gd, t);
}
const fd = {}, Ad = i`
    mutation ApiHubServiceRotateApiCredential($input: ApiHubServiceRotateApiCredentialInput!) {
        apiHubServiceRotateApiCredential(input: $input) {
            id
            providerCode
            scope
            tenantId
            externalAccountId
            accountAlias
            credentialType
            fields
            expiresAt
            refreshExpiresAt
            isCurrent
            status
            createdBy
            updatedBy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function xQ(e) {
  const t = { ...fd, ...e };
  return n.useMutation(Ad, t);
}
const Id = {}, $d = i`
    mutation ApiHubServicePromoteApiCredential($input: ApiHubServicePromoteApiCredentialInput!) {
        apiHubServicePromoteApiCredential(input: $input) {
            id
            providerCode
            scope
            tenantId
            externalAccountId
            accountAlias
            credentialType
            fields
            expiresAt
            refreshExpiresAt
            isCurrent
            status
            createdBy
            updatedBy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function wQ(e) {
  const t = { ...Id, ...e };
  return n.useMutation($d, t);
}
const Qd = {}, Cd = i`
    mutation ApiHubServiceRollbackApiCredential($input: ApiHubServiceRollbackApiCredentialInput!) {
        apiHubServiceRollbackApiCredential(input: $input) {
            id
            providerCode
            scope
            tenantId
            externalAccountId
            accountAlias
            credentialType
            fields
            expiresAt
            refreshExpiresAt
            isCurrent
            status
            createdBy
            updatedBy
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function HQ(e) {
  const t = { ...Qd, ...e };
  return n.useMutation(Cd, t);
}
const hd = {}, kd = i`
    mutation ApiHubServiceUpsertTenantProviderLink($input: ApiHubServiceUpsertTenantProviderLinkInput!) {
        apiHubServiceUpsertTenantProviderLink(input: $input) {
            id
            tenantId
            providerCode
            isEnabled
            credentialRefId
            strategy
            selectionPolicy
            isDefault
            priority
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function NQ(e) {
  const t = { ...hd, ...e };
  return n.useMutation(kd, t);
}
const Dd = {}, Pd = i`
    mutation ApiHubServiceDisableTenantProviderLink($id: UUID!) {
        apiHubServiceDisableTenantProviderLink(id: $id) {
            id
            tenantId
            providerCode
            isEnabled
            credentialRefId
            strategy
            selectionPolicy
            isDefault
            priority
            isDeleted
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function WQ(e) {
  const t = { ...Dd, ...e };
  return n.useMutation(Pd, t);
}
const Td = {}, Md = i`
    mutation ApiHubServiceCreateWebhookProvider($input: ApiHubServiceCreateWebhookProviderInput) {
        apiHubServiceCreateWebhookProvider(input: $input) {
            id
            providerCode
            webhookName
            description
            webhookUrlPattern
            authenticationMethod
            authenticationConfig
            routingStrategy
            status
            supportedEventTypes
            supportedEvents {
                eventType
                eventName
                subject
                isEnabled
                eventDeliveryType
                transformTemplate
                deliveryConfig
            }
            eventIdConfig {
                fieldName
                fieldPath
                headerName
            }
            eventTypeConfig {
                fieldName
                fieldPath
                headerName
            }
            identifierExtractionConfig {
                fieldName
                fieldPath
                headerName
                example
            }
            retryConfig {
                maxRetries
                retryDelaySeconds
                maxRetryDelaySeconds
                exponentialBackoff
                retryableErrorCodes
            }
            rateLimit {
                requestsPerMinute
                burstSize
            }
            metadata
            createdAt
            updatedAt
        }
    }
`;
function jQ(e) {
  const t = { ...Td, ...e };
  return n.useMutation(Md, t);
}
const bd = {}, Ld = i`
    mutation ApiHubServiceCreateWebhookRoutingMap($input: ApiHubServiceCreateWebhookRoutingMapInput) {
        apiHubServiceCreateWebhookRoutingMap(input: $input) {
            id
            tenantId
            providerCode
            externalIdentifier
            externalIdentifierType
            webhookEndpointId
            isActive
            metadata
            createdAt
            updatedAt
        }
    }
`;
function KQ(e) {
  const t = { ...bd, ...e };
  return n.useMutation(Ld, t);
}
const Bd = {}, Ud = i`
    mutation ApiHubServiceDeleteWebhookEndpoint($id: UUID) {
        apiHubServiceDeleteWebhookEndpoint(id: $id)
    }
`;
function ZQ(e) {
  const t = { ...Bd, ...e };
  return n.useMutation(Ud, t);
}
const zd = {}, Fd = i`
    mutation ApiHubServiceDeleteWebhookProvider($id: UUID) {
        apiHubServiceDeleteWebhookProvider(id: $id)
    }
`;
function YQ(e) {
  const t = { ...zd, ...e };
  return n.useMutation(Fd, t);
}
const Rd = {}, Gd = i`
    mutation ApiHubServiceDeleteWebhookRoutingMap($id: UUID) {
        apiHubServiceDeleteWebhookRoutingMap(id: $id)
    }
`;
function JQ(e) {
  const t = { ...Rd, ...e };
  return n.useMutation(Gd, t);
}
const qd = {}, Ed = i`
    mutation ApiHubServiceRegenerateWebhookSecret($endpointId: UUID) {
        apiHubServiceRegenerateWebhookSecret(endpointId: $endpointId) {
            id
            tenantId
            providerCode
            webhookUrl
            webhookSecret
            subscribedEvents
            isEnabled
            eventDeliveryType
            externalIdentifier
            externalIdentifierField
            metadata
            createdAt
            updatedAt
        }
    }
`;
function _Q(e) {
  const t = { ...qd, ...e };
  return n.useMutation(Ed, t);
}
const Vd = {}, Od = i`
    mutation ApiHubServiceRetryWebhookEvent($eventId: UUID) {
        apiHubServiceRetryWebhookEvent(eventId: $eventId) {
            id
            webhookEndpointId
            providerCode
            tenantId
            eventId
            eventType
            subject
            externalIdentifier
            payload
            transformedPayload
            requestHeaders
            requestId
            receivedAt
            processedAt
            processingStatus
            verificationStatus
            errorMessage
            createdAt
            updatedAt
        }
    }
`;
function XQ(e) {
  const t = { ...Vd, ...e };
  return n.useMutation(
    Od,
    t
  );
}
const xd = {}, wd = i`
    mutation ApiHubServiceUpdateWebhookProvider($id: UUID!, $input: ApiHubServiceUpdateWebhookProviderInput) {
        apiHubServiceUpdateWebhookProvider(id: $id, input: $input) {
            id
            providerCode
            webhookName
            description
            webhookUrlPattern
            authenticationMethod
            authenticationConfig
            routingStrategy
            status
            supportedEventTypes
            supportedEvents {
                eventType
                eventName
                subject
                isEnabled
                eventDeliveryType
                transformTemplate
                deliveryConfig
            }
            eventIdConfig {
                fieldName
                fieldPath
                headerName
            }
            eventTypeConfig {
                fieldName
                fieldPath
                headerName
            }
            identifierExtractionConfig {
                fieldName
                fieldPath
                headerName
                example
            }
            retryConfig {
                maxRetries
                retryDelaySeconds
                maxRetryDelaySeconds
                exponentialBackoff
                retryableErrorCodes
            }
            rateLimit {
                requestsPerMinute
                burstSize
            }
            metadata
            createdAt
            updatedAt
        }
    }
`;
function eC(e) {
  const t = { ...xd, ...e };
  return n.useMutation(wd, t);
}
const Hd = {}, Nd = i`
    mutation ApiHubServiceUpsertWebhookEndpoint($input: ApiHubServiceUpsertWebhookEndpointInput) {
        apiHubServiceUpsertWebhookEndpoint(input: $input) {
            id
            tenantId
            providerCode
            webhookUrl
            webhookSecret
            subscribedEvents
            isEnabled
            eventDeliveryType
            externalIdentifier
            externalIdentifierField
            metadata
            createdAt
            updatedAt
        }
    }
`;
function tC(e) {
  const t = { ...Hd, ...e };
  return n.useMutation(Nd, t);
}
const Wd = {}, jd = i`
    mutation AuthServiceChangePassword($input: AuthServiceChangePasswordGqlInput!) {
        authServiceChangePassword(input: $input)
    }
`;
function nC(e) {
  const t = { ...Wd, ...e };
  return n.useMutation(
    jd,
    t
  );
}
const Kd = {}, Zd = i`
    mutation AuthServiceConfirmRegister($input: AuthServiceConfirmTokenGqlInput!) {
        authServiceConfirmRegister(input: $input)
    }
`;
function iC(e) {
  const t = { ...Kd, ...e };
  return n.useMutation(
    Zd,
    t
  );
}
const Yd = {}, Jd = i`
    mutation AuthServiceEmailForgotPassword($input: AuthServiceForgotPasswordGqlInput!) {
        authServiceEmailForgotPassword(input: $input)
    }
`;
function rC(e) {
  const t = { ...Yd, ...e };
  return n.useMutation(
    Jd,
    t
  );
}
const _d = {}, Xd = i`
    mutation AuthServiceEmailLogin($input: AuthServiceLoginGqlInput!) {
        authServiceEmailLogin(input: $input) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                fullName
                phoneNumber
                avatarUrl
                birthDate
                gender
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function sC(e) {
  const t = { ..._d, ...e };
  return n.useMutation(
    Xd,
    t
  );
}
const ep = {}, tp = i`
    mutation AuthServiceEmailRegister($input: AuthServiceRegisterGqlInput!) {
        authServiceEmailRegister(input: $input)
    }
`;
function oC(e) {
  const t = { ...ep, ...e };
  return n.useMutation(
    tp,
    t
  );
}
const np = {}, ip = i`
    mutation AuthServiceLoginWithGoogle($input: AuthServiceLoginWithSocialGqlInput!) {
        authServiceLoginWithGoogle(input: $input) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                fullName
                phoneNumber
                avatarUrl
                birthDate
                gender
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function aC(e) {
  const t = { ...np, ...e };
  return n.useMutation(
    ip,
    t
  );
}
const oe = {}, ae = i`
    query AuthServiceMe {
        authServiceMe {
            id
            avatarUrl
            createdAt
            email
            firstName
            lastName
            phoneNumber
            status
            tenantId
            type
            updatedAt
            zaloId
        }
    }
`;
function uC(e) {
  const t = { ...oe, ...e };
  return n.useQuery(ae, t);
}
function cC(e) {
  const t = { ...oe, ...e };
  return n.useLazyQuery(ae, t);
}
function dC(e) {
  const t = e === n.skipToken ? e : { ...oe, ...e };
  return n.useSuspenseQuery(ae, t);
}
const rp = {}, sp = i`
    mutation AuthServiceRefreshToken($refreshToken: String!) {
        authServiceRefreshToken(refreshToken: $refreshToken) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                fullName
                phoneNumber
                avatarUrl
                birthDate
                gender
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function pC(e) {
  const t = { ...rp, ...e };
  return n.useMutation(
    sp,
    t
  );
}
const op = {}, ap = i`
    mutation AuthServiceResetPassword($input: AuthServiceResetPasswordGqlInput!) {
        authServiceResetPassword(input: $input)
    }
`;
function lC(e) {
  const t = { ...op, ...e };
  return n.useMutation(
    ap,
    t
  );
}
const up = {}, cp = i`
    mutation AuthServiceImpersonateUser($input: AuthServiceImpersonateUserGqlInput!) {
        authServiceImpersonateUser(input: $input) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                fullName
                phoneNumber
                avatarUrl
                birthDate
                gender
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function yC(e) {
  const t = { ...up, ...e };
  return n.useMutation(
    cp,
    t
  );
}
const dp = {}, pp = i`
    mutation AuthServiceZaloLogin($input: AuthServiceZaloLoginGqlInput!) {
        authServiceZaloLogin(input: $input) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                fullName
                phoneNumber
                avatarUrl
                birthDate
                gender
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function SC(e) {
  const t = { ...dp, ...e };
  return n.useMutation(
    pp,
    t
  );
}
const lp = {}, yp = i`
    mutation AuthServiceKratosEmailLogin($input: AuthServiceKratosLoginGqlInput!) {
        authServiceKratosEmailLogin(input: $input) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                phoneNumber
                avatarUrl
                birthDate
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function mC(e) {
  const t = { ...lp, ...e };
  return n.useMutation(
    yp,
    t
  );
}
const Sp = {}, mp = i`
    mutation AuthServiceKratosZaloLogin($input: AuthServiceKratosZaloLoginGqlInput!) {
        authServiceKratosZaloLogin(input: $input) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                phoneNumber
                avatarUrl
                birthDate
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function vC(e) {
  const t = { ...Sp, ...e };
  return n.useMutation(
    mp,
    t
  );
}
const vp = {}, gp = i`
    mutation AuthServiceKratosImpersonateZaloUser($input: AuthServiceImpersonateUserGqlInput!) {
        authServiceKratosImpersonateZaloUser(input: $input) {
            accessToken
            accessTokenExpiry
            refreshToken
            refreshTokenExpiry
            user {
                id
                email
                firstName
                lastName
                phoneNumber
                avatarUrl
                birthDate
                status
                type
                organizationId
                tenantId
                zaloId
                createdAt
                updatedAt
            }
        }
    }
`;
function gC(e) {
  const t = { ...vp, ...e };
  return n.useMutation(gp, t);
}
const ue = {}, ce = i`
    query AuthServiceKratosMe {
        authServiceKratosMe {
            id
            avatarUrl
            createdAt
            email
            firstName
            lastName
            phoneNumber
            status
            tenantId
            type
            updatedAt
            zaloId
        }
    }
`;
function fC(e) {
  const t = { ...ue, ...e };
  return n.useQuery(
    ce,
    t
  );
}
function AC(e) {
  const t = { ...ue, ...e };
  return n.useLazyQuery(
    ce,
    t
  );
}
function IC(e) {
  const t = e === n.skipToken ? e : { ...ue, ...e };
  return n.useSuspenseQuery(
    ce,
    t
  );
}
const fp = {}, Ap = i`
    mutation AuthServiceKratosRefreshToken($input: AuthServiceKratosRefreshTokenGqlInput!) {
        authServiceKratosRefreshToken(input: $input) {
            accessToken
            refreshToken
        }
    }
`;
function $C(e) {
  const t = { ...fp, ...e };
  return n.useMutation(
    Ap,
    t
  );
}
const de = {}, pe = i`
    query binoAdminServiceAuthoritiesReport($id: ID!) {
        binoAdminServiceAuthoritiesReport(id: $id) {
            id
            createdAt
            updatedAt
            submitterId
            postId
            authorId
            incidentTime
            incidentLocation
            violationTypeRef {
                id
                code
                name
            }
            severityLevel
            incidentDescription
            violatorName
            violatorIdCard
            violatorAddress
            supportingDocs
            evidenceDescription
            urgencyLevel
            proposedAction
            status
            statusHistory {
                status
                changedAt
                changedBy
                changedByName
                note
            }
            isDeleted
        }
    }
`;
function QC(e) {
  const t = { ...de, ...e };
  return n.useQuery(
    pe,
    t
  );
}
function CC(e) {
  const t = { ...de, ...e };
  return n.useLazyQuery(
    pe,
    t
  );
}
function hC(e) {
  const t = e === n.skipToken ? e : { ...de, ...e };
  return n.useSuspenseQuery(pe, t);
}
const le = {}, ye = i`
    query binoAdminServiceAuthoritiesReports($params: BinoAdminServiceAuthoritiesReportListParamsGqlInput) {
        binoAdminServiceAuthoritiesReports(params: $params) {
            authoritiesReports {
                id
                createdAt
                updatedAt
                submitterId
                postId
                authorId
                incidentTime
                incidentLocation
                violationTypeRef {
                    id
                    code
                    name
                }
                severityLevel
                incidentDescription
                violatorName
                violatorIdCard
                violatorAddress
                supportingDocs
                evidenceDescription
                urgencyLevel
                proposedAction
                status
                statusHistory {
                    status
                    changedAt
                    changedBy
                    changedByName
                    note
                }
                isDeleted
            }
            total
            page
            limit
        }
    }
`;
function kC(e) {
  const t = { ...le, ...e };
  return n.useQuery(
    ye,
    t
  );
}
function DC(e) {
  const t = { ...le, ...e };
  return n.useLazyQuery(ye, t);
}
function PC(e) {
  const t = e === n.skipToken ? e : { ...le, ...e };
  return n.useSuspenseQuery(ye, t);
}
const Se = {}, me = i`
    query binoAdminServicePost($id: ID!) {
        binoAdminServicePost(id: $id) {
            id
            userId
            isAnonymous
            title
            description
            status
            category
            videoUrls
            audioUrls
            imageUrls
            lat
            long
            address
            isDeleted
            createdAt
            updatedAt
        }
    }
`;
function TC(e) {
  const t = { ...Se, ...e };
  return n.useQuery(
    me,
    t
  );
}
function MC(e) {
  const t = { ...Se, ...e };
  return n.useLazyQuery(
    me,
    t
  );
}
function bC(e) {
  const t = e === n.skipToken ? e : { ...Se, ...e };
  return n.useSuspenseQuery(
    me,
    t
  );
}
const Ip = {}, $p = i`
    mutation binoAdminServiceCreateAuthoritiesReport($input: BinoAdminServiceCreateAuthoritiesReportGqlInput!) {
        binoAdminServiceCreateAuthoritiesReport(input: $input) {
            id
            createdAt
            updatedAt
            submitterId
            postId
            authorId
            incidentTime
            incidentLocation
            violationTypeRef {
                id
                code
                name
            }
            severityLevel
            incidentDescription
            violatorName
            violatorIdCard
            violatorAddress
            supportingDocs
            evidenceDescription
            urgencyLevel
            proposedAction
            status
            statusHistory {
                status
                changedAt
                changedBy
                changedByName
                note
            }
            isDeleted
        }
    }
`;
function LC(e) {
  const t = { ...Ip, ...e };
  return n.useMutation($p, t);
}
const Qp = {}, Cp = i`
    mutation binoAdminServiceUpdateAuthoritiesReportStatus(
        $id: ID!
        $input: BinoAdminServiceUpdateAuthoritiesReportStatusGqlInput!
    ) {
        binoAdminServiceUpdateAuthoritiesReportStatus(id: $id, input: $input) {
            id
            createdAt
            updatedAt
            submitterId
            postId
            authorId
            incidentTime
            incidentLocation
            violationTypeRef {
                id
                code
                name
            }
            severityLevel
            incidentDescription
            violatorName
            violatorIdCard
            violatorAddress
            supportingDocs
            evidenceDescription
            urgencyLevel
            proposedAction
            status
            statusHistory {
                status
                changedAt
                changedBy
                changedByName
                note
            }
            isDeleted
        }
    }
`;
function BC(e) {
  const t = { ...Qp, ...e };
  return n.useMutation(Cp, t);
}
const hp = {}, kp = i`
    mutation BookingServiceAcceptBookings($ids: [String!]!) {
        bookingServiceAcceptBookings(ids: $ids)
    }
`;
function UC(e) {
  const t = { ...hp, ...e };
  return n.useMutation(
    kp,
    t
  );
}
const ve = {}, ge = i`
    query BookingServiceAllBookings($pagination: PaginationArgs!) {
        bookingServiceAllBookings(pagination: $pagination) {
            total
            data {
                id
                branchId
                userId
                tenantId
                reserveName
                contactPhone
                reserveDate
                reserveTime
                numOfAdults
                numOfChildren
                slotId
                hasPayment
                productSuggestions
                status
                note
                isDeleted
                orderId
                employeeIds
                metadata
                deletedAt
                deletedBy
                requests {
                    question
                    answer
                }
                products {
                    productId
                    quantity
                    sku
                }
                createdAt
                updatedAt
            }
        }
    }
`;
function zC(e) {
  const t = { ...ve, ...e };
  return n.useQuery(
    ge,
    t
  );
}
function FC(e) {
  const t = { ...ve, ...e };
  return n.useLazyQuery(
    ge,
    t
  );
}
function RC(e) {
  const t = e === n.skipToken ? e : { ...ve, ...e };
  return n.useSuspenseQuery(
    ge,
    t
  );
}
const fe = {}, Ae = i`
    query BookingServiceAllSlots($branchId: String!, $pagination: PaginationArgs!) {
        bookingServiceAllSlots(branchId: $branchId, pagination: $pagination) {
            id
            branchId
            tenantId
            name
            description
            isEnabled
            isDeleted
            bookingMode
            schedule {
                recurrenceType
                startDate
                endDate
                daysOfWeek
                daysOfMonth
                monthsOfYear
                customDates
                shifts {
                    startTime
                    endTime
                }
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function GC(e) {
  const t = { ...fe, ...e };
  return n.useQuery(
    Ae,
    t
  );
}
function qC(e) {
  const t = { ...fe, ...e };
  return n.useLazyQuery(
    Ae,
    t
  );
}
function EC(e) {
  const t = e === n.skipToken ? e : { ...fe, ...e };
  return n.useSuspenseQuery(
    Ae,
    t
  );
}
const Ie = {}, $e = i`
    query BookingServiceAvailableDays($input: BookingServiceAvailableDaysGqlInput!) {
        bookingServiceAvailableDays(input: $input) {
            date
        }
    }
`;
function VC(e) {
  const t = { ...Ie, ...e };
  return n.useQuery(
    $e,
    t
  );
}
function OC(e) {
  const t = { ...Ie, ...e };
  return n.useLazyQuery(
    $e,
    t
  );
}
function xC(e) {
  const t = e === n.skipToken ? e : { ...Ie, ...e };
  return n.useSuspenseQuery(
    $e,
    t
  );
}
const Qe = {}, Ce = i`
    query BookingServiceAvailableMonths($input: BookingServiceAvailableMonthsGqlInput!) {
        bookingServiceAvailableMonths(input: $input) {
            month
            monthName
        }
    }
`;
function wC(e) {
  const t = { ...Qe, ...e };
  return n.useQuery(
    Ce,
    t
  );
}
function HC(e) {
  const t = { ...Qe, ...e };
  return n.useLazyQuery(
    Ce,
    t
  );
}
function NC(e) {
  const t = e === n.skipToken ? e : { ...Qe, ...e };
  return n.useSuspenseQuery(
    Ce,
    t
  );
}
const he = {}, ke = i`
    query BookingServiceAvailableTimes($input: BookingServiceAvailableTimesGqlInput!) {
        bookingServiceAvailableTimes(input: $input) {
            shift {
                startTime
                endTime
            }
        }
    }
`;
function WC(e) {
  const t = { ...he, ...e };
  return n.useQuery(
    ke,
    t
  );
}
function jC(e) {
  const t = { ...he, ...e };
  return n.useLazyQuery(
    ke,
    t
  );
}
function KC(e) {
  const t = e === n.skipToken ? e : { ...he, ...e };
  return n.useSuspenseQuery(
    ke,
    t
  );
}
const De = {}, Pe = i`
    query BookingServiceBookingsById($id: String!) {
        bookingServiceBookingsById(id: $id) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            imageUrls
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function ZC(e) {
  const t = { ...De, ...e };
  return n.useQuery(
    Pe,
    t
  );
}
function YC(e) {
  const t = { ...De, ...e };
  return n.useLazyQuery(
    Pe,
    t
  );
}
function JC(e) {
  const t = e === n.skipToken ? e : { ...De, ...e };
  return n.useSuspenseQuery(
    Pe,
    t
  );
}
const Dp = {}, Pp = i`
    mutation BookingServiceCancelBookings($ids: [String!]!) {
        bookingServiceCancelBookings(ids: $ids)
    }
`;
function _C(e) {
  const t = { ...Dp, ...e };
  return n.useMutation(
    Pp,
    t
  );
}
const Tp = {}, Mp = i`
    mutation BookingServiceCreateBooking($input: BookingServiceBookingGqlInput!) {
        bookingServiceCreateBooking(input: $input) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            orderId
            employeeIds
            imageUrls
            metadata
            deletedAt
            deletedBy
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function XC(e) {
  const t = { ...Tp, ...e };
  return n.useMutation(
    Mp,
    t
  );
}
const bp = {}, Lp = i`
    mutation BookingServiceCreateSlot($branchId: String!, $input: BookingServiceSlotGqlInput!) {
        bookingServiceCreateSlot(branchId: $branchId, input: $input)
    }
`;
function eh(e) {
  const t = { ...bp, ...e };
  return n.useMutation(
    Lp,
    t
  );
}
const Bp = {}, Up = i`
    mutation BookingServiceDeleteBookings($ids: [String!]!) {
        bookingServiceDeleteBookings(ids: $ids)
    }
`;
function th(e) {
  const t = { ...Bp, ...e };
  return n.useMutation(
    Up,
    t
  );
}
const zp = {}, Fp = i`
    mutation BookingServiceDeleteSlots($branchId: String!, $ids: [String!]!) {
        bookingServiceDeleteSlots(branchId: $branchId, ids: $ids)
    }
`;
function nh(e) {
  const t = { ...zp, ...e };
  return n.useMutation(
    Fp,
    t
  );
}
const Rp = {}, Gp = i`
    mutation BookingServiceDisableSlots($branchId: String!, $ids: [String!]!) {
        bookingServiceDisableSlots(branchId: $branchId, ids: $ids)
    }
`;
function ih(e) {
  const t = { ...Rp, ...e };
  return n.useMutation(
    Gp,
    t
  );
}
const Te = {}, Me = i`
    query BookingServiceDisabledSlots($branchId: String!, $pagination: PaginationArgs!) {
        bookingServiceDisabledSlots(branchId: $branchId, pagination: $pagination) {
            id
            branchId
            tenantId
            name
            description
            isEnabled
            isDeleted
            bookingMode
            schedule {
                recurrenceType
                startDate
                endDate
                daysOfWeek
                daysOfMonth
                monthsOfYear
                customDates
                shifts {
                    startTime
                    endTime
                }
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function rh(e) {
  const t = { ...Te, ...e };
  return n.useQuery(
    Me,
    t
  );
}
function sh(e) {
  const t = { ...Te, ...e };
  return n.useLazyQuery(
    Me,
    t
  );
}
function oh(e) {
  const t = e === n.skipToken ? e : { ...Te, ...e };
  return n.useSuspenseQuery(
    Me,
    t
  );
}
const qp = {}, Ep = i`
    mutation BookingServiceEnableSlots($branchId: String!, $ids: [String!]!) {
        bookingServiceEnableSlots(branchId: $branchId, ids: $ids)
    }
`;
function ah(e) {
  const t = { ...qp, ...e };
  return n.useMutation(
    Ep,
    t
  );
}
const be = {}, Le = i`
    query BookingServiceEnabledSlots($branchId: String!, $pagination: PaginationArgs!) {
        bookingServiceEnabledSlots(branchId: $branchId, pagination: $pagination) {
            id
            branchId
            tenantId
            name
            description
            isEnabled
            isDeleted
            bookingMode
            schedule {
                recurrenceType
                startDate
                endDate
                daysOfWeek
                daysOfMonth
                monthsOfYear
                customDates
                shifts {
                    startTime
                    endTime
                }
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function uh(e) {
  const t = { ...be, ...e };
  return n.useQuery(
    Le,
    t
  );
}
function ch(e) {
  const t = { ...be, ...e };
  return n.useLazyQuery(
    Le,
    t
  );
}
function dh(e) {
  const t = e === n.skipToken ? e : { ...be, ...e };
  return n.useSuspenseQuery(
    Le,
    t
  );
}
const Be = {}, Ue = i`
    query BookingServiceEndedBookings($pagination: PaginationArgs!) {
        bookingServiceEndedBookings(pagination: $pagination) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            imageUrls
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function ph(e) {
  const t = { ...Be, ...e };
  return n.useQuery(
    Ue,
    t
  );
}
function lh(e) {
  const t = { ...Be, ...e };
  return n.useLazyQuery(
    Ue,
    t
  );
}
function yh(e) {
  const t = e === n.skipToken ? e : { ...Be, ...e };
  return n.useSuspenseQuery(
    Ue,
    t
  );
}
const ze = {}, Fe = i`
    query BookingServiceIncomingBookings($pagination: PaginationArgs!) {
        bookingServiceIncomingBookings(pagination: $pagination) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            imageUrls
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function Sh(e) {
  const t = { ...ze, ...e };
  return n.useQuery(
    Fe,
    t
  );
}
function mh(e) {
  const t = { ...ze, ...e };
  return n.useLazyQuery(
    Fe,
    t
  );
}
function vh(e) {
  const t = e === n.skipToken ? e : { ...ze, ...e };
  return n.useSuspenseQuery(
    Fe,
    t
  );
}
const Re = {}, Ge = i`
    query BookingServiceMyBookings($filter: BookingServiceMyBookingsFilterGqlInput, $pagination: PaginationArgs!) {
        bookingServiceMyBookings(filter: $filter, pagination: $pagination) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            imageUrls
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function gh(e) {
  const t = { ...Re, ...e };
  return n.useQuery(
    Ge,
    t
  );
}
function fh(e) {
  const t = { ...Re, ...e };
  return n.useLazyQuery(
    Ge,
    t
  );
}
function Ah(e) {
  const t = e === n.skipToken ? e : { ...Re, ...e };
  return n.useSuspenseQuery(
    Ge,
    t
  );
}
const qe = {}, Ee = i`
    query BookingServiceOngoingBookings($pagination: PaginationArgs!) {
        bookingServiceOngoingBookings(pagination: $pagination) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            imageUrls
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function Ih(e) {
  const t = { ...qe, ...e };
  return n.useQuery(
    Ee,
    t
  );
}
function $h(e) {
  const t = { ...qe, ...e };
  return n.useLazyQuery(
    Ee,
    t
  );
}
function Qh(e) {
  const t = e === n.skipToken ? e : { ...qe, ...e };
  return n.useSuspenseQuery(
    Ee,
    t
  );
}
const Ve = {}, Oe = i`
    query BookingServicePendingBookings($pagination: PaginationArgs!) {
        bookingServicePendingBookings(pagination: $pagination) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            imageUrls
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function Ch(e) {
  const t = { ...Ve, ...e };
  return n.useQuery(
    Oe,
    t
  );
}
function hh(e) {
  const t = { ...Ve, ...e };
  return n.useLazyQuery(
    Oe,
    t
  );
}
function kh(e) {
  const t = e === n.skipToken ? e : { ...Ve, ...e };
  return n.useSuspenseQuery(
    Oe,
    t
  );
}
const xe = {}, we = i`
    query BookingServicePublicSlots($branchId: String!, $pagination: PaginationArgs!) {
        bookingServicePublicSlots(branchId: $branchId, pagination: $pagination) {
            id
            branchId
            tenantId
            name
            description
            isEnabled
            isDeleted
            bookingMode
            schedule {
                recurrenceType
                startDate
                endDate
                daysOfWeek
                daysOfMonth
                monthsOfYear
                customDates
                shifts {
                    startTime
                    endTime
                }
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function Dh(e) {
  const t = { ...xe, ...e };
  return n.useQuery(
    we,
    t
  );
}
function Ph(e) {
  const t = { ...xe, ...e };
  return n.useLazyQuery(
    we,
    t
  );
}
function Th(e) {
  const t = e === n.skipToken ? e : { ...xe, ...e };
  return n.useSuspenseQuery(
    we,
    t
  );
}
const He = {}, Ne = i`
    query BookingServiceSlotById($branchId: String!, $id: String!) {
        bookingServiceSlotById(branchId: $branchId, id: $id) {
            id
            branchId
            tenantId
            name
            description
            isEnabled
            isDeleted
            bookingMode
            schedule {
                recurrenceType
                startDate
                endDate
                daysOfWeek
                daysOfMonth
                monthsOfYear
                customDates
                shifts {
                    startTime
                    endTime
                }
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function Mh(e) {
  const t = { ...He, ...e };
  return n.useQuery(
    Ne,
    t
  );
}
function bh(e) {
  const t = { ...He, ...e };
  return n.useLazyQuery(
    Ne,
    t
  );
}
function Lh(e) {
  const t = e === n.skipToken ? e : { ...He, ...e };
  return n.useSuspenseQuery(
    Ne,
    t
  );
}
const Vp = {}, Op = i`
    mutation BookingServiceUpdateBooking($id: String!, $input: BookingServiceBookingGqlInput!) {
        bookingServiceUpdateBooking(id: $id, input: $input) {
            id
            branchId
            userId
            tenantId
            reserveName
            contactPhone
            reserveDate
            reserveTime
            numOfAdults
            numOfChildren
            slotId
            hasPayment
            productSuggestions
            status
            note
            isDeleted
            orderId
            employeeIds
            imageUrls
            metadata
            deletedAt
            deletedBy
            requests {
                question
                answer
            }
            products {
                productId
                quantity
                sku
            }
            createdAt
            updatedAt
        }
    }
`;
function Bh(e) {
  const t = { ...Vp, ...e };
  return n.useMutation(
    Op,
    t
  );
}
const xp = {}, wp = i`
    mutation BookingServiceUpdateSlot($branchId: String!, $id: String!, $input: BookingServiceSlotGqlInput!) {
        bookingServiceUpdateSlot(branchId: $branchId, id: $id, input: $input)
    }
`;
function Uh(e) {
  const t = { ...xp, ...e };
  return n.useMutation(
    wp,
    t
  );
}
const zh = {
  Branch: "Branch",
  Slot: "Slot"
}, Fh = {
  Accepted: "Accepted",
  Cancelled: "Cancelled",
  Pending: "Pending"
}, Rh = {
  Cancelled: "Cancelled",
  Completed: "Completed",
  Confirmed: "Confirmed",
  Draft: "Draft",
  New: "New",
  PaymentPartiallyReceived: "PaymentPartiallyReceived",
  PaymentReceived: "PaymentReceived",
  Pending: "Pending",
  PendingPayment: "PendingPayment",
  Shipping: "Shipping"
}, Gh = {
  Product: "Product",
  Service: "Service"
}, qh = {
  Bogo: "Bogo",
  FixedAmount: "FixedAmount",
  FreeItem: "FreeItem",
  FreeShipping: "FreeShipping",
  Percentage: "Percentage"
}, Hp = {}, Np = i`
    mutation BusinessConfigServiceActivateBusinessConfig($id: ID!) {
        businessConfigServiceActivateBusinessConfig(id: $id) {
            id
            key
            name
            value
            valueType
            scope
            scopeValue
            category
            description
            status
            priority
            tags
            version
            isDeleted
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;
function Eh(e) {
  const t = { ...Hp, ...e };
  return n.useMutation(Np, t);
}
const We = {}, je = i`
    query BusinessConfigServiceAvailableConfigCategories {
        businessConfigServiceAvailableConfigCategories {
            category
            description
        }
    }
`;
function Vh(e) {
  const t = { ...We, ...e };
  return n.useQuery(je, t);
}
function Oh(e) {
  const t = { ...We, ...e };
  return n.useLazyQuery(je, t);
}
function xh(e) {
  const t = e === n.skipToken ? e : { ...We, ...e };
  return n.useSuspenseQuery(je, t);
}
const Ke = {}, Ze = i`
    query BusinessConfigServiceAvailableConfigKeys {
        businessConfigServiceAvailableConfigKeys {
            category
            key
            description
        }
    }
`;
function wh(e) {
  const t = { ...Ke, ...e };
  return n.useQuery(Ze, t);
}
function Hh(e) {
  const t = { ...Ke, ...e };
  return n.useLazyQuery(Ze, t);
}
function Nh(e) {
  const t = e === n.skipToken ? e : { ...Ke, ...e };
  return n.useSuspenseQuery(Ze, t);
}
const Wp = {}, jp = i`
    mutation BusinessConfigServiceBulkCreateBusinessConfigs($inputs: [BusinessConfigServiceBusinessConfigGqlInput!]!) {
        businessConfigServiceBulkCreateBusinessConfigs(inputs: $inputs) {
            id
            key
            name
            value
            valueType
            scope
            scopeValue
            category
            description
            status
            priority
            tags
            version
            isDeleted
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;
function Wh(e) {
  const t = { ...Wp, ...e };
  return n.useMutation(jp, t);
}
const Ye = {}, Je = i`
    query BusinessConfigServiceBusinessConfig($id: ID!) {
        businessConfigServiceBusinessConfig(id: $id) {
            id
            key
            name
            value
            valueType
            scope
            scopeValue
            category
            description
            status
            priority
            tags
            version
            isDeleted
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;
function jh(e) {
  const t = { ...Ye, ...e };
  return n.useQuery(
    Je,
    t
  );
}
function Kh(e) {
  const t = { ...Ye, ...e };
  return n.useLazyQuery(Je, t);
}
function Zh(e) {
  const t = e === n.skipToken ? e : { ...Ye, ...e };
  return n.useSuspenseQuery(Je, t);
}
const _e = {}, Xe = i`
    query BusinessConfigServiceBusinessConfigByKey(
        $key: String!
        $scope: BusinessConfigServiceConfigScope
        $scopeValue: String
    ) {
        businessConfigServiceBusinessConfigByKey(key: $key, scope: $scope, scopeValue: $scopeValue) {
            id
            key
            name
            value
            valueType
            scope
            scopeValue
            category
            description
            status
            priority
            tags
            version
            isDeleted
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;
function Yh(e) {
  const t = { ..._e, ...e };
  return n.useQuery(Xe, t);
}
function Jh(e) {
  const t = { ..._e, ...e };
  return n.useLazyQuery(Xe, t);
}
function _h(e) {
  const t = e === n.skipToken ? e : { ..._e, ...e };
  return n.useSuspenseQuery(Xe, t);
}
const et = {}, tt = i`
    query BusinessConfigServiceBusinessConfigs($params: BusinessConfigServiceBusinessConfigListParamsGqlInput) {
        businessConfigServiceBusinessConfigs(params: $params) {
            configs {
                id
                key
                name
                value
                valueType
                scope
                scopeValue
                category
                description
                status
                priority
                tags
                version
                isDeleted
                createdAt
                createdBy
                updatedAt
                updatedBy
            }
            total
            hasMore
        }
    }
`;
function Xh(e) {
  const t = { ...et, ...e };
  return n.useQuery(tt, t);
}
function ek(e) {
  const t = { ...et, ...e };
  return n.useLazyQuery(tt, t);
}
function tk(e) {
  const t = e === n.skipToken ? e : { ...et, ...e };
  return n.useSuspenseQuery(tt, t);
}
const nt = {}, it = i`
    query BusinessConfigServiceConfigHistory($configId: ID!) {
        businessConfigServiceConfigHistory(configId: $configId) {
            id
            configId
            configKey
            action
            changedBy
            changedAt
            oldValue
            newValue
            changeReason
            tenantId
        }
    }
`;
function nk(e) {
  const t = { ...nt, ...e };
  return n.useQuery(
    it,
    t
  );
}
function ik(e) {
  const t = { ...nt, ...e };
  return n.useLazyQuery(it, t);
}
function rk(e) {
  const t = e === n.skipToken ? e : { ...nt, ...e };
  return n.useSuspenseQuery(it, t);
}
const Kp = {}, Zp = i`
    mutation BusinessConfigServiceCreateBusinessConfig($input: BusinessConfigServiceBusinessConfigGqlInput!) {
        businessConfigServiceCreateBusinessConfig(input: $input) {
            id
            key
            name
            value
            valueType
            scope
            scopeValue
            category
            description
            status
            priority
            tags
            version
            isDeleted
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;
function sk(e) {
  const t = { ...Kp, ...e };
  return n.useMutation(Zp, t);
}
const Yp = {}, Jp = i`
    mutation BusinessConfigServiceDeactivateBusinessConfig($id: ID!) {
        businessConfigServiceDeactivateBusinessConfig(id: $id) {
            id
            key
            name
            value
            valueType
            scope
            scopeValue
            category
            description
            status
            priority
            tags
            version
            isDeleted
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;
function ok(e) {
  const t = { ...Yp, ...e };
  return n.useMutation(Jp, t);
}
const _p = {}, Xp = i`
    mutation BusinessConfigServiceDeleteBusinessConfig($id: ID!) {
        businessConfigServiceDeleteBusinessConfig(id: $id)
    }
`;
function ak(e) {
  const t = { ..._p, ...e };
  return n.useMutation(Xp, t);
}
const el = {}, tl = i`
    mutation BusinessConfigServiceUpdateBusinessConfig(
        $id: ID!
        $input: BusinessConfigServiceUpdateBusinessConfigGqlInput!
    ) {
        businessConfigServiceUpdateBusinessConfig(id: $id, input: $input) {
            id
            key
            name
            value
            valueType
            scope
            scopeValue
            category
            description
            status
            priority
            tags
            version
            isDeleted
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;
function uk(e) {
  const t = { ...el, ...e };
  return n.useMutation(tl, t);
}
const rt = {}, st = i`
    query CacheServiceGetCache($input: CacheServiceGetCacheGqlInput!) {
        cacheServiceGetCache(input: $input) {
            key
            value
            found
            backend
            metadata {
                service
                tenantId
                userId
                environment
                requestId
                tags
                isCompress
            }
        }
    }
`;
function ck(e) {
  const t = { ...rt, ...e };
  return n.useQuery(
    st,
    t
  );
}
function dk(e) {
  const t = { ...rt, ...e };
  return n.useLazyQuery(
    st,
    t
  );
}
function pk(e) {
  const t = e === n.skipToken ? e : { ...rt, ...e };
  return n.useSuspenseQuery(
    st,
    t
  );
}
const ot = {}, at = i`
    query CacheServiceGetCacheStats {
        cacheServiceGetCacheStats {
            backend
            hitCount
            missCount
            latencyMs
        }
    }
`;
function lk(e) {
  const t = { ...ot, ...e };
  return n.useQuery(
    at,
    t
  );
}
function yk(e) {
  const t = { ...ot, ...e };
  return n.useLazyQuery(
    at,
    t
  );
}
function Sk(e) {
  const t = e === n.skipToken ? e : { ...ot, ...e };
  return n.useSuspenseQuery(
    at,
    t
  );
}
const nl = {}, il = i`
    mutation CacheServiceInvalidateCache($input: CacheServiceInvalidateCacheGqlInput!) {
        cacheServiceInvalidateCache(input: $input) {
            success
            message
        }
    }
`;
function mk(e) {
  const t = { ...nl, ...e };
  return n.useMutation(
    il,
    t
  );
}
const ut = {}, ct = i`
    query CampaignServiceAllCampaignTriggers($pagination: PaginationArgs!) {
        campaignServiceAllCampaignTriggers(pagination: $pagination) {
            data {
                action {
                    actions {
                        type
                        value
                        voucherTypeId
                    }
                    type
                    value
                    voucherTypeId
                }
                campaignId
                conditions {
                    categoryIds
                    pointsThreshold
                    productIds
                    purchaseAmount
                }
                createdAt
                eventType
                id
                sourceService
                tenantId
                updatedAt
            }
            total
        }
    }
`;
function vk(e) {
  const t = { ...ut, ...e };
  return n.useQuery(
    ct,
    t
  );
}
function gk(e) {
  const t = { ...ut, ...e };
  return n.useLazyQuery(ct, t);
}
function fk(e) {
  const t = e === n.skipToken ? e : { ...ut, ...e };
  return n.useSuspenseQuery(ct, t);
}
const dt = {}, pt = i`
    query CampaignServiceAllCampaigns($pagination: PaginationArgs!) {
        campaignServiceAllCampaigns(pagination: $pagination) {
            data {
                bannerUrl
                benefitConfig {
                    discountType
                    discountValue
                    pointsMultiplier
                    pointsToEarn
                    tierUpgrade
                    voucherTypeId
                }
                campaignType
                createdAt
                currentParticipants
                description
                eligibilityRules {
                    excludedProducts
                    firstPurchaseOnly
                    membershipTiers
                    minimumSpend
                    productCategories
                }
                endDate
                id
                isDeleted
                isEnabled
                isRecurring
                isStackable
                locations
                name
                priority
                recurringPattern
                startDate
                status
                targetAudience
                targetParticipants
                tenantId
                triggerType
                updatedAt
                usageLimitPerUser
                voucherLimit
                vouchersIssued
            }
            total
        }
    }
`;
function Ak(e) {
  const t = { ...dt, ...e };
  return n.useQuery(
    pt,
    t
  );
}
function Ik(e) {
  const t = { ...dt, ...e };
  return n.useLazyQuery(
    pt,
    t
  );
}
function $k(e) {
  const t = e === n.skipToken ? e : { ...dt, ...e };
  return n.useSuspenseQuery(
    pt,
    t
  );
}
const lt = {}, yt = i`
    query CampaignServiceCampaignById($id: String!) {
        campaignServiceCampaignById(id: $id) {
            bannerUrl
            benefitConfig {
                discountType
                discountValue
                pointsMultiplier
                pointsToEarn
                tierUpgrade
                voucherTypeId
            }
            campaignType
            createdAt
            currentParticipants
            description
            eligibilityRules {
                excludedProducts
                firstPurchaseOnly
                membershipTiers
                minimumSpend
                productCategories
            }
            endDate
            id
            isDeleted
            isEnabled
            isRecurring
            isStackable
            locations
            name
            priority
            recurringPattern
            startDate
            status
            targetAudience
            targetParticipants
            tenantId
            triggerType
            updatedAt
            usageLimitPerUser
            voucherLimit
            vouchersIssued
        }
    }
`;
function Qk(e) {
  const t = { ...lt, ...e };
  return n.useQuery(
    yt,
    t
  );
}
function Ck(e) {
  const t = { ...lt, ...e };
  return n.useLazyQuery(
    yt,
    t
  );
}
function hk(e) {
  const t = e === n.skipToken ? e : { ...lt, ...e };
  return n.useSuspenseQuery(
    yt,
    t
  );
}
const St = {}, mt = i`
    query CampaignServiceCampaignTriggerById($id: String!) {
        campaignServiceCampaignTriggerById(id: $id) {
            id
            action {
                actions {
                    type
                    value
                    voucherTypeId
                }
                type
                value
                voucherTypeId
            }
            campaignId
            conditions {
                categoryIds
                pointsThreshold
                productIds
                purchaseAmount
            }
            createdAt
            eventType
            sourceService
            tenantId
            updatedAt
        }
    }
`;
function kk(e) {
  const t = { ...St, ...e };
  return n.useQuery(
    mt,
    t
  );
}
function Dk(e) {
  const t = { ...St, ...e };
  return n.useLazyQuery(mt, t);
}
function Pk(e) {
  const t = e === n.skipToken ? e : { ...St, ...e };
  return n.useSuspenseQuery(mt, t);
}
const vt = {}, gt = i`
    query CampaignServiceCampaignsByIds($ids: [String!]!) {
        campaignServiceCampaignsByIds(ids: $ids) {
            id
            bannerUrl
            benefitConfig {
                discountType
                discountValue
                pointsMultiplier
                pointsToEarn
                tierUpgrade
                voucherTypeId
            }
            campaignType
            createdAt
            currentParticipants
            description
            eligibilityRules {
                excludedProducts
                firstPurchaseOnly
                membershipTiers
                minimumSpend
                productCategories
            }
            endDate
            isDeleted
            isEnabled
            isRecurring
            isStackable
            locations
            name
            priority
            recurringPattern
            startDate
            status
            targetAudience
            targetParticipants
            tenantId
            updatedAt
            usageLimitPerUser
            voucherLimit
            vouchersIssued
        }
    }
`;
function Tk(e) {
  const t = { ...vt, ...e };
  return n.useQuery(
    gt,
    t
  );
}
function Mk(e) {
  const t = { ...vt, ...e };
  return n.useLazyQuery(
    gt,
    t
  );
}
function bk(e) {
  const t = e === n.skipToken ? e : { ...vt, ...e };
  return n.useSuspenseQuery(
    gt,
    t
  );
}
const rl = {}, sl = i`
    mutation CampaignServiceCreateCampaign($input: CampaignServiceCreateCampaignGqlInput!) {
        campaignServiceCreateCampaign(input: $input)
    }
`;
function Lk(e) {
  const t = { ...rl, ...e };
  return n.useMutation(
    sl,
    t
  );
}
const ol = {}, al = i`
    mutation CampaignServiceCreateCampaignTrigger($input: CampaignServiceCampaignTriggerGqlInput!) {
        campaignServiceCreateCampaignTrigger(input: $input)
    }
`;
function Bk(e) {
  const t = { ...ol, ...e };
  return n.useMutation(al, t);
}
const ul = {}, cl = i`
    mutation CampaignServiceDeleteCampaign($id: String!) {
        campaignServiceDeleteCampaign(id: $id)
    }
`;
function Uk(e) {
  const t = { ...ul, ...e };
  return n.useMutation(
    cl,
    t
  );
}
const dl = {}, pl = i`
    mutation CampaignServiceDeleteCampaignTrigger($id: String!) {
        campaignServiceDeleteCampaignTrigger(id: $id)
    }
`;
function zk(e) {
  const t = { ...dl, ...e };
  return n.useMutation(pl, t);
}
const ll = {}, yl = i`
    mutation CampaignServiceDisableCampaign($id: String!) {
        campaignServiceDisableCampaign(id: $id)
    }
`;
function Fk(e) {
  const t = { ...ll, ...e };
  return n.useMutation(
    yl,
    t
  );
}
const Sl = {}, ml = i`
    mutation CampaignServiceDisableCampaignTrigger($id: String!) {
        campaignServiceDisableCampaignTrigger(id: $id)
    }
`;
function Rk(e) {
  const t = { ...Sl, ...e };
  return n.useMutation(ml, t);
}
const ft = {}, At = i`
    query CampaignServiceDisabledCampaigns($pagination: PaginationArgs!) {
        campaignServiceDisabledCampaigns(pagination: $pagination) {
            id
            bannerUrl
            benefitConfig {
                discountType
                discountValue
                pointsMultiplier
                pointsToEarn
                tierUpgrade
                voucherTypeId
            }
            campaignType
            createdAt
            currentParticipants
            description
            eligibilityRules {
                excludedProducts
                firstPurchaseOnly
                membershipTiers
                minimumSpend
                productCategories
            }
            endDate
            isDeleted
            isEnabled
            isRecurring
            isStackable
            locations
            name
            priority
            recurringPattern
            startDate
            status
            targetAudience
            targetParticipants
            tenantId
            updatedAt
            usageLimitPerUser
            voucherLimit
            vouchersIssued
        }
    }
`;
function Gk(e) {
  const t = { ...ft, ...e };
  return n.useQuery(
    At,
    t
  );
}
function qk(e) {
  const t = { ...ft, ...e };
  return n.useLazyQuery(
    At,
    t
  );
}
function Ek(e) {
  const t = e === n.skipToken ? e : { ...ft, ...e };
  return n.useSuspenseQuery(At, t);
}
const vl = {}, gl = i`
    mutation CampaignServiceEnableCampaign($id: String!) {
        campaignServiceEnableCampaign(id: $id)
    }
`;
function Vk(e) {
  const t = { ...vl, ...e };
  return n.useMutation(
    gl,
    t
  );
}
const fl = {}, Al = i`
    mutation CampaignServiceEnableCampaignTrigger($id: String!) {
        campaignServiceEnableCampaignTrigger(id: $id)
    }
`;
function Ok(e) {
  const t = { ...fl, ...e };
  return n.useMutation(Al, t);
}
const It = {}, $t = i`
    query CampaignServiceEnabledCampaignTriggers($pagination: PaginationArgs!) {
        campaignServiceEnabledCampaignTriggers(pagination: $pagination) {
            id
            action {
                actions {
                    type
                    value
                    voucherTypeId
                }
                type
                value
                voucherTypeId
            }
            campaignId
            conditions {
                categoryIds
                pointsThreshold
                productIds
                purchaseAmount
            }
            createdAt
            eventType
            sourceService
            tenantId
            updatedAt
        }
    }
`;
function xk(e) {
  const t = { ...It, ...e };
  return n.useQuery($t, t);
}
function wk(e) {
  const t = { ...It, ...e };
  return n.useLazyQuery($t, t);
}
function Hk(e) {
  const t = e === n.skipToken ? e : { ...It, ...e };
  return n.useSuspenseQuery($t, t);
}
const Qt = {}, Ct = i`
    query CampaignServiceEnabledCampaigns($pagination: PaginationArgs!) {
        campaignServiceEnabledCampaigns(pagination: $pagination) {
            id
            bannerUrl
            benefitConfig {
                discountType
                discountValue
                pointsMultiplier
                pointsToEarn
                tierUpgrade
                voucherTypeId
            }
            campaignType
            createdAt
            currentParticipants
            description
            eligibilityRules {
                excludedProducts
                firstPurchaseOnly
                membershipTiers
                minimumSpend
                productCategories
            }
            endDate
            isDeleted
            isEnabled
            isRecurring
            isStackable
            locations
            name
            priority
            recurringPattern
            startDate
            status
            targetAudience
            targetParticipants
            tenantId
            updatedAt
            usageLimitPerUser
            voucherLimit
            vouchersIssued
        }
    }
`;
function Nk(e) {
  const t = { ...Qt, ...e };
  return n.useQuery(
    Ct,
    t
  );
}
function Wk(e) {
  const t = { ...Qt, ...e };
  return n.useLazyQuery(
    Ct,
    t
  );
}
function jk(e) {
  const t = e === n.skipToken ? e : { ...Qt, ...e };
  return n.useSuspenseQuery(
    Ct,
    t
  );
}
const ht = {}, kt = i`
    query CampaignServiceSearchCampaigns($input: String!, $pagination: PaginationArgs!) {
        campaignServiceSearchCampaigns(input: $input, pagination: $pagination) {
            id
            bannerUrl
            benefitConfig {
                discountType
                discountValue
                pointsMultiplier
                pointsToEarn
                tierUpgrade
                voucherTypeId
            }
            campaignType
            createdAt
            currentParticipants
            description
            eligibilityRules {
                excludedProducts
                firstPurchaseOnly
                membershipTiers
                minimumSpend
                productCategories
            }
            endDate
            isDeleted
            isEnabled
            isRecurring
            isStackable
            locations
            name
            priority
            recurringPattern
            startDate
            status
            targetAudience
            targetParticipants
            tenantId
            updatedAt
            usageLimitPerUser
            voucherLimit
            vouchersIssued
        }
    }
`;
function Kk(e) {
  const t = { ...ht, ...e };
  return n.useQuery(
    kt,
    t
  );
}
function Zk(e) {
  const t = { ...ht, ...e };
  return n.useLazyQuery(
    kt,
    t
  );
}
function Yk(e) {
  const t = e === n.skipToken ? e : { ...ht, ...e };
  return n.useSuspenseQuery(
    kt,
    t
  );
}
const Il = {}, $l = i`
    mutation CampaignServiceUpdateCampaign($id: String!, $input: CampaignServiceUpdateCampaignGqlInput!) {
        campaignServiceUpdateCampaign(id: $id, input: $input)
    }
`;
function Jk(e) {
  const t = { ...Il, ...e };
  return n.useMutation(
    $l,
    t
  );
}
const Ql = {}, Cl = i`
    mutation CampaignServiceUpdateCampaignTrigger($input: CampaignServiceUpdateCampaignTriggerGqlInput!) {
        campaignServiceUpdateCampaignTrigger(input: $input)
    }
`;
function _k(e) {
  const t = { ...Ql, ...e };
  return n.useMutation(Cl, t);
}
const hl = {}, kl = i`
    mutation CartServiceCreate($input: CartServiceCreateGqlInput!) {
        cartServiceCreate(input: $input) {
            id
            userId
            tenantId
            currency
            totalAmount
            totalAmountFormatted
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                }
            }
            createdAt
            updatedAt
        }
    }
`;
function Xk(e) {
  const t = { ...hl, ...e };
  return n.useMutation(
    kl,
    t
  );
}
const Dl = {}, Pl = i`
    mutation CartServiceDeleteAll {
        cartServiceDeleteAll
    }
`;
function eD(e) {
  const t = { ...Dl, ...e };
  return n.useMutation(
    Pl,
    t
  );
}
const Tl = {}, Ml = i`
    mutation CartServiceDelete($input: CartServiceDeleteGqlInput!) {
        cartServiceDelete(input: $input)
    }
`;
function tD(e) {
  const t = { ...Tl, ...e };
  return n.useMutation(
    Ml,
    t
  );
}
const Dt = {}, Pt = i`
    query CartService($input: CartServiceGetGqlInput!) {
        cartService(input: $input) {
            id
            userId
            tenantId
            currency
            totalAmount
            totalAmountFormatted
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                    mediaUrls
                    attributes {
                        key
                        value
                        colorCode
                        colorName
                    }
                }
            }
            createdAt
            updatedAt
        }
    }
`;
function nD(e) {
  const t = { ...Dt, ...e };
  return n.useQuery(Pt, t);
}
function iD(e) {
  const t = { ...Dt, ...e };
  return n.useLazyQuery(Pt, t);
}
function rD(e) {
  const t = e === n.skipToken ? e : { ...Dt, ...e };
  return n.useSuspenseQuery(Pt, t);
}
const bl = {}, Ll = i`
    mutation CartServiceUpdate($input: CartServiceUpdateGqlInput!) {
        cartServiceUpdate(input: $input) {
            id
            userId
            tenantId
            currency
            totalAmount
            totalAmountFormatted
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                }
            }
            createdAt
            updatedAt
        }
    }
`;
function sD(e) {
  const t = { ...bl, ...e };
  return n.useMutation(
    Ll,
    t
  );
}
const Tt = {}, Mt = i`
    query CheckinServiceCheckinById($id: String!) {
        checkinServiceCheckinById(id: $id) {
            id
            checkinMethod
            checkinTime
            isDeleted
            qrCode
            tenantId
            userId
            imageVerification
            createdAt
            updatedAt
            gpsVerification {
                latitude
                longitude
            }
            wifiVerification {
                bssid
                ssid
            }
        }
    }
`;
function oD(e) {
  const t = { ...Tt, ...e };
  return n.useQuery(
    Mt,
    t
  );
}
function aD(e) {
  const t = { ...Tt, ...e };
  return n.useLazyQuery(
    Mt,
    t
  );
}
function uD(e) {
  const t = e === n.skipToken ? e : { ...Tt, ...e };
  return n.useSuspenseQuery(
    Mt,
    t
  );
}
const Bl = {}, Ul = i`
    mutation CheckinServiceCheckinByGps($input: CheckinServiceGpsCheckinGqlInput!) {
        checkinServiceCheckinByGps(input: $input) {
            checkinId
            status
        }
    }
`;
function cD(e) {
  const t = { ...Bl, ...e };
  return n.useMutation(
    Ul,
    t
  );
}
const zl = {}, Fl = i`
    mutation CheckinServiceCheckinByImage($input: CheckinServiceImageCheckinGqlInput!) {
        checkinServiceCheckinByImage(input: $input) {
            checkinId
            status
        }
    }
`;
function dD(e) {
  const t = { ...zl, ...e };
  return n.useMutation(
    Fl,
    t
  );
}
const Rl = {}, Gl = i`
    mutation CheckinServiceCheckinByQrCode($input: CheckinServiceQrCodeCheckinGqlInput!) {
        checkinServiceCheckinByQrCode(input: $input) {
            checkinId
            status
        }
    }
`;
function pD(e) {
  const t = { ...Rl, ...e };
  return n.useMutation(
    Gl,
    t
  );
}
const ql = {}, El = i`
    mutation CheckinServiceCheckinByWifi($input: CheckinServiceWifiCheckinGqlInput!) {
        checkinServiceCheckinByWifi(input: $input) {
            checkinId
            status
        }
    }
`;
function lD(e) {
  const t = { ...ql, ...e };
  return n.useMutation(
    El,
    t
  );
}
const Vl = {}, Ol = i`
    mutation ClockinServiceAcceptClockin($id: String!) {
        clockinServiceAcceptClockin(id: $id)
    }
`;
function yD(e) {
  const t = { ...Vl, ...e };
  return n.useMutation(
    Ol,
    t
  );
}
const xl = {}, wl = i`
    mutation ClockinServiceAddStaff($id: String!, $staffIds: [String!]!) {
        clockinServiceAddStaff(id: $id, staffIds: $staffIds)
    }
`;
function SD(e) {
  const t = { ...xl, ...e };
  return n.useMutation(
    wl,
    t
  );
}
const bt = {}, Lt = i`
    query ClockinServiceAllClockin($input: ClockinServiceClockinGqlInput!, $pagination: PaginationArgs!) {
        clockinServiceAllClockin(input: $input, pagination: $pagination) {
            id
            acceptedBy
            checkinId
            isAccepted
            isDeleted
            shiftId
            staffId
            status
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function mD(e) {
  const t = { ...bt, ...e };
  return n.useQuery(
    Lt,
    t
  );
}
function vD(e) {
  const t = { ...bt, ...e };
  return n.useLazyQuery(
    Lt,
    t
  );
}
function gD(e) {
  const t = e === n.skipToken ? e : { ...bt, ...e };
  return n.useSuspenseQuery(
    Lt,
    t
  );
}
const Bt = {}, Ut = i`
    query ClockinServiceAllShifts($pagination: PaginationArgs!) {
        clockinServiceAllShifts(pagination: $pagination) {
            id
            name
            location
            startTime
            endTime
            isEnabled
            note
            staffIds
            tenantId
            createdAt
            updatedAt
            checkinMethod {
                methodType
                gpsConfig {
                    allowedLatitude
                    allowedLongitude
                    allowedRadius
                    note
                }
                imageConfig {
                    note
                }
                wifiConfig {
                    allowedSSIDs
                    allowedBSSIDs
                    note
                }
            }
        }
    }
`;
function fD(e) {
  const t = { ...Bt, ...e };
  return n.useQuery(
    Ut,
    t
  );
}
function AD(e) {
  const t = { ...Bt, ...e };
  return n.useLazyQuery(
    Ut,
    t
  );
}
function ID(e) {
  const t = e === n.skipToken ? e : { ...Bt, ...e };
  return n.useSuspenseQuery(
    Ut,
    t
  );
}
const zt = {}, Ft = i`
    query ClockinServiceClockinById($id: String!) {
        clockinServiceClockinById(id: $id) {
            id
            acceptedBy
            checkinId
            isAccepted
            isDeleted
            shiftId
            staffId
            status
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function $D(e) {
  const t = { ...zt, ...e };
  return n.useQuery(
    Ft,
    t
  );
}
function QD(e) {
  const t = { ...zt, ...e };
  return n.useLazyQuery(
    Ft,
    t
  );
}
function CD(e) {
  const t = e === n.skipToken ? e : { ...zt, ...e };
  return n.useSuspenseQuery(
    Ft,
    t
  );
}
const Hl = {}, Nl = i`
    mutation ClockinServiceCreateShift($input: ClockinServiceShiftGqlInput!) {
        clockinServiceCreateShift(input: $input)
    }
`;
function hD(e) {
  const t = { ...Hl, ...e };
  return n.useMutation(
    Nl,
    t
  );
}
const Wl = {}, jl = i`
    mutation ClockinServiceDeleteShifts($ids: [String!]!) {
        clockinServiceDeleteShifts(ids: $ids)
    }
`;
function kD(e) {
  const t = { ...Wl, ...e };
  return n.useMutation(
    jl,
    t
  );
}
const Kl = {}, Zl = i`
    mutation ClockinServiceDisableShifts($ids: [String!]!) {
        clockinServiceDisableShifts(ids: $ids)
    }
`;
function DD(e) {
  const t = { ...Kl, ...e };
  return n.useMutation(
    Zl,
    t
  );
}
const Yl = {}, Jl = i`
    mutation ClockinServiceEnableShifts($ids: [String!]!) {
        clockinServiceEnableShifts(ids: $ids)
    }
`;
function PD(e) {
  const t = { ...Yl, ...e };
  return n.useMutation(
    Jl,
    t
  );
}
const _l = {}, Xl = i`
    mutation ClockinServiceGpsClockin($input: ClockinServiceGpsClockinGqlInput!, $shiftId: String!) {
        clockinServiceGpsClockin(input: $input, shiftId: $shiftId)
    }
`;
function TD(e) {
  const t = { ..._l, ...e };
  return n.useMutation(
    Xl,
    t
  );
}
const ey = {}, ty = i`
    mutation ClockinServiceImageClockin($input: ClockinServiceImageClockinGqlInput!, $shiftId: String!) {
        clockinServiceImageClockin(input: $input, shiftId: $shiftId)
    }
`;
function MD(e) {
  const t = { ...ey, ...e };
  return n.useMutation(
    ty,
    t
  );
}
const Rt = {}, Gt = i`
    query ClockinServiceMyClockin($input: ClockinServiceClockinGqlInput!, $pagination: PaginationArgs!) {
        clockinServiceMyClockin(input: $input, pagination: $pagination) {
            id
            acceptedBy
            checkinId
            isAccepted
            isDeleted
            shiftId
            staffId
            status
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function bD(e) {
  const t = { ...Rt, ...e };
  return n.useQuery(
    Gt,
    t
  );
}
function LD(e) {
  const t = { ...Rt, ...e };
  return n.useLazyQuery(
    Gt,
    t
  );
}
function BD(e) {
  const t = e === n.skipToken ? e : { ...Rt, ...e };
  return n.useSuspenseQuery(
    Gt,
    t
  );
}
const qt = {}, Et = i`
    query ClockinServiceMyShifts {
        clockinServiceMyShifts {
            id
            name
            location
            startTime
            endTime
            isEnabled
            note
            staffIds
            tenantId
            createdAt
            updatedAt
            checkinMethod {
                methodType
                gpsConfig {
                    allowedLatitude
                    allowedLongitude
                    allowedRadius
                    note
                }
                imageConfig {
                    note
                }
                wifiConfig {
                    allowedSSIDs
                    allowedBSSIDs
                    note
                }
            }
        }
    }
`;
function UD(e) {
  const t = { ...qt, ...e };
  return n.useQuery(
    Et,
    t
  );
}
function zD(e) {
  const t = { ...qt, ...e };
  return n.useLazyQuery(
    Et,
    t
  );
}
function FD(e) {
  const t = e === n.skipToken ? e : { ...qt, ...e };
  return n.useSuspenseQuery(
    Et,
    t
  );
}
const ny = {}, iy = i`
    mutation ClockinServiceRemoveStaff($id: String!, $staffIds: [String!]!) {
        clockinServiceRemoveStaff(id: $id, staffIds: $staffIds)
    }
`;
function RD(e) {
  const t = { ...ny, ...e };
  return n.useMutation(
    iy,
    t
  );
}
const Vt = {}, Ot = i`
    query ClockinServiceShiftById($id: String!) {
        clockinServiceShiftById(id: $id) {
            id
            name
            location
            startTime
            endTime
            isEnabled
            note
            staffIds
            tenantId
            createdAt
            updatedAt
            checkinMethod {
                methodType
                gpsConfig {
                    allowedLatitude
                    allowedLongitude
                    allowedRadius
                    note
                }
                imageConfig {
                    note
                }
                wifiConfig {
                    allowedSSIDs
                    allowedBSSIDs
                    note
                }
            }
        }
    }
`;
function GD(e) {
  const t = { ...Vt, ...e };
  return n.useQuery(
    Ot,
    t
  );
}
function qD(e) {
  const t = { ...Vt, ...e };
  return n.useLazyQuery(
    Ot,
    t
  );
}
function ED(e) {
  const t = e === n.skipToken ? e : { ...Vt, ...e };
  return n.useSuspenseQuery(
    Ot,
    t
  );
}
const ry = {}, sy = i`
    mutation ClockinServiceUpdateShift($id: String!, $input: ClockinServiceShiftGqlInput!) {
        clockinServiceUpdateShift(id: $id, input: $input)
    }
`;
function VD(e) {
  const t = { ...ry, ...e };
  return n.useMutation(
    sy,
    t
  );
}
const oy = {}, ay = i`
    mutation ClockinServiceWifiClockin($input: ClockinServiceWifiClockinGqlInput!, $shiftId: String!) {
        clockinServiceWifiClockin(input: $input, shiftId: $shiftId)
    }
`;
function OD(e) {
  const t = { ...oy, ...e };
  return n.useMutation(
    ay,
    t
  );
}
const xt = {}, wt = i`
    query ContentServiceArticle($id: String!) {
        contentServiceArticle(id: $id) {
            id
            contentId
            title
            content
            description
            category
            contentType
            status
            hidden
            isDeleted
            imageUrl
            tags
            eventDate
            publishedAt
            viewCount
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function xD(e) {
  const t = { ...xt, ...e };
  return n.useQuery(
    wt,
    t
  );
}
function wD(e) {
  const t = { ...xt, ...e };
  return n.useLazyQuery(
    wt,
    t
  );
}
function HD(e) {
  const t = e === n.skipToken ? e : { ...xt, ...e };
  return n.useSuspenseQuery(
    wt,
    t
  );
}
const uy = {}, cy = i`
    mutation ContentServiceCreateArticle($input: ContentServiceArticleGqlInput!) {
        contentServiceCreateArticle(input: $input) {
            category
            content
            contentId
            contentType
            createdAt
            description
            eventDate
            hidden
            id
            imageUrl
            isDeleted
            publishedAt
            status
            tags
            tenantId
            title
            updatedAt
            viewCount
        }
    }
`;
function ND(e) {
  const t = { ...uy, ...e };
  return n.useMutation(
    cy,
    t
  );
}
const dy = {}, py = i`
    mutation ContentServiceDeleteArticles($ids: [String!]!) {
        contentServiceDeleteArticles(ids: $ids)
    }
`;
function WD(e) {
  const t = { ...dy, ...e };
  return n.useMutation(
    py,
    t
  );
}
const Ht = {}, Nt = i`
    query ContentServiceGetAllArticles($input: ContentServiceSearchArticleGqlInput!, $pagination: PaginationArgs!) {
        contentServiceGetAllArticles(input: $input, pagination: $pagination) {
            id
            contentId
            title
            content
            description
            category
            contentType
            status
            hidden
            isDeleted
            imageUrl
            tags
            eventDate
            publishedAt
            viewCount
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function jD(e) {
  const t = { ...Ht, ...e };
  return n.useQuery(
    Nt,
    t
  );
}
function KD(e) {
  const t = { ...Ht, ...e };
  return n.useLazyQuery(
    Nt,
    t
  );
}
function ZD(e) {
  const t = e === n.skipToken ? e : { ...Ht, ...e };
  return n.useSuspenseQuery(
    Nt,
    t
  );
}
const ly = {}, yy = i`
    mutation ContentServiceHideArticles($ids: [String!]!) {
        contentServiceHideArticles(ids: $ids)
    }
`;
function YD(e) {
  const t = { ...ly, ...e };
  return n.useMutation(
    yy,
    t
  );
}
const Wt = {}, jt = i`
    query ContentServiceSearchArticles($input: ContentServiceSearchArticleGqlInput!, $pagination: PaginationArgs!) {
        contentServiceSearchArticles(input: $input, pagination: $pagination) {
            id
            contentId
            title
            content
            description
            category
            contentType
            status
            hidden
            isDeleted
            imageUrl
            tags
            eventDate
            publishedAt
            viewCount
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function JD(e) {
  const t = { ...Wt, ...e };
  return n.useQuery(
    jt,
    t
  );
}
function _D(e) {
  const t = { ...Wt, ...e };
  return n.useLazyQuery(
    jt,
    t
  );
}
function XD(e) {
  const t = e === n.skipToken ? e : { ...Wt, ...e };
  return n.useSuspenseQuery(
    jt,
    t
  );
}
const Sy = {}, my = i`
    mutation ContentServiceUnhideArticles($ids: [String!]!) {
        contentServiceUnhideArticles(ids: $ids)
    }
`;
function eP(e) {
  const t = { ...Sy, ...e };
  return n.useMutation(
    my,
    t
  );
}
const vy = {}, gy = i`
    mutation ContentServiceUpdateArticle($id: String!, $input: ContentServiceUpdateArticleGqlInput!) {
        contentServiceUpdateArticle(id: $id, input: $input)
    }
`;
function tP(e) {
  const t = { ...vy, ...e };
  return n.useMutation(
    gy,
    t
  );
}
const Kt = {}, Zt = i`
    query EventServiceAllEvents($pagination: PaginationArgs!) {
        eventServiceAllEvents(pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function nP(e) {
  const t = { ...Kt, ...e };
  return n.useQuery(
    Zt,
    t
  );
}
function iP(e) {
  const t = { ...Kt, ...e };
  return n.useLazyQuery(
    Zt,
    t
  );
}
function rP(e) {
  const t = e === n.skipToken ? e : { ...Kt, ...e };
  return n.useSuspenseQuery(
    Zt,
    t
  );
}
const fy = {}, Ay = i`
    mutation EventServiceCreateEvent($input: EventServiceEventGqlInput!) {
        eventServiceCreateEvent(input: $input)
    }
`;
function sP(e) {
  const t = { ...fy, ...e };
  return n.useMutation(
    Ay,
    t
  );
}
const Iy = {}, $y = i`
    mutation EventServiceDeleteEvents($ids: [String!]!) {
        eventServiceDeleteEvents(ids: $ids)
    }
`;
function oP(e) {
  const t = { ...Iy, ...e };
  return n.useMutation(
    $y,
    t
  );
}
const Yt = {}, Jt = i`
    query EventServiceDisabledEvents($pagination: PaginationArgs!) {
        eventServiceDisabledEvents(pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function aP(e) {
  const t = { ...Yt, ...e };
  return n.useQuery(
    Jt,
    t
  );
}
function uP(e) {
  const t = { ...Yt, ...e };
  return n.useLazyQuery(
    Jt,
    t
  );
}
function cP(e) {
  const t = e === n.skipToken ? e : { ...Yt, ...e };
  return n.useSuspenseQuery(
    Jt,
    t
  );
}
const Qy = {}, Cy = i`
    mutation EventServiceDisableEvents($ids: [String!]!) {
        eventServiceDisableEvents(ids: $ids)
    }
`;
function dP(e) {
  const t = { ...Qy, ...e };
  return n.useMutation(
    Cy,
    t
  );
}
const _t = {}, Xt = i`
    query EventServiceEnabledEvents($pagination: PaginationArgs!) {
        eventServiceEnabledEvents(pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function pP(e) {
  const t = { ..._t, ...e };
  return n.useQuery(
    Xt,
    t
  );
}
function lP(e) {
  const t = { ..._t, ...e };
  return n.useLazyQuery(
    Xt,
    t
  );
}
function yP(e) {
  const t = e === n.skipToken ? e : { ..._t, ...e };
  return n.useSuspenseQuery(
    Xt,
    t
  );
}
const hy = {}, ky = i`
    mutation EventServiceEnableEvents($ids: [String!]!) {
        eventServiceEnableEvents(ids: $ids)
    }
`;
function SP(e) {
  const t = { ...hy, ...e };
  return n.useMutation(
    ky,
    t
  );
}
const en = {}, tn = i`
    query EventServiceEndedEvents($pagination: PaginationArgs!) {
        eventServiceEndedEvents(pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function mP(e) {
  const t = { ...en, ...e };
  return n.useQuery(
    tn,
    t
  );
}
function vP(e) {
  const t = { ...en, ...e };
  return n.useLazyQuery(
    tn,
    t
  );
}
function gP(e) {
  const t = e === n.skipToken ? e : { ...en, ...e };
  return n.useSuspenseQuery(
    tn,
    t
  );
}
const nn = {}, rn = i`
    query EventServiceEventById($id: String!) {
        eventServiceEventById(id: $id) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function fP(e) {
  const t = { ...nn, ...e };
  return n.useQuery(
    rn,
    t
  );
}
function AP(e) {
  const t = { ...nn, ...e };
  return n.useLazyQuery(
    rn,
    t
  );
}
function IP(e) {
  const t = e === n.skipToken ? e : { ...nn, ...e };
  return n.useSuspenseQuery(
    rn,
    t
  );
}
const sn = {}, on = i`
    query EventServiceIncomingEvents($pagination: PaginationArgs!) {
        eventServiceIncomingEvents(pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function $P(e) {
  const t = { ...sn, ...e };
  return n.useQuery(
    on,
    t
  );
}
function QP(e) {
  const t = { ...sn, ...e };
  return n.useLazyQuery(
    on,
    t
  );
}
function CP(e) {
  const t = e === n.skipToken ? e : { ...sn, ...e };
  return n.useSuspenseQuery(
    on,
    t
  );
}
const an = {}, un = i`
    query EventServiceOngoingEvents($pagination: PaginationArgs!) {
        eventServiceOngoingEvents(pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function hP(e) {
  const t = { ...an, ...e };
  return n.useQuery(
    un,
    t
  );
}
function kP(e) {
  const t = { ...an, ...e };
  return n.useLazyQuery(
    un,
    t
  );
}
function DP(e) {
  const t = e === n.skipToken ? e : { ...an, ...e };
  return n.useSuspenseQuery(
    un,
    t
  );
}
const cn = {}, dn = i`
    query EventServicePublicEvents($pagination: PaginationArgs!) {
        eventServicePublicEvents(pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function PP(e) {
  const t = { ...cn, ...e };
  return n.useQuery(
    dn,
    t
  );
}
function TP(e) {
  const t = { ...cn, ...e };
  return n.useLazyQuery(
    dn,
    t
  );
}
function MP(e) {
  const t = e === n.skipToken ? e : { ...cn, ...e };
  return n.useSuspenseQuery(
    dn,
    t
  );
}
const pn = {}, ln = i`
    query EventServiceSearchEvents($input: String!, $pagination: PaginationArgs!) {
        eventServiceSearchEvents(input: $input, pagination: $pagination) {
            bannerUrl
            content
            createdAt
            description
            endDate
            id
            isDeleted
            isEnabled
            location
            mediaUrls
            name
            organizerEmail
            organizerName
            startDate
            status
            tenantId
            thumbnailUrl
            timeline {
                description
                time
            }
            updatedAt
        }
    }
`;
function bP(e) {
  const t = { ...pn, ...e };
  return n.useQuery(
    ln,
    t
  );
}
function LP(e) {
  const t = { ...pn, ...e };
  return n.useLazyQuery(
    ln,
    t
  );
}
function BP(e) {
  const t = e === n.skipToken ? e : { ...pn, ...e };
  return n.useSuspenseQuery(
    ln,
    t
  );
}
const Dy = {}, Py = i`
    mutation EventServiceUpdateEvent($id: String!, $input: EventServiceEventGqlInput!) {
        eventServiceUpdateEvent(id: $id, input: $input)
    }
`;
function UP(e) {
  const t = { ...Dy, ...e };
  return n.useMutation(
    Py,
    t
  );
}
const Ty = {}, My = i`
    mutation FeatureFlagServiceCreateFeatureFlag($input: FeatureFlagServiceCreateFeatureFlagGqlInput!) {
        featureFlagServiceCreateFeatureFlag(input: $input)
    }
`;
function zP(e) {
  const t = { ...Ty, ...e };
  return n.useMutation(My, t);
}
const by = {}, Ly = i`
    mutation FeatureFlagServiceDeleteFeatureFlag($featureFlagId: String!, $type: FeatureFlagTypeEnum!) {
        featureFlagServiceDeleteFeatureFlag(featureFlagId: $featureFlagId, type: $type)
    }
`;
function FP(e) {
  const t = { ...by, ...e };
  return n.useMutation(Ly, t);
}
const yn = {}, Sn = i`
    query FeatureFlagServiceGetAllFeatureFlags($input: FeatureFlagServiceGetAllFeatureFlagGqlInput!) {
        featureFlagServiceGetAllFeatureFlags(input: $input) {
            description
            featureCode
            id
            isEnabled
            type
            rules {
                conditions {
                    key
                    operator
                    values
                }
                priority
            }
        }
    }
`;
function RP(e) {
  const t = { ...yn, ...e };
  return n.useQuery(Sn, t);
}
function GP(e) {
  const t = { ...yn, ...e };
  return n.useLazyQuery(Sn, t);
}
function qP(e) {
  const t = e === n.skipToken ? e : { ...yn, ...e };
  return n.useSuspenseQuery(Sn, t);
}
const mn = {}, vn = i`
    query FeatureFlagServiceGetEnabledFeatureFlags($input: FeatureFlagServiceGetFeatureFlagGqlInput!) {
        featureFlagServiceGetEnabledFeatureFlags(input: $input) {
            description
            featureCode
            id
            isEnabled
            type
            rules {
                conditions {
                    key
                    operator
                    values
                }
                priority
            }
        }
    }
`;
function EP(e) {
  const t = { ...mn, ...e };
  return n.useQuery(vn, t);
}
function VP(e) {
  const t = { ...mn, ...e };
  return n.useLazyQuery(vn, t);
}
function OP(e) {
  const t = e === n.skipToken ? e : { ...mn, ...e };
  return n.useSuspenseQuery(vn, t);
}
const gn = {}, fn = i`
    query FeatureFlagServiceGetFeatureFlagDetail($input: FeatureFlagServiceGetFeatureFlagDetailGqlInput!) {
        featureFlagServiceGetFeatureFlagDetail(input: $input) {
            description
            featureCode
            id
            isEnabled
            type
            rules {
                conditions {
                    key
                    operator
                    values
                }
                isEnabled
                priority
            }
        }
    }
`;
function xP(e) {
  const t = { ...gn, ...e };
  return n.useQuery(fn, t);
}
function wP(e) {
  const t = { ...gn, ...e };
  return n.useLazyQuery(fn, t);
}
function HP(e) {
  const t = e === n.skipToken ? e : { ...gn, ...e };
  return n.useSuspenseQuery(fn, t);
}
const By = {}, Uy = i`
    mutation featureFlagServiceToggleFeatureFlag($id: String!, $type: FeatureFlagTypeEnum!) {
        featureFlagServiceToggleFeatureFlagById(featureFlagId: $id, type: $type) {
            id
        }
    }
`;
function NP(e) {
  const t = { ...By, ...e };
  return n.useMutation(Uy, t);
}
const zy = {}, Fy = i`
    mutation FeatureFlagServiceUpdateFeatureFlag(
        $featureFlagId: String!
        $input: FeatureFlagServiceUpdateFeatureFlagGqlInput!
    ) {
        featureFlagServiceUpdateFeatureFlag(featureFlagId: $featureFlagId, input: $input)
    }
`;
function WP(e) {
  const t = { ...zy, ...e };
  return n.useMutation(Fy, t);
}
const An = {}, In = i`
    query FlashsaleServiceGetCampaign($id: ID!) {
        flashsaleServiceGetCampaign(id: $id) {
            id
            tenantId
            name
            description
            bannerUrl
            startTime
            endTime
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function jP(e) {
  const t = { ...An, ...e };
  return n.useQuery(
    In,
    t
  );
}
function KP(e) {
  const t = { ...An, ...e };
  return n.useLazyQuery(
    In,
    t
  );
}
function ZP(e) {
  const t = e === n.skipToken ? e : { ...An, ...e };
  return n.useSuspenseQuery(
    In,
    t
  );
}
const $n = {}, Qn = i`
    query FlashsaleServiceGetCampaigns($input: FlashSaleCampaignFilterInput, $pagination: PaginationInput) {
        flashsaleServiceGetCampaigns(input: $input, pagination: $pagination) {
            data {
                id
                tenantId
                name
                description
                bannerUrl
                startTime
                endTime
                status
                createdAt
                updatedAt
                deletedAt
            }
            total
        }
    }
`;
function YP(e) {
  const t = { ...$n, ...e };
  return n.useQuery(
    Qn,
    t
  );
}
function JP(e) {
  const t = { ...$n, ...e };
  return n.useLazyQuery(
    Qn,
    t
  );
}
function _P(e) {
  const t = e === n.skipToken ? e : { ...$n, ...e };
  return n.useSuspenseQuery(
    Qn,
    t
  );
}
const Cn = {}, hn = i`
    query FlashsaleServiceGetCampaignProducts($input: FlashSaleProductFilterInput!, $pagination: PaginationInput) {
        flashsaleServiceGetCampaignProducts(input: $input, pagination: $pagination) {
            data {
                id
                tenantId
                campaignId
                productId
                sku
                originalPrice
                flashSalePrice
                stockQuantity
                startTime
                endTime
                status
                createdAt
                updatedAt
                deletedAt
            }
            total
        }
    }
`;
function XP(e) {
  const t = { ...Cn, ...e };
  return n.useQuery(
    hn,
    t
  );
}
function eT(e) {
  const t = { ...Cn, ...e };
  return n.useLazyQuery(hn, t);
}
function tT(e) {
  const t = e === n.skipToken ? e : { ...Cn, ...e };
  return n.useSuspenseQuery(hn, t);
}
const kn = {}, Dn = i`
    query FlashsaleServiceHasActiveFlashSale {
        flashsaleServiceHasActiveFlashSale
    }
`;
function nT(e) {
  const t = { ...kn, ...e };
  return n.useQuery(
    Dn,
    t
  );
}
function iT(e) {
  const t = { ...kn, ...e };
  return n.useLazyQuery(Dn, t);
}
function rT(e) {
  const t = e === n.skipToken ? e : { ...kn, ...e };
  return n.useSuspenseQuery(Dn, t);
}
const Ry = {}, Gy = i`
    mutation FlashsaleServiceCreateCampaign($input: FlashsaleServiceCreateCampaignGqlInput!) {
        flashsaleServiceCreateCampaign(input: $input) {
            id
            tenantId
            name
            description
            bannerUrl
            startTime
            endTime
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function sT(e) {
  const t = { ...Ry, ...e };
  return n.useMutation(
    Gy,
    t
  );
}
const qy = {}, Ey = i`
    mutation FlashsaleServiceUpdateCampaign($id: ID!, $input: FlashsaleServiceUpdateCampaignGqlInput!) {
        flashsaleServiceUpdateCampaign(id: $id, input: $input) {
            id
            tenantId
            name
            description
            bannerUrl
            startTime
            endTime
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function oT(e) {
  const t = { ...qy, ...e };
  return n.useMutation(
    Ey,
    t
  );
}
const Vy = {}, Oy = i`
    mutation FlashsaleServiceDeleteCampaign($id: ID!) {
        flashsaleServiceDeleteCampaign(id: $id)
    }
`;
function aT(e) {
  const t = { ...Vy, ...e };
  return n.useMutation(
    Oy,
    t
  );
}
const xy = {}, wy = i`
    mutation FlashsaleServiceAddProduct($input: FlashsaleServiceAddProductGqlInput!) {
        flashsaleServiceAddProduct(input: $input) {
            id
            tenantId
            campaignId
            productId
            sku
            originalPrice
            flashSalePrice
            stockQuantity
            startTime
            endTime
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function uT(e) {
  const t = { ...xy, ...e };
  return n.useMutation(
    wy,
    t
  );
}
const Hy = {}, Ny = i`
    mutation FlashsaleServiceUpdateProduct($id: ID!, $input: FlashsaleServiceUpdateProductGqlInput!) {
        flashsaleServiceUpdateProduct(id: $id, input: $input) {
            id
            tenantId
            campaignId
            productId
            sku
            originalPrice
            flashSalePrice
            stockQuantity
            startTime
            endTime
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function cT(e) {
  const t = { ...Hy, ...e };
  return n.useMutation(
    Ny,
    t
  );
}
const Wy = {}, jy = i`
    mutation FlashsaleServiceDeleteProduct($id: ID!) {
        flashsaleServiceDeleteProduct(id: $id)
    }
`;
function dT(e) {
  const t = { ...Wy, ...e };
  return n.useMutation(
    jy,
    t
  );
}
const Pn = {}, Tn = i`
    query FlashsaleServiceGetActiveCampaigns($input: FlashSaleActiveCampaignFilterInput, $pagination: PaginationInput) {
        flashsaleServiceGetActiveCampaigns(input: $input, pagination: $pagination) {
            data {
                id
                tenantId
                name
                description
                status
                startTime
                endTime
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function pT(e) {
  const t = { ...Pn, ...e };
  return n.useQuery(
    Tn,
    t
  );
}
function lT(e) {
  const t = { ...Pn, ...e };
  return n.useLazyQuery(Tn, t);
}
function yT(e) {
  const t = e === n.skipToken ? e : { ...Pn, ...e };
  return n.useSuspenseQuery(Tn, t);
}
const Ky = {}, Zy = i`
    mutation FeatureServiceCreateFeature($input: FeatureServiceCreateFeatureGqlInput!) {
        featureServiceCreateFeature(input: $input)
    }
`;
function ST(e) {
  const t = { ...Ky, ...e };
  return n.useMutation(
    Zy,
    t
  );
}
const Yy = {}, Jy = i`
    mutation FeatureServiceDeleteFeature($featureCode: String!) {
        featureServiceDeleteFeature(featureCode: $featureCode)
    }
`;
function mT(e) {
  const t = { ...Yy, ...e };
  return n.useMutation(
    Jy,
    t
  );
}
const Mn = {}, bn = i`
    query FeatureServiceGetFeatureByCode($featureCode: String!) {
        featureServiceGetFeatureByCode(featureCode: $featureCode) {
            createdAt
            featureCode
            featureName
            id
            isDeleted
            isEnabled
            updatedAt
        }
    }
`;
function vT(e) {
  const t = { ...Mn, ...e };
  return n.useQuery(
    bn,
    t
  );
}
function gT(e) {
  const t = { ...Mn, ...e };
  return n.useLazyQuery(
    bn,
    t
  );
}
function fT(e) {
  const t = e === n.skipToken ? e : { ...Mn, ...e };
  return n.useSuspenseQuery(
    bn,
    t
  );
}
const Ln = {}, Bn = i`
    query FeatureServiceGetFeatureList($input: FeatureServiceGetListGqlInput) {
        featureServiceGetFeatureList(input: $input) {
            data {
                createdAt
                featureCode
                featureName
                id
                isDeleted
                isEnabled
                updatedAt
            }
            limit
            page
            total
            totalPages
        }
    }
`;
function AT(e) {
  const t = { ...Ln, ...e };
  return n.useQuery(
    Bn,
    t
  );
}
function IT(e) {
  const t = { ...Ln, ...e };
  return n.useLazyQuery(
    Bn,
    t
  );
}
function $T(e) {
  const t = e === n.skipToken ? e : { ...Ln, ...e };
  return n.useSuspenseQuery(
    Bn,
    t
  );
}
const _y = {}, Xy = i`
    mutation FeatureServiceToggleFeature($input: FeatureServiceToggleFeatureGqlInput!) {
        featureServiceToggleFeature(input: $input)
    }
`;
function QT(e) {
  const t = { ..._y, ...e };
  return n.useMutation(
    Xy,
    t
  );
}
const eS = {}, tS = i`
    mutation FeatureServiceUpdateFeature($featureCode: String!, $input: FeatureServiceUpdateFeatureGqlInput!) {
        featureServiceUpdateFeature(featureCode: $featureCode, input: $input)
    }
`;
function CT(e) {
  const t = { ...eS, ...e };
  return n.useMutation(
    tS,
    t
  );
}
const nS = {}, iS = i`
    mutation FnsServiceCreateFormForAdmin($input: FnsServiceCreateFormGqlInput!) {
        fnsServiceCreateFormForAdmin(input: $input) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function hT(e) {
  const t = { ...nS, ...e };
  return n.useMutation(
    iS,
    t
  );
}
const rS = {}, sS = i`
    mutation FnsServiceCreateSurveyForAdmin($input: FnsServiceCreateSurveyGqlInput!) {
        fnsServiceCreateSurveyForAdmin(input: $input) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            type
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function kT(e) {
  const t = { ...rS, ...e };
  return n.useMutation(
    sS,
    t
  );
}
const oS = {}, aS = i`
    mutation FnsServiceCreateUserResponseToForm($input: FnsServiceCreateUserResponseFormGqlInput!) {
        fnsServiceCreateUserResponseToForm(input: $input) {
            id
            formId
            surveyId
            userId
            tenantId
            ipAddress
            userAgent
            createdAt
            updatedAt
            answers {
                questionId
                answer
            }
        }
    }
`;
function DT(e) {
  const t = { ...oS, ...e };
  return n.useMutation(aS, t);
}
const uS = {}, cS = i`
    mutation FnsServiceCreateUserResponseToFormForAnonymous($input: FnsServiceCreateUserResponseFormGqlInput!) {
        fnsServiceCreateUserResponseToFormForAnonymous(input: $input) {
            id
            formId
            surveyId
            userId
            tenantId
            ipAddress
            userAgent
            createdAt
            updatedAt
            answers {
                questionId
                answer
            }
        }
    }
`;
function PT(e) {
  const t = { ...uS, ...e };
  return n.useMutation(cS, t);
}
const dS = {}, pS = i`
    mutation FnsServiceCreateUserResponseToSurvey($input: FnsServiceCreateUserResponseSurveyGqlInput!) {
        fnsServiceCreateUserResponseToSurvey(input: $input) {
            id
            formId
            surveyId
            userId
            tenantId
            ipAddress
            userAgent
            createdAt
            updatedAt
            answers {
                questionId
                answer
            }
        }
    }
`;
function TT(e) {
  const t = { ...dS, ...e };
  return n.useMutation(pS, t);
}
const lS = {}, yS = i`
    mutation FnsServiceCreateUserResponseToSurveyForAnonymous($input: FnsServiceCreateUserResponseSurveyGqlInput!) {
        fnsServiceCreateUserResponseToSurveyForAnonymous(input: $input) {
            id
            formId
            surveyId
            userId
            tenantId
            ipAddress
            userAgent
            createdAt
            updatedAt
            answers {
                questionId
                answer
            }
        }
    }
`;
function MT(e) {
  const t = { ...lS, ...e };
  return n.useMutation(yS, t);
}
const SS = {}, mS = i`
    mutation FnsServiceUpdateFormForAdmin($id: String!, $input: FnsServiceUpdateFormGqlInput!) {
        fnsServiceUpdateFormForAdmin(id: $id, input: $input) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function bT(e) {
  const t = { ...SS, ...e };
  return n.useMutation(
    mS,
    t
  );
}
const vS = {}, gS = i`
    mutation FnsServiceUpdateSurveyForAdmin($id: String!, $input: FnsServiceUpdateSurveyGqlInput!) {
        fnsServiceUpdateSurveyForAdmin(id: $id, input: $input) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            type
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function LT(e) {
  const t = { ...vS, ...e };
  return n.useMutation(
    gS,
    t
  );
}
const Un = {}, zn = i`
    query FnsServiceGetFormById($id: String!) {
        fnsServiceGetFormById(id: $id) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function BT(e) {
  const t = { ...Un, ...e };
  return n.useQuery(
    zn,
    t
  );
}
function UT(e) {
  const t = { ...Un, ...e };
  return n.useLazyQuery(
    zn,
    t
  );
}
function zT(e) {
  const t = e === n.skipToken ? e : { ...Un, ...e };
  return n.useSuspenseQuery(
    zn,
    t
  );
}
const Fn = {}, Rn = i`
    query FnsServiceGetFormByIdForAdmin($id: String!) {
        fnsServiceGetFormByIdForAdmin(id: $id) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function FT(e) {
  const t = { ...Fn, ...e };
  return n.useQuery(
    Rn,
    t
  );
}
function RT(e) {
  const t = { ...Fn, ...e };
  return n.useLazyQuery(
    Rn,
    t
  );
}
function GT(e) {
  const t = e === n.skipToken ? e : { ...Fn, ...e };
  return n.useSuspenseQuery(
    Rn,
    t
  );
}
const Gn = {}, qn = i`
    query FnsServiceGetFormsForAdmin($pagination: PaginationArgs!) {
        fnsServiceGetFormsForAdmin(pagination: $pagination) {
            data {
                id
                title
                description
                isActive
                isAnonymous
                tenantId
                createdAt
                updatedAt
                questions {
                    id
                    text
                    type
                    isRequired
                    isActive
                    index
                    options
                    minValue
                    maxValue
                    actionLabel
                    actionUrl
                    uiTemplate
                }
            }
            total
        }
    }
`;
function qT(e) {
  const t = { ...Gn, ...e };
  return n.useQuery(
    qn,
    t
  );
}
function ET(e) {
  const t = { ...Gn, ...e };
  return n.useLazyQuery(
    qn,
    t
  );
}
function VT(e) {
  const t = e === n.skipToken ? e : { ...Gn, ...e };
  return n.useSuspenseQuery(
    qn,
    t
  );
}
const En = {}, Vn = i`
    query FnsServiceGetSurveyById($id: String!) {
        fnsServiceGetSurveyById(id: $id) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            type
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function OT(e) {
  const t = { ...En, ...e };
  return n.useQuery(
    Vn,
    t
  );
}
function xT(e) {
  const t = { ...En, ...e };
  return n.useLazyQuery(
    Vn,
    t
  );
}
function wT(e) {
  const t = e === n.skipToken ? e : { ...En, ...e };
  return n.useSuspenseQuery(
    Vn,
    t
  );
}
const On = {}, xn = i`
    query FnsServiceGetSurveyByIdForAdmin($id: String!) {
        fnsServiceGetSurveyByIdForAdmin(id: $id) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            type
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function HT(e) {
  const t = { ...On, ...e };
  return n.useQuery(
    xn,
    t
  );
}
function NT(e) {
  const t = { ...On, ...e };
  return n.useLazyQuery(
    xn,
    t
  );
}
function WT(e) {
  const t = e === n.skipToken ? e : { ...On, ...e };
  return n.useSuspenseQuery(
    xn,
    t
  );
}
const wn = {}, Hn = i`
    query FnsServiceGetSurveyByType($type: SurveyType!) {
        fnsServiceGetSurveyByType(type: $type) {
            id
            title
            description
            isActive
            isAnonymous
            tenantId
            type
            createdAt
            updatedAt
            questions {
                id
                text
                type
                isRequired
                isActive
                index
                options
                minValue
                maxValue
                actionLabel
                actionUrl
                uiTemplate
            }
        }
    }
`;
function jT(e) {
  const t = { ...wn, ...e };
  return n.useQuery(
    Hn,
    t
  );
}
function KT(e) {
  const t = { ...wn, ...e };
  return n.useLazyQuery(
    Hn,
    t
  );
}
function ZT(e) {
  const t = e === n.skipToken ? e : { ...wn, ...e };
  return n.useSuspenseQuery(
    Hn,
    t
  );
}
const Nn = {}, Wn = i`
    query FnsServiceGetSurveysForAdmin($pagination: PaginationArgs!) {
        fnsServiceGetSurveysForAdmin(pagination: $pagination) {
            data {
                id
                title
                description
                isActive
                isAnonymous
                tenantId
                type
                createdAt
                updatedAt
                questions {
                    id
                    text
                    type
                    isRequired
                    isActive
                    index
                    options
                    minValue
                    maxValue
                    actionLabel
                    actionUrl
                    uiTemplate
                }
            }
            total
        }
    }
`;
function YT(e) {
  const t = { ...Nn, ...e };
  return n.useQuery(
    Wn,
    t
  );
}
function JT(e) {
  const t = { ...Nn, ...e };
  return n.useLazyQuery(
    Wn,
    t
  );
}
function _T(e) {
  const t = e === n.skipToken ? e : { ...Nn, ...e };
  return n.useSuspenseQuery(
    Wn,
    t
  );
}
const jn = {}, Kn = i`
    query FnsServiceGetUserResponseByIdForAdmin($id: String!) {
        fnsServiceGetUserResponseByIdForAdmin(id: $id) {
            id
            formId
            surveyId
            userId
            tenantId
            ipAddress
            userAgent
            createdAt
            updatedAt
            formTitle
            surveyTitle
            userName
            answers {
                questionId
                questionName
                answer
            }
        }
    }
`;
function XT(e) {
  const t = { ...jn, ...e };
  return n.useQuery(Kn, t);
}
function eM(e) {
  const t = { ...jn, ...e };
  return n.useLazyQuery(Kn, t);
}
function tM(e) {
  const t = e === n.skipToken ? e : { ...jn, ...e };
  return n.useSuspenseQuery(Kn, t);
}
const Zn = {}, Yn = i`
    query FnsServiceGetUserResponsesToFormForAdmin(
        $input: FnsServiceFindUserResponsesToFormGqlInput!
        $pagination: PaginationArgs!
    ) {
        fnsServiceGetUserResponsesToFormForAdmin(input: $input, pagination: $pagination) {
            data {
                id
                formId
                formTitle
                surveyId
                surveyTitle
                userId
                userName
                tenantId
                ipAddress
                userAgent
                createdAt
                updatedAt
                answers {
                    questionId
                    questionName
                    answer
                }
            }
            total
        }
    }
`;
function nM(e) {
  const t = { ...Zn, ...e };
  return n.useQuery(Yn, t);
}
function iM(e) {
  const t = { ...Zn, ...e };
  return n.useLazyQuery(Yn, t);
}
function rM(e) {
  const t = e === n.skipToken ? e : { ...Zn, ...e };
  return n.useSuspenseQuery(Yn, t);
}
const Jn = {}, _n = i`
    query FnsServiceGetUserResponsesToSurveyForAdmin(
        $input: FnsServiceFindUserResponsesToSurveyGqlInput!
        $pagination: PaginationArgs!
    ) {
        fnsServiceGetUserResponsesToSurveyForAdmin(input: $input, pagination: $pagination) {
            data {
                id
                formId
                formTitle
                surveyId
                surveyTitle
                userId
                userName
                tenantId
                ipAddress
                userAgent
                createdAt
                updatedAt
                answers {
                    questionId
                    questionName
                    answer
                }
            }
            total
        }
    }
`;
function sM(e) {
  const t = { ...Jn, ...e };
  return n.useQuery(_n, t);
}
function oM(e) {
  const t = { ...Jn, ...e };
  return n.useLazyQuery(_n, t);
}
function aM(e) {
  const t = e === n.skipToken ? e : { ...Jn, ...e };
  return n.useSuspenseQuery(_n, t);
}
const Xn = {}, ei = i`
    query InventoryServiceAllStock($pagination: PaginationArgs!) {
        inventoryServiceAllStock(pagination: $pagination) {
            data {
                id
                productId
                productName
                sku
                availableQuantity
                reservedQuantity
                soldQuantity
                totalQuantity
                isDeleted
                tenantId
                createdAt
                updatedAt
                deletedAt
            }
            total
        }
    }
`;
function uM(e) {
  const t = { ...Xn, ...e };
  return n.useQuery(
    ei,
    t
  );
}
function cM(e) {
  const t = { ...Xn, ...e };
  return n.useLazyQuery(
    ei,
    t
  );
}
function dM(e) {
  const t = e === n.skipToken ? e : { ...Xn, ...e };
  return n.useSuspenseQuery(
    ei,
    t
  );
}
const ti = {}, ni = i`
    query InventoryServiceSearchStock($input: InventoryServiceSearchStockGqlInput!, $pagination: PaginationArgs!) {
        inventoryServiceSearchStock(input: $input, pagination: $pagination) {
            id
            productId
            productName
            sku
            availableQuantity
            reservedQuantity
            soldQuantity
            totalQuantity
            isDeleted
            tenantId
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function pM(e) {
  const t = { ...ti, ...e };
  return n.useQuery(
    ni,
    t
  );
}
function lM(e) {
  const t = { ...ti, ...e };
  return n.useLazyQuery(
    ni,
    t
  );
}
function yM(e) {
  const t = e === n.skipToken ? e : { ...ti, ...e };
  return n.useSuspenseQuery(
    ni,
    t
  );
}
const ii = {}, ri = i`
    query InventoryServiceStockById($stockId: String!) {
        inventoryServiceStockById(stockId: $stockId) {
            id
            productId
            productName
            sku
            availableQuantity
            reservedQuantity
            soldQuantity
            totalQuantity
            isDeleted
            tenantId
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function SM(e) {
  const t = { ...ii, ...e };
  return n.useQuery(
    ri,
    t
  );
}
function mM(e) {
  const t = { ...ii, ...e };
  return n.useLazyQuery(
    ri,
    t
  );
}
function vM(e) {
  const t = e === n.skipToken ? e : { ...ii, ...e };
  return n.useSuspenseQuery(
    ri,
    t
  );
}
const si = {}, oi = i`
    query InventoryServiceStockByProductAndSku($productId: String!, $sku: String!) {
        inventoryServiceStockByProductAndSku(productId: $productId, sku: $sku) {
            id
            productId
            productName
            sku
            totalQuantity
            reservedQuantity
            availableQuantity
            soldQuantity
            isDeleted
            tenantId
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function gM(e) {
  const t = { ...si, ...e };
  return n.useQuery(oi, t);
}
function fM(e) {
  const t = { ...si, ...e };
  return n.useLazyQuery(oi, t);
}
function AM(e) {
  const t = e === n.skipToken ? e : { ...si, ...e };
  return n.useSuspenseQuery(oi, t);
}
const fS = {}, AS = i`
    mutation InventoryServiceCreateStock($input: InventoryServiceCreateStockGqlInput!) {
        inventoryServiceCreateStock(input: $input)
    }
`;
function IM(e) {
  const t = { ...fS, ...e };
  return n.useMutation(
    AS,
    t
  );
}
const IS = {}, $S = i`
    mutation InventoryServiceDeleteStock($stockId: String!) {
        inventoryServiceDeleteStock(stockId: $stockId)
    }
`;
function $M(e) {
  const t = { ...IS, ...e };
  return n.useMutation(
    $S,
    t
  );
}
const QS = {}, CS = i`
    mutation InventoryServiceUpdateStock($input: InventoryServiceStockGqlInput!, $stockId: String!) {
        inventoryServiceUpdateStock(input: $input, stockId: $stockId)
    }
`;
function QM(e) {
  const t = { ...QS, ...e };
  return n.useMutation(
    CS,
    t
  );
}
const hS = {}, kS = i`
    mutation InventoryServiceConfirmProduct($input: InventoryServiceStockGqlInput!) {
        inventoryServiceConfirmProduct(input: $input)
    }
`;
function CM(e) {
  const t = { ...hS, ...e };
  return n.useMutation(
    kS,
    t
  );
}
const DS = {}, PS = i`
    mutation InventoryServiceReleaseProduct($input: InventoryServiceStockGqlInput!) {
        inventoryServiceReleaseProduct(input: $input)
    }
`;
function hM(e) {
  const t = { ...DS, ...e };
  return n.useMutation(
    PS,
    t
  );
}
const TS = {}, MS = i`
    mutation InventoryServiceReserveProduct($input: InventoryServiceStockGqlInput!) {
        inventoryServiceReserveProduct(input: $input)
    }
`;
function kM(e) {
  const t = { ...TS, ...e };
  return n.useMutation(
    MS,
    t
  );
}
const ai = {}, ui = i`
    query LoyaltyServiceActiveLoyaltyPrograms {
        loyaltyServiceActiveLoyaltyPrograms {
            id
            additionalSettings {
                customTheme {
                    logoUrl
                    primaryColor
                    secondaryColor
                }
                displayInApp
                emailTemplateId
                integrations {
                    apiKeys
                    externalSystemId
                }
                notificationEnabled
            }
            createdAt
            description
            endDate
            isActive
            isDefault
            isDeleted
            isEnabled
            name
            pointsConfig {
                earnRules {
                    amountSpentRatio
                    referralBonus
                    registrationBonus
                }
                redemptionRules {
                    minimumPoints
                    pointValue
                }
            }
            startDate
            tenantId
            updatedAt
        }
    }
`;
function DM(e) {
  const t = { ...ai, ...e };
  return n.useQuery(
    ui,
    t
  );
}
function PM(e) {
  const t = { ...ai, ...e };
  return n.useLazyQuery(ui, t);
}
function TM(e) {
  const t = e === n.skipToken ? e : { ...ai, ...e };
  return n.useSuspenseQuery(ui, t);
}
const ci = {}, di = i`
    query LoyaltyServiceAllLoyaltyPrograms($pagination: PaginationArgs!) {
        loyaltyServiceAllLoyaltyPrograms(pagination: $pagination) {
            data {
                additionalSettings {
                    customTheme {
                        logoUrl
                        primaryColor
                        secondaryColor
                    }
                    displayInApp
                    emailTemplateId
                    integrations {
                        apiKeys
                        externalSystemId
                    }
                    notificationEnabled
                }
                createdAt
                description
                endDate
                id
                isActive
                isDefault
                isDeleted
                isEnabled
                name
                pointsConfig {
                    earnRules {
                        amountSpentRatio
                        referralBonus
                        registrationBonus
                    }
                    redemptionRules {
                        minimumPoints
                        pointValue
                    }
                }
                startDate
                tenantId
                updatedAt
            }
            total
        }
    }
`;
function MM(e) {
  const t = { ...ci, ...e };
  return n.useQuery(
    di,
    t
  );
}
function bM(e) {
  const t = { ...ci, ...e };
  return n.useLazyQuery(
    di,
    t
  );
}
function LM(e) {
  const t = e === n.skipToken ? e : { ...ci, ...e };
  return n.useSuspenseQuery(di, t);
}
const pi = {}, li = i`
    query LoyaltyServiceAllLoyaltyTiers($pagination: PaginationArgs!) {
        loyaltyServiceAllLoyaltyTiers(pagination: $pagination) {
            data {
                benefit {
                    additionalBenefits
                    discounts {
                        applicableCategoryIds
                        applicableProductIds
                        applicableServices
                        maximumDiscount
                        minimumPurchase
                        percentage
                        scope
                    }
                    exclusiveAccess
                    freeServices
                    prioritySupport
                }
                benefitDescriptions
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                level
                maintenanceThreshold
                name
                pointEarnRuleDescription
                pointsMultiplier
                pointsThreshold
                spendingPerPoint
                spendingThreshold
                tenantId
                updatedAt
                validityPeriod
            }
            total
        }
    }
`;
function BM(e) {
  const t = { ...pi, ...e };
  return n.useQuery(
    li,
    t
  );
}
function UM(e) {
  const t = { ...pi, ...e };
  return n.useLazyQuery(
    li,
    t
  );
}
function zM(e) {
  const t = e === n.skipToken ? e : { ...pi, ...e };
  return n.useSuspenseQuery(
    li,
    t
  );
}
const bS = {}, LS = i`
    mutation LoyaltyServiceCreateLoyaltyProgram($input: LoyaltyServiceCreateLoyaltyProgramGqlInput!) {
        loyaltyServiceCreateLoyaltyProgram(input: $input)
    }
`;
function FM(e) {
  const t = { ...bS, ...e };
  return n.useMutation(LS, t);
}
const BS = {}, US = i`
    mutation LoyaltyServiceCreateLoyaltyTier($input: LoyaltyServiceCreateLoyaltyTierGqlInput!) {
        loyaltyServiceCreateLoyaltyTier(input: $input)
    }
`;
function RM(e) {
  const t = { ...BS, ...e };
  return n.useMutation(US, t);
}
const zS = {}, FS = i`
    mutation LoyaltyServiceDeactiveLoyaltyProgram($id: String!) {
        loyaltyServiceDeactiveLoyaltyProgram(id: $id)
    }
`;
function GM(e) {
  const t = { ...zS, ...e };
  return n.useMutation(FS, t);
}
const yi = {}, Si = i`
    query LoyaltyServiceDefaultLoyaltyProgram {
        loyaltyServiceDefaultLoyaltyProgram {
            id
            additionalSettings {
                customTheme {
                    logoUrl
                    primaryColor
                    secondaryColor
                }
                displayInApp
                emailTemplateId
                integrations {
                    apiKeys
                    externalSystemId
                }
                notificationEnabled
            }
            createdAt
            description
            endDate
            isActive
            isDefault
            isDeleted
            isEnabled
            name
            pointsConfig {
                earnRules {
                    amountSpentRatio
                    referralBonus
                    registrationBonus
                }
                redemptionRules {
                    minimumPoints
                    pointValue
                }
            }
            startDate
            tenantId
            updatedAt
        }
    }
`;
function qM(e) {
  const t = { ...yi, ...e };
  return n.useQuery(
    Si,
    t
  );
}
function EM(e) {
  const t = { ...yi, ...e };
  return n.useLazyQuery(Si, t);
}
function VM(e) {
  const t = e === n.skipToken ? e : { ...yi, ...e };
  return n.useSuspenseQuery(Si, t);
}
const RS = {}, GS = i`
    mutation LoyaltyServiceDeleteLoyaltyProgram($id: String!) {
        loyaltyServiceDeleteLoyaltyProgram(id: $id)
    }
`;
function OM(e) {
  const t = { ...RS, ...e };
  return n.useMutation(GS, t);
}
const qS = {}, ES = i`
    mutation LoyaltyServiceDeleteLoyaltyTiers($ids: [String!]!) {
        loyaltyServiceDeleteLoyaltyTiers(ids: $ids)
    }
`;
function xM(e) {
  const t = { ...qS, ...e };
  return n.useMutation(ES, t);
}
const VS = {}, OS = i`
    mutation LoyaltyServiceDisableLoyaltyTier($ids: [String!]!) {
        loyaltyServiceDisableLoyaltyTier(ids: $ids)
    }
`;
function wM(e) {
  const t = { ...VS, ...e };
  return n.useMutation(OS, t);
}
const xS = {}, wS = i`
    mutation LoyaltyServiceEnableLoyaltyTier($ids: [String!]!) {
        loyaltyServiceEnableLoyaltyTier(ids: $ids)
    }
`;
function HM(e) {
  const t = { ...xS, ...e };
  return n.useMutation(wS, t);
}
const mi = {}, vi = i`
    query LoyaltyServiceEnabledLoyaltyTiers($pagination: PaginationArgs!) {
        loyaltyServiceEnabledLoyaltyTiers(pagination: $pagination) {
            benefit {
                additionalBenefits
                discounts {
                    applicableCategoryIds
                    applicableProductIds
                    applicableServices
                    maximumDiscount
                    minimumPurchase
                    percentage
                    scope
                }
                exclusiveAccess
                freeServices
                prioritySupport
            }
            benefitDescriptions
            createdAt
            description
            iconUrl
            id
            isDeleted
            isEnabled
            level
            maintenanceThreshold
            name
            pointEarnRuleDescription
            pointsMultiplier
            pointsThreshold
            spendingPerPoint
            spendingThreshold
            tenantId
            updatedAt
            validityPeriod
        }
    }
`;
function NM(e) {
  const t = { ...mi, ...e };
  return n.useQuery(
    vi,
    t
  );
}
function WM(e) {
  const t = { ...mi, ...e };
  return n.useLazyQuery(
    vi,
    t
  );
}
function jM(e) {
  const t = e === n.skipToken ? e : { ...mi, ...e };
  return n.useSuspenseQuery(vi, t);
}
const gi = {}, fi = i`
    query LoyaltyServiceLoyaltyProgramById($id: String!) {
        loyaltyServiceLoyaltyProgramById(id: $id) {
            id
            additionalSettings {
                customTheme {
                    logoUrl
                    primaryColor
                    secondaryColor
                }
                displayInApp
                emailTemplateId
                integrations {
                    apiKeys
                    externalSystemId
                }
                notificationEnabled
            }
            createdAt
            description
            endDate
            isActive
            isDefault
            isDeleted
            isEnabled
            name
            pointsConfig {
                earnRules {
                    amountSpentRatio
                    referralBonus
                    registrationBonus
                }
                redemptionRules {
                    minimumPoints
                    pointValue
                }
            }
            startDate
            tenantId
            updatedAt
        }
    }
`;
function KM(e) {
  const t = { ...gi, ...e };
  return n.useQuery(
    fi,
    t
  );
}
function ZM(e) {
  const t = { ...gi, ...e };
  return n.useLazyQuery(
    fi,
    t
  );
}
function YM(e) {
  const t = e === n.skipToken ? e : { ...gi, ...e };
  return n.useSuspenseQuery(fi, t);
}
const Ai = {}, Ii = i`
    query LoyaltyServiceLoyaltyTierById($id: String!) {
        loyaltyServiceLoyaltyTierById(id: $id) {
            id
            benefit {
                additionalBenefits
                discounts {
                    applicableCategoryIds
                    applicableProductIds
                    applicableServices
                    maximumDiscount
                    minimumPurchase
                    percentage
                    scope
                }
                exclusiveAccess
                freeServices
                prioritySupport
            }
            benefitDescriptions
            createdAt
            description
            iconUrl
            level
            maintenanceThreshold
            name
            pointEarnRuleDescription
            pointsMultiplier
            pointsThreshold
            spendingPerPoint
            spendingThreshold
            tenantId
            updatedAt
            validityPeriod
        }
    }
`;
function JM(e) {
  const t = { ...Ai, ...e };
  return n.useQuery(
    Ii,
    t
  );
}
function _M(e) {
  const t = { ...Ai, ...e };
  return n.useLazyQuery(
    Ii,
    t
  );
}
function XM(e) {
  const t = e === n.skipToken ? e : { ...Ai, ...e };
  return n.useSuspenseQuery(
    Ii,
    t
  );
}
const $i = {}, Qi = i`
    query LoyaltyServiceLoyaltyTierByIdForAdmin($id: String!) {
        loyaltyServiceLoyaltyTierByIdForAdmin(id: $id) {
            id
            benefit {
                additionalBenefits
                discounts {
                    applicableCategoryIds
                    applicableProductIds
                    applicableServices
                    maximumDiscount
                    minimumPurchase
                    percentage
                    scope
                }
                exclusiveAccess
                freeServices
                prioritySupport
            }
            benefitDescriptions
            createdAt
            description
            iconUrl
            level
            maintenanceThreshold
            name
            pointEarnRuleDescription
            pointsMultiplier
            pointsThreshold
            spendingPerPoint
            spendingThreshold
            tenantId
            tierQualificationType
            updatedAt
            validityPeriod
        }
    }
`;
function eb(e) {
  const t = { ...$i, ...e };
  return n.useQuery(Qi, t);
}
function tb(e) {
  const t = { ...$i, ...e };
  return n.useLazyQuery(Qi, t);
}
function nb(e) {
  const t = e === n.skipToken ? e : { ...$i, ...e };
  return n.useSuspenseQuery(Qi, t);
}
const Ci = {}, hi = i`
    query LoyaltyServiceLoyaltyTierByUserId($userId: String!) {
        loyaltyServiceLoyaltyTierByUserId(userId: $userId) {
            id
            benefit {
                additionalBenefits
                discounts {
                    applicableCategoryIds
                    applicableProductIds
                    applicableServices
                    maximumDiscount
                    minimumPurchase
                    percentage
                    scope
                }
                exclusiveAccess
                freeServices
                prioritySupport
            }
            benefitDescriptions
            createdAt
            description
            iconUrl
            level
            maintenanceThreshold
            name
            pointEarnRuleDescription
            pointsMultiplier
            pointsThreshold
            spendingPerPoint
            spendingThreshold
            tenantId
            updatedAt
            validityPeriod
        }
    }
`;
function ib(e) {
  const t = { ...Ci, ...e };
  return n.useQuery(
    hi,
    t
  );
}
function rb(e) {
  const t = { ...Ci, ...e };
  return n.useLazyQuery(
    hi,
    t
  );
}
function sb(e) {
  const t = e === n.skipToken ? e : { ...Ci, ...e };
  return n.useSuspenseQuery(hi, t);
}
const HS = {}, NS = i`
    mutation LoyaltyServiceSetDefaultLoyaltyProgram($id: String!) {
        loyaltyServiceSetDefaultLoyaltyProgram(id: $id)
    }
`;
function ob(e) {
  const t = { ...HS, ...e };
  return n.useMutation(NS, t);
}
const WS = {}, jS = i`
    mutation LoyaltyServiceUpdateLoyaltyTier($input: LoyaltyServiceUpdateLoyaltyTierGqlInput!) {
        loyaltyServiceUpdateLoyaltyTier(input: $input)
    }
`;
function ab(e) {
  const t = { ...WS, ...e };
  return n.useMutation(jS, t);
}
const KS = {}, ZS = i`
    mutation MembershipServiceCreateMember($userId: String!) {
        membershipServiceCreateMember(userId: $userId) {
            createdAt
            cumulativeSpending
            currentTierId
            currentYearSpending
            id
            isActive
            isDeleted
            joinDate
            membershipNumber
            nextTierId
            pointsToNextTier
            spendingToNextTier
            tenantId
            updatedAt
            userId
        }
    }
`;
function ub(e) {
  const t = { ...KS, ...e };
  return n.useMutation(
    ZS,
    t
  );
}
const ki = {}, Di = i`
    query MembershipServiceMyMemberInfo {
        membershipServiceMyMemberInfo {
            createdAt
            cumulativeSpending
            currentTierId
            currentYearSpending
            id
            isActive
            isDeleted
            joinDate
            membershipNumber
            nextTierId
            pointsToNextTier
            spendingToNextTier
            tenantId
            tierExpiryDate
            updatedAt
            userId
        }
    }
`;
function cb(e) {
  const t = { ...ki, ...e };
  return n.useQuery(
    Di,
    t
  );
}
function db(e) {
  const t = { ...ki, ...e };
  return n.useLazyQuery(
    Di,
    t
  );
}
function pb(e) {
  const t = e === n.skipToken ? e : { ...ki, ...e };
  return n.useSuspenseQuery(
    Di,
    t
  );
}
const Pi = {}, Ti = i`
    query MembershipServiceMemberInfoByUserId($userId: String!) {
        membershipServiceMemberInfoByUserId(userId: $userId) {
            id
            userId
            tenantId
            membershipNumber
            isActive
            isDeleted
            joinDate
            currentTierId
            nextTierId
            pointsToNextTier
            spendingToNextTier
            cumulativeSpending
            currentYearSpending
            tierExpiryDate
            createdAt
            updatedAt
        }
    }
`;
function lb(e) {
  const t = { ...Pi, ...e };
  return n.useQuery(
    Ti,
    t
  );
}
function yb(e) {
  const t = { ...Pi, ...e };
  return n.useLazyQuery(Ti, t);
}
function Sb(e) {
  const t = e === n.skipToken ? e : { ...Pi, ...e };
  return n.useSuspenseQuery(Ti, t);
}
const YS = {}, JS = i`
    mutation MessageManagementServiceCreateOttSms($input: MessageManagementServiceCreateOttSmsGqlInput!) {
        messageManagementServiceCreateOttSms(input: $input) {
            success
            ottID
            error
            expiresIn
        }
    }
`;
function mb(e) {
  const t = { ...YS, ...e };
  return n.useMutation(JS, t);
}
const Mi = {}, bi = i`
    query MessageManagementServiceOttSmsList($params: MessageManagementServiceMessageLogParams!) {
        messageManagementServiceOttSmsList(params: $params) {
            id
            phone
            otpCode
            channel
            status
            expiredAt
            verifiedAt
            tenantID
            createdAt
            updatedAt
        }
    }
`;
function vb(e) {
  const t = { ...Mi, ...e };
  return n.useQuery(
    bi,
    t
  );
}
function gb(e) {
  const t = { ...Mi, ...e };
  return n.useLazyQuery(bi, t);
}
function fb(e) {
  const t = e === n.skipToken ? e : { ...Mi, ...e };
  return n.useSuspenseQuery(bi, t);
}
const _S = {}, XS = i`
    mutation MessageManagementServiceSendOttSms($input: MessageManagementServiceSendOttSmsGqlInput!) {
        messageManagementServiceSendOttSms(input: $input) {
            success
            messageID
            error
            message {
                id
                templateID
                templateType
                templateName
                templateContent
                phone
                templateData
                trackingID
                status
                zaloMsgID
                unitPrice
                errorCode
                errorMessage
                sentAt
                tenantID
                createdAt
                updatedAt
            }
        }
    }
`;
function Ab(e) {
  const t = { ..._S, ...e };
  return n.useMutation(XS, t);
}
const Li = {}, Bi = i`
    query MessageManagementServiceSmsMessageLogs($params: MessageManagementServiceMessageLogParams!) {
        messageManagementServiceSmsMessageLogs(params: $params) {
            messages {
                id
                phone
                message
                brandName
                trackingID
                status
                provider
                resultCode
                resultMessage
                messageID
                errorMessage
                sentAt
                tenantID
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function Ib(e) {
  const t = { ...Li, ...e };
  return n.useQuery(Bi, t);
}
function $b(e) {
  const t = { ...Li, ...e };
  return n.useLazyQuery(Bi, t);
}
function Qb(e) {
  const t = e === n.skipToken ? e : { ...Li, ...e };
  return n.useSuspenseQuery(Bi, t);
}
const em = {}, tm = i`
    mutation MessageManagementServiceSendSmsMessage($input: MessageManagementServiceSendSmsMessageGqlInput!) {
        messageManagementServiceSendSmsMessage(input: $input) {
            resultCode
            resultMessage
            messageID
            trackingID
            data
        }
    }
`;
function Cb(e) {
  const t = { ...em, ...e };
  return n.useMutation(tm, t);
}
const Ui = {}, zi = i`
    query MessageManagementServiceViberMessageLogs($params: MessageManagementServiceMessageLogParams!) {
        messageManagementServiceViberMessageLogs(params: $params) {
            messages {
                id
                phone
                message
                senderName
                trackingID
                status
                provider
                resultCode
                resultMessage
                messageID
                errorMessage
                sentAt
                tenantID
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function hb(e) {
  const t = { ...Ui, ...e };
  return n.useQuery(zi, t);
}
function kb(e) {
  const t = { ...Ui, ...e };
  return n.useLazyQuery(zi, t);
}
function Db(e) {
  const t = e === n.skipToken ? e : { ...Ui, ...e };
  return n.useSuspenseQuery(zi, t);
}
const nm = {}, im = i`
    mutation MessageManagementServiceSendViberMessage($input: MessageManagementServiceSendViberMessageGqlInput!) {
        messageManagementServiceSendViberMessage(input: $input) {
            resultCode
            resultMessage
            messageID
            trackingID
            data
        }
    }
`;
function Pb(e) {
  const t = { ...nm, ...e };
  return n.useMutation(im, t);
}
const rm = {}, sm = i`
    mutation MessageManagementServiceSendZnsMessage($input: MessageManagementServiceSendZnsMessageGqlInput!) {
        messageManagementServiceSendZnsMessage(input: $input) {
            resultCode
            resultMessage
            trackingID
            data
        }
    }
`;
function Tb(e) {
  const t = { ...rm, ...e };
  return n.useMutation(sm, t);
}
const om = {}, am = i`
    mutation MessageManagementServiceSoftDeleteZnsMessageLog($id: ID!) {
        messageManagementServiceSoftDeleteZnsMessageLog(id: $id)
    }
`;
function Mb(e) {
  const t = { ...om, ...e };
  return n.useMutation(am, t);
}
const Fi = {}, Ri = i`
    query MessageManagementServiceZnsMessageLogs($params: MessageManagementServiceMessageLogParams!) {
        messageManagementServiceZnsMessageLogs(params: $params) {
            messages {
                id
                templateID
                templateType
                templateName
                templateContent
                phone
                content
                templateData
                trackingID
                status
                provider
                resultCode
                resultMessage
                zaloMsgID
                unitPrice
                errorCode
                errorMessage
                sentAt
                tenantID
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function bb(e) {
  const t = { ...Fi, ...e };
  return n.useQuery(Ri, t);
}
function Lb(e) {
  const t = { ...Fi, ...e };
  return n.useLazyQuery(Ri, t);
}
function Bb(e) {
  const t = e === n.skipToken ? e : { ...Fi, ...e };
  return n.useSuspenseQuery(Ri, t);
}
const Gi = {}, qi = i`
    query MessageManagementServiceZnsTemplates($params: MessageManagementServiceZnsListParams) {
        messageManagementServiceZnsTemplates(params: $params) {
            templates {
                id
                templateID
                templateName
                templateType
                status
                listParams
                previewURL
                price
                tenantID
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function Ub(e) {
  const t = { ...Gi, ...e };
  return n.useQuery(qi, t);
}
function zb(e) {
  const t = { ...Gi, ...e };
  return n.useLazyQuery(qi, t);
}
function Fb(e) {
  const t = e === n.skipToken ? e : { ...Gi, ...e };
  return n.useSuspenseQuery(qi, t);
}
const Ei = {}, Vi = i`
    query MessageManagementServiceZnsTemplate($id: ID!) {
        messageManagementServiceZnsTemplate(id: $id) {
            id
            templateID
            templateName
            templateType
            status
            listParams
            previewURL
            price
            tenantID
            createdAt
            updatedAt
        }
    }
`;
function Rb(e) {
  const t = { ...Ei, ...e };
  return n.useQuery(
    Vi,
    t
  );
}
function Gb(e) {
  const t = { ...Ei, ...e };
  return n.useLazyQuery(Vi, t);
}
function qb(e) {
  const t = e === n.skipToken ? e : { ...Ei, ...e };
  return n.useSuspenseQuery(Vi, t);
}
const Oi = {}, xi = i`
    query MessageManagementServiceZnsTemplateByTemplateID($templateID: String!) {
        messageManagementServiceZnsTemplateByTemplateID(templateID: $templateID) {
            id
            templateID
            templateName
            templateType
            status
            listParams
            previewURL
            price
            tenantID
            createdAt
            updatedAt
        }
    }
`;
function Eb(e) {
  const t = { ...Oi, ...e };
  return n.useQuery(xi, t);
}
function Vb(e) {
  const t = { ...Oi, ...e };
  return n.useLazyQuery(xi, t);
}
function Ob(e) {
  const t = e === n.skipToken ? e : { ...Oi, ...e };
  return n.useSuspenseQuery(xi, t);
}
const um = {}, cm = i`
    mutation MessageManagementServiceSyncZnsTemplates {
        messageManagementServiceSyncZnsTemplates
    }
`;
function xb(e) {
  const t = { ...um, ...e };
  return n.useMutation(cm, t);
}
const wi = {}, Hi = i`
    query MessageManagementServiceOaAccountsAll($params: MessageManagementServiceOAListParams) {
        messageManagementServiceOaAccountsAll(params: $params) {
            accounts {
                id
                oaID
                name
                description
                avatar
                cover
                isVerified
                packageName
                packageValidThroughDate
                packageAutoRenewDate
                linkedZaloID
                status
                tenantID
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function wb(e) {
  const t = { ...wi, ...e };
  return n.useQuery(Hi, t);
}
function Hb(e) {
  const t = { ...wi, ...e };
  return n.useLazyQuery(Hi, t);
}
function Nb(e) {
  const t = e === n.skipToken ? e : { ...wi, ...e };
  return n.useSuspenseQuery(Hi, t);
}
const Ni = {}, Wi = i`
    query MessageManagementServiceOaAccounts($params: MessageManagementServiceOAListParams) {
        messageManagementServiceOaAccounts(params: $params) {
            accounts {
                id
                oaID
                name
                description
                avatar
                cover
                isVerified
                packageName
                packageValidThroughDate
                packageAutoRenewDate
                linkedZaloID
                status
                tenantID
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function Wb(e) {
  const t = { ...Ni, ...e };
  return n.useQuery(
    Wi,
    t
  );
}
function jb(e) {
  const t = { ...Ni, ...e };
  return n.useLazyQuery(Wi, t);
}
function Kb(e) {
  const t = e === n.skipToken ? e : { ...Ni, ...e };
  return n.useSuspenseQuery(Wi, t);
}
const ji = {}, Ki = i`
    query MessageManagementServiceOaDetail($id: ID!) {
        messageManagementServiceOaDetail(id: $id) {
            id
            oaID
            name
            description
            avatar
            cover
            isVerified
            packageName
            packageValidThroughDate
            packageAutoRenewDate
            linkedZaloID
            status
            tenantID
            createdAt
            updatedAt
        }
    }
`;
function Zb(e) {
  const t = { ...ji, ...e };
  return n.useQuery(
    Ki,
    t
  );
}
function Yb(e) {
  const t = { ...ji, ...e };
  return n.useLazyQuery(
    Ki,
    t
  );
}
function Jb(e) {
  const t = e === n.skipToken ? e : { ...ji, ...e };
  return n.useSuspenseQuery(Ki, t);
}
const dm = {}, pm = i`
    mutation MessageManagementServiceCreateOAAccount($input: MessageManagementServiceCreateOAAccountGqlInput!) {
        messageManagementServiceCreateOAAccount(input: $input) {
            id
            oaID
            name
            description
            avatar
            cover
            isVerified
            packageName
            packageValidThroughDate
            packageAutoRenewDate
            linkedZaloID
            status
            tenantID
            createdAt
            updatedAt
        }
    }
`;
function _b(e) {
  const t = { ...dm, ...e };
  return n.useMutation(pm, t);
}
const lm = {}, ym = i`
    mutation MessageManagementServiceSyncOAAccounts {
        messageManagementServiceSyncOAAccounts
    }
`;
function Xb(e) {
  const t = { ...lm, ...e };
  return n.useMutation(ym, t);
}
const Zi = {}, Yi = i`
    query MessageManagementServiceSystemHealth {
        messageManagementServiceSystemHealth {
            status
            uptime
            version
            mongodb {
                status
                responseTime
                error
            }
            redis {
                status
                responseTime
                error
            }
            zaloAPI {
                status
                responseTime
                error
            }
            timestamp
        }
    }
`;
function eL(e) {
  const t = { ...Zi, ...e };
  return n.useQuery(Yi, t);
}
function tL(e) {
  const t = { ...Zi, ...e };
  return n.useLazyQuery(Yi, t);
}
function nL(e) {
  const t = e === n.skipToken ? e : { ...Zi, ...e };
  return n.useSuspenseQuery(Yi, t);
}
const Ji = {}, _i = i`
    query MessageManagementServiceSystemSettings {
        messageManagementServiceSystemSettings {
            id
            key
            value
            description
            isEditable
            updatedAt
        }
    }
`;
function iL(e) {
  const t = { ...Ji, ...e };
  return n.useQuery(_i, t);
}
function rL(e) {
  const t = { ...Ji, ...e };
  return n.useLazyQuery(_i, t);
}
function sL(e) {
  const t = e === n.skipToken ? e : { ...Ji, ...e };
  return n.useSuspenseQuery(_i, t);
}
const Sm = {}, mm = i`
    mutation MessageManagementServiceVerifyOtp($phone: String!, $otpCode: String!) {
        messageManagementServiceVerifyOtp(phone: $phone, otpCode: $otpCode) {
            success
            error
            remainingAttempts
        }
    }
`;
function oL(e) {
  const t = { ...Sm, ...e };
  return n.useMutation(mm, t);
}
const vm = {}, gm = i`
    mutation MinigamesServiceAddAnswer($input: MinigamesServiceAddAnswerInput!) {
        minigamesServiceAddAnswer(input: $input) {
            answers {
                createdAt
                id
                imageUrl
                isActive
                isCorrect
                order
                questionId
                text
                updatedAt
            }
            audioUrl
            campaignId
            content
            correctAnswerIds
            createdAt
            explanation
            id
            isActive
            mediaUrl
            metadata
            order
            passage
            points
            presentationType
            questionType
            tenantId
            updatedAt
            videoUrl
        }
    }
`;
function aL(e) {
  const t = { ...vm, ...e };
  return n.useMutation(
    gm,
    t
  );
}
const fm = {}, Am = i`
    mutation MinigamesServiceAddPrize($input: MinigamesServiceAddPrizeInput!) {
        minigamesServiceAddPrize(input: $input) {
            campaignId
            createdAt
            displayName
            id
            isActive
            mediaUrls
            pointsAmount
            prizeType
            probability
            productId
            quantity
            remainingQuantity
            tenantId
            updatedAt
        }
    }
`;
function uL(e) {
  const t = { ...fm, ...e };
  return n.useMutation(
    Am,
    t
  );
}
const Im = {}, $m = i`
    mutation MinigamesServiceConfirmPrizeDelivery($gameRecordId: String!) {
        minigamesServiceConfirmPrizeDelivery(gameRecordId: $gameRecordId) {
            campaignId
            codeId
            createdAt
            guestName
            guestPhone
            id
            playerType
            prize {
                displayName
                mediaUrls
                productId
                type
                voucherId
            }
            prizeDelivered
            prizeDeliveredAt
            score
            tenantId
            updatedAt
            userId
        }
    }
`;
function cL(e) {
  const t = { ...Im, ...e };
  return n.useMutation($m, t);
}
const Qm = {}, Cm = i`
    mutation MinigamesServiceCreateCampaign($input: MinigamesServiceCreateCampaignInput!) {
        minigamesServiceCreateCampaign(input: $input) {
            authenticationRequired
            createdAt
            createdBy
            description
            distributionType
            enablePrizeSystem
            enableTierSystem
            endDate
            gameConfig
            howToPlay
            id
            maxPlaysPerUser
            name
            playCodeRequired
            prizes {
                id
                probability
            }
            rules
            startDate
            status
            templateId
            tenantId
            thumbnailUrl
            uiConfig
            updatedAt
        }
    }
`;
function dL(e) {
  const t = { ...Qm, ...e };
  return n.useMutation(
    Cm,
    t
  );
}
const hm = {}, km = i`
    mutation MinigamesServiceCreateGameTemplate($input: MinigamesServiceCreateGameTemplateInput!) {
        minigamesServiceCreateGameTemplate(input: $input) {
            authenticationRequired
            createdAt
            distributionType
            enablePrizeSystem
            enableTierSystem
            gameConfig
            gameType
            howToPlay
            id
            isActive
            maxPlaysPerUser
            playCodeRequired
            rules
            templateName
            tenantId
            thumbnailUrl
            uiConfig
            updatedAt
        }
    }
`;
function pL(e) {
  const t = { ...hm, ...e };
  return n.useMutation(km, t);
}
const Dm = {}, Pm = i`
    mutation MinigamesServiceCreateQuestion($input: MinigamesServiceCreateQuestionInput!) {
        minigamesServiceCreateQuestion(input: $input) {
            answers {
                createdAt
                id
                imageUrl
                isActive
                isCorrect
                order
                questionId
                text
                updatedAt
            }
            audioUrl
            campaignId
            content
            correctAnswerIds
            createdAt
            explanation
            id
            isActive
            mediaUrl
            metadata
            order
            passage
            points
            presentationType
            questionType
            tenantId
            updatedAt
            videoUrl
        }
    }
`;
function lL(e) {
  const t = { ...Dm, ...e };
  return n.useMutation(
    Pm,
    t
  );
}
const Tm = {}, Mm = i`
    mutation MinigamesServiceDeleteAnswer($id: String!) {
        minigamesServiceDeleteAnswer(id: $id)
    }
`;
function yL(e) {
  const t = { ...Tm, ...e };
  return n.useMutation(
    Mm,
    t
  );
}
const bm = {}, Lm = i`
    mutation MinigamesServiceDeleteCampaign($id: String!) {
        minigamesServiceDeleteCampaign(id: $id)
    }
`;
function SL(e) {
  const t = { ...bm, ...e };
  return n.useMutation(
    Lm,
    t
  );
}
const Bm = {}, Um = i`
    mutation MinigamesServiceDeletePrize($id: String!) {
        minigamesServiceDeletePrize(id: $id)
    }
`;
function mL(e) {
  const t = { ...Bm, ...e };
  return n.useMutation(
    Um,
    t
  );
}
const zm = {}, Fm = i`
    mutation MinigamesServiceDeleteQuestion($id: String!) {
        minigamesServiceDeleteQuestion(id: $id)
    }
`;
function vL(e) {
  const t = { ...zm, ...e };
  return n.useMutation(
    Fm,
    t
  );
}
const Rm = {}, Gm = i`
    mutation MinigamesServiceGenerateCodes($input: MinigamesServiceGenerateCodesInput!) {
        minigamesServiceGenerateCodes(input: $input) {
            campaignId
            code
            createdAt
            gameplayId
            id
            isUsed
            tenantId
            updatedAt
            usedAt
        }
    }
`;
function gL(e) {
  const t = { ...Rm, ...e };
  return n.useMutation(
    Gm,
    t
  );
}
const qm = {}, Em = i`
    mutation MinigamesServicePlayGame($input: MinigamesServicePlayGameInput!) {
        minigamesServicePlayGame(input: $input) {
            gameRecordId
            prize {
                productId
                type
                voucherId
            }
        }
    }
`;
function fL(e) {
  const t = { ...qm, ...e };
  return n.useMutation(
    Em,
    t
  );
}
const Vm = {}, Om = i`
    mutation MinigamesServicePlayGameAsGuest($input: MinigamesServicePlayGameInput!) {
        minigamesServicePlayGameAsGuest(input: $input) {
            gameRecordId
            prize {
                productId
                type
                voucherId
            }
        }
    }
`;
function AL(e) {
  const t = { ...Vm, ...e };
  return n.useMutation(Om, t);
}
const xm = {}, wm = i`
    mutation MinigamesServiceSetPrizeProbabilities($input: MinigamesServiceSetPrizeProbabilitiesInput!) {
        minigamesServiceSetPrizeProbabilities(input: $input) {
            campaignId
            createdAt
            id
            isActive
            pointsAmount
            prizeType
            probability
            productId
            quantity
            remainingQuantity
            tenantId
            updatedAt
        }
    }
`;
function IL(e) {
  const t = { ...xm, ...e };
  return n.useMutation(wm, t);
}
const Hm = {}, Nm = i`
    mutation MinigamesServiceSetWheelSlots($input: MinigamesServiceSetWheelSlotsInput!) {
        minigamesServiceSetWheelSlots(input: $input) {
            campaignId
            createdAt
            id
            isActive
            position
            prize {
                campaignId
                createdAt
                displayName
                id
                isActive
                mediaUrls
                pointsAmount
                prizeType
                probability
                productId
                quantity
                remainingQuantity
                sku
                tenantId
                updatedAt
            }
            tenantId
            updatedAt
        }
    }
`;
function $L(e) {
  const t = { ...Hm, ...e };
  return n.useMutation(
    Nm,
    t
  );
}
const Wm = {}, jm = i`
    mutation MinigamesServiceSubmitQuizAnswers($input: MinigamesServiceSubmitQuizAnswersInput!) {
        minigamesServiceSubmitQuizAnswers(input: $input) {
            currentTotalScore
            gameRecordId
            isLastQuestion
            maxScore
            passed
            prize {
                productId
                type
                voucherId
            }
            questionResults {
                correctAnswerIds
                explanation
                isCorrect
                pointsEarned
                questionId
            }
            tier
        }
    }
`;
function QL(e) {
  const t = { ...Wm, ...e };
  return n.useMutation(jm, t);
}
const Km = {}, Zm = i`
    mutation MinigamesServiceUpdateAnswer($id: String!, $input: MinigamesServiceUpdateAnswerInput!) {
        minigamesServiceUpdateAnswer(id: $id, input: $input) {
            answers {
                createdAt
                id
                imageUrl
                isActive
                isCorrect
                order
                questionId
                text
                updatedAt
            }
            audioUrl
            campaignId
            content
            correctAnswerIds
            createdAt
            explanation
            id
            isActive
            mediaUrl
            metadata
            order
            passage
            points
            presentationType
            questionType
            tenantId
            updatedAt
            videoUrl
        }
    }
`;
function CL(e) {
  const t = { ...Km, ...e };
  return n.useMutation(
    Zm,
    t
  );
}
const Ym = {}, Jm = i`
    mutation MinigamesServiceUpdateCampaign($id: String!, $input: MinigamesServiceUpdateCampaignInput!) {
        minigamesServiceUpdateCampaign(id: $id, input: $input) {
            authenticationRequired
            createdAt
            createdBy
            description
            distributionType
            enablePrizeSystem
            enableTierSystem
            endDate
            gameConfig
            howToPlay
            id
            maxPlaysPerUser
            name
            playCodeRequired
            prizes {
                id
                probability
            }
            rules
            startDate
            status
            templateId
            tenantId
            thumbnailUrl
            uiConfig
            updatedAt
        }
    }
`;
function hL(e) {
  const t = { ...Ym, ...e };
  return n.useMutation(
    Jm,
    t
  );
}
const _m = {}, Xm = i`
    mutation MinigamesServiceUpdateCampaignStatus($id: String!, $input: MinigamesServiceUpdateCampaignStatusInput!) {
        minigamesServiceUpdateCampaignStatus(id: $id, input: $input) {
            authenticationRequired
            createdAt
            createdBy
            description
            distributionType
            enablePrizeSystem
            enableTierSystem
            endDate
            gameConfig
            howToPlay
            id
            maxPlaysPerUser
            name
            playCodeRequired
            prizes {
                id
                probability
            }
            rules
            startDate
            status
            templateId
            tenantId
            thumbnailUrl
            uiConfig
            updatedAt
        }
    }
`;
function kL(e) {
  const t = { ..._m, ...e };
  return n.useMutation(Xm, t);
}
const ev = {}, tv = i`
    mutation MinigamesServiceUpdatePrize($id: String!, $input: MinigamesServiceUpdatePrizeInput!) {
        minigamesServiceUpdatePrize(id: $id, input: $input) {
            campaignId
            createdAt
            displayName
            id
            isActive
            mediaUrls
            pointsAmount
            prizeType
            probability
            productId
            quantity
            remainingQuantity
            tenantId
            updatedAt
        }
    }
`;
function DL(e) {
  const t = { ...ev, ...e };
  return n.useMutation(
    tv,
    t
  );
}
const Xi = {}, er = i`
    query MinigamesServiceGetActiveCampaigns {
        minigamesServiceGetActiveCampaigns {
            authenticationRequired
            createdAt
            createdBy
            description
            distributionType
            endDate
            gameConfig
            id
            maxPlaysPerUser
            name
            playCodeRequired
            startDate
            status
            templateId
            tenantId
            uiConfig
            updatedAt
        }
    }
`;
function PL(e) {
  const t = { ...Xi, ...e };
  return n.useQuery(
    er,
    t
  );
}
function TL(e) {
  const t = { ...Xi, ...e };
  return n.useLazyQuery(er, t);
}
function ML(e) {
  const t = e === n.skipToken ? e : { ...Xi, ...e };
  return n.useSuspenseQuery(er, t);
}
const tr = {}, nr = i`
    query MinigamesServiceGetAllCampaigns($pagination: PaginationArgs!) {
        minigamesServiceGetAllCampaigns(pagination: $pagination) {
            data {
                authenticationRequired
                createdAt
                createdBy
                description
                distributionType
                endDate
                gameConfig
                id
                maxPlaysPerUser
                name
                playCodeRequired
                startDate
                status
                templateId
                tenantId
                uiConfig
                updatedAt
            }
            total
        }
    }
`;
function bL(e) {
  const t = { ...tr, ...e };
  return n.useQuery(
    nr,
    t
  );
}
function LL(e) {
  const t = { ...tr, ...e };
  return n.useLazyQuery(
    nr,
    t
  );
}
function BL(e) {
  const t = e === n.skipToken ? e : { ...tr, ...e };
  return n.useSuspenseQuery(
    nr,
    t
  );
}
const ir = {}, rr = i`
    query MinigamesServiceGetCampaign($id: String!) {
        minigamesServiceGetCampaign(id: $id) {
            authenticationRequired
            createdAt
            createdBy
            description
            distributionType
            enablePrizeSystem
            enableTierSystem
            endDate
            gameConfig
            gameType
            howToPlay
            id
            maxPlaysPerUser
            name
            playCodeRequired
            prizes {
                displayName
                id
                probability
            }
            rules
            startDate
            status
            templateId
            tenantId
            thumbnailUrl
            totalPlayers
            totalPlays
            uiConfig
            updatedAt
        }
    }
`;
function UL(e) {
  const t = { ...ir, ...e };
  return n.useQuery(
    rr,
    t
  );
}
function zL(e) {
  const t = { ...ir, ...e };
  return n.useLazyQuery(
    rr,
    t
  );
}
function FL(e) {
  const t = e === n.skipToken ? e : { ...ir, ...e };
  return n.useSuspenseQuery(
    rr,
    t
  );
}
const sr = {}, or = i`
    query MinigamesServiceGetCampaignInfo($id: String!) {
        minigamesServiceGetCampaignInfo(id: $id) {
            description
            endDate
            gameConfig
            gameType
            howToPlay
            id
            name
            prizes {
                displayName
                id
                probability
            }
            rules
            startDate
            status
            thumbnailUrl
            uiConfig
        }
    }
`;
function RL(e) {
  const t = { ...sr, ...e };
  return n.useQuery(
    or,
    t
  );
}
function GL(e) {
  const t = { ...sr, ...e };
  return n.useLazyQuery(
    or,
    t
  );
}
function qL(e) {
  const t = e === n.skipToken ? e : { ...sr, ...e };
  return n.useSuspenseQuery(
    or,
    t
  );
}
const ar = {}, ur = i`
    query MinigamesServiceGetCampaignCodes($id: String!, $pagination: PaginationArgs!) {
        minigamesServiceGetCampaignCodes(id: $id, pagination: $pagination) {
            data {
                campaignId
                code
                createdAt
                gameplayId
                id
                isUsed
                tenantId
                updatedAt
                usedAt
            }
            total
        }
    }
`;
function EL(e) {
  const t = { ...ar, ...e };
  return n.useQuery(
    ur,
    t
  );
}
function VL(e) {
  const t = { ...ar, ...e };
  return n.useLazyQuery(
    ur,
    t
  );
}
function OL(e) {
  const t = e === n.skipToken ? e : { ...ar, ...e };
  return n.useSuspenseQuery(ur, t);
}
const cr = {}, dr = i`
    query MinigamesServiceGetCampaignPrizes($id: String!, $pagination: PaginationArgs!) {
        minigamesServiceGetCampaignPrizes(id: $id, pagination: $pagination) {
            data {
                campaignId
                createdAt
                displayName
                id
                isActive
                mediaUrls
                pointsAmount
                prizeType
                probability
                productId
                quantity
                remainingQuantity
                tenantId
                updatedAt
            }
            total
        }
    }
`;
function xL(e) {
  const t = { ...cr, ...e };
  return n.useQuery(
    dr,
    t
  );
}
function wL(e) {
  const t = { ...cr, ...e };
  return n.useLazyQuery(
    dr,
    t
  );
}
function HL(e) {
  const t = e === n.skipToken ? e : { ...cr, ...e };
  return n.useSuspenseQuery(dr, t);
}
const pr = {}, lr = i`
    query MinigamesServiceGetGameRecords($input: MinigamesServiceGameRecordFilterInput!, $pagination: PaginationArgs!) {
        minigamesServiceGetGameRecords(input: $input, pagination: $pagination) {
            data {
                campaignId
                codeId
                createdAt
                guestName
                guestPhone
                id
                playerType
                prize {
                    displayName
                    mediaUrls
                    productId
                    type
                    voucherId
                }
                prizeDelivered
                prizeDeliveredAt
                score
                tenantId
                updatedAt
                userId
            }
            total
        }
    }
`;
function NL(e) {
  const t = { ...pr, ...e };
  return n.useQuery(
    lr,
    t
  );
}
function WL(e) {
  const t = { ...pr, ...e };
  return n.useLazyQuery(
    lr,
    t
  );
}
function jL(e) {
  const t = e === n.skipToken ? e : { ...pr, ...e };
  return n.useSuspenseQuery(
    lr,
    t
  );
}
const yr = {}, Sr = i`
    query MinigamesServiceGetGameTemplates {
        minigamesServiceGetGameTemplates {
            authenticationRequired
            createdAt
            distributionType
            enablePrizeSystem
            enableTierSystem
            gameConfig
            gameType
            howToPlay
            id
            isActive
            isDeleted
            maxPlaysPerUser
            playCodeRequired
            rules
            templateName
            tenantId
            thumbnailUrl
            uiConfig
            updatedAt
        }
    }
`;
function KL(e) {
  const t = { ...yr, ...e };
  return n.useQuery(
    Sr,
    t
  );
}
function ZL(e) {
  const t = { ...yr, ...e };
  return n.useLazyQuery(
    Sr,
    t
  );
}
function YL(e) {
  const t = e === n.skipToken ? e : { ...yr, ...e };
  return n.useSuspenseQuery(Sr, t);
}
const mr = {}, vr = i`
    query MinigamesServiceGetMyGameHistory(
        $input: MinigamesServiceUserGameHistoryInput!
        $pagination: PaginationArgs!
    ) {
        minigamesServiceGetMyGameHistory(input: $input, pagination: $pagination) {
            data {
                campaignId
                campaignName
                campaignThumbnail
                gameType
                id
                playedAt
                prize {
                    displayName
                    mediaUrls
                    productId
                    type
                    voucherId
                }
                prizeDelivered
                prizeDeliveredAt
            }
            total
        }
    }
`;
function JL(e) {
  const t = { ...mr, ...e };
  return n.useQuery(
    vr,
    t
  );
}
function _L(e) {
  const t = { ...mr, ...e };
  return n.useLazyQuery(
    vr,
    t
  );
}
function XL(e) {
  const t = e === n.skipToken ? e : { ...mr, ...e };
  return n.useSuspenseQuery(vr, t);
}
const gr = {}, fr = i`
    query MinigamesServiceGetQuestion($id: String!) {
        minigamesServiceGetQuestion(id: $id) {
            answers {
                createdAt
                id
                imageUrl
                isActive
                isCorrect
                order
                questionId
                text
                updatedAt
            }
            audioUrl
            campaignId
            content
            correctAnswerIds
            createdAt
            explanation
            id
            isActive
            mediaUrl
            metadata
            order
            passage
            points
            presentationType
            questionType
            tenantId
            updatedAt
            videoUrl
        }
    }
`;
function eB(e) {
  const t = { ...gr, ...e };
  return n.useQuery(
    fr,
    t
  );
}
function tB(e) {
  const t = { ...gr, ...e };
  return n.useLazyQuery(
    fr,
    t
  );
}
function nB(e) {
  const t = e === n.skipToken ? e : { ...gr, ...e };
  return n.useSuspenseQuery(
    fr,
    t
  );
}
const Ar = {}, Ir = i`
    query MinigamesServiceGetQuestionsByCampaign($id: String!, $pagination: PaginationArgs!) {
        minigamesServiceGetQuestionsByCampaign(id: $id, pagination: $pagination) {
            data {
                answers {
                    createdAt
                    id
                    imageUrl
                    isActive
                    isCorrect
                    order
                    questionId
                    text
                    updatedAt
                }
                audioUrl
                campaignId
                content
                correctAnswerIds
                createdAt
                explanation
                id
                isActive
                mediaUrl
                metadata
                order
                passage
                points
                presentationType
                questionType
                tenantId
                updatedAt
                videoUrl
            }
            total
        }
    }
`;
function iB(e) {
  const t = { ...Ar, ...e };
  return n.useQuery(Ir, t);
}
function rB(e) {
  const t = { ...Ar, ...e };
  return n.useLazyQuery(Ir, t);
}
function sB(e) {
  const t = e === n.skipToken ? e : { ...Ar, ...e };
  return n.useSuspenseQuery(Ir, t);
}
const $r = {}, Qr = i`
    query MinigamesServiceGetQuizQuestionsForPlay($input: MinigamesServiceGetQuizQuestionsForPlayInput!) {
        minigamesServiceGetQuizQuestionsForPlay(input: $input) {
            allowShuffle
            campaignId
            questions {
                answers {
                    id
                    imageUrl
                    order
                    text
                }
                content
                id
                mediaUrl
                order
                passage
                points
                presentationType
                questionType
            }
            quizMode
            showExplanation
            timeLimit
        }
    }
`;
function oB(e) {
  const t = { ...$r, ...e };
  return n.useQuery(Qr, t);
}
function aB(e) {
  const t = { ...$r, ...e };
  return n.useLazyQuery(Qr, t);
}
function uB(e) {
  const t = e === n.skipToken ? e : { ...$r, ...e };
  return n.useSuspenseQuery(Qr, t);
}
const nv = {}, iv = i`
    mutation OrderServiceApplyVoucher($input: OrderServiceCreateGqlInput!) {
        orderServiceApplyVoucher(input: $input) {
            id
            userId
            tenantId
            branchId
            type
            status
            currency
            productTotalAmount
            productTotalAmountFormatted
            discountAmount
            discountAmountFormatted
            shippingFee
            shippingFeeFormatted
            totalAmount
            totalAmountFormatted
            paymentMethod
            paymentStatus
            shippingStatus
            vouchers
            promotionId
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                }
            }
            shippingAddress {
                name
                phone
                address
                province
                ward
            }
            payment {
                transactionId
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
            }
            shippingMethod
            shippingNote
            createdAt
            updatedAt
        }
    }
`;
function cB(e) {
  const t = { ...nv, ...e };
  return n.useMutation(
    iv,
    t
  );
}
const rv = {}, sv = i`
    mutation OrderServiceCancelOrder($orderId: String!) {
        orderServiceCancelOrder(orderId: $orderId) {
            id
            userId
            tenantId
            branchId
            type
            status
            currency
            productTotalAmount
            productTotalAmountFormatted
            discountAmount
            discountAmountFormatted
            shippingFee
            shippingFeeFormatted
            totalAmount
            totalAmountFormatted
            paymentMethod
            paymentStatus
            shippingStatus
            vouchers
            promotionId
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                }
            }
            shippingAddress {
                name
                phone
                address
                province
                ward
            }
            payment {
                transactionId
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
            }
            shippingMethod
            shippingNote
            createdAt
            updatedAt
        }
    }
`;
function dB(e) {
  const t = { ...rv, ...e };
  return n.useMutation(
    sv,
    t
  );
}
const ov = {}, av = i`
    mutation OrderServiceConfirmOrder($input: OrderServiceDetailGqlInput!) {
        orderServiceConfirmOrder(input: $input)
    }
`;
function pB(e) {
  const t = { ...ov, ...e };
  return n.useMutation(
    av,
    t
  );
}
const uv = {}, cv = i`
    mutation OrderServiceCreateBookingOrder($input: OrderServiceCreateBookingGqlInput!) {
        orderServiceCreateBookingOrder(input: $input) {
            id
            userId
            tenantId
            branchId
            type
            status
            currency
            productTotalAmount
            productTotalAmountFormatted
            discountAmount
            discountAmountFormatted
            shippingFee
            shippingFeeFormatted
            totalAmount
            totalAmountFormatted
            paymentMethod
            paymentStatus
            shippingStatus
            vouchers
            promotionId
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                }
            }
            shippingAddress {
                name
                phone
                address
                province
                ward
            }
            payment {
                transactionId
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
            }
            shippingMethod
            shippingNote
            createdAt
            updatedAt
        }
    }
`;
function lB(e) {
  const t = { ...uv, ...e };
  return n.useMutation(
    cv,
    t
  );
}
const dv = {}, pv = i`
    mutation OrderServiceCreateOrder($input: OrderServiceCreateGqlInput!) {
        orderServiceCreateOrder(input: $input) {
            id
            userId
            tenantId
            branchId
            type
            status
            currency
            productTotalAmount
            productTotalAmountFormatted
            discountAmount
            discountAmountFormatted
            shippingFee
            shippingFeeFormatted
            totalAmount
            totalAmountFormatted
            paymentMethod
            paymentStatus
            shippingStatus
            vouchers
            promotionId
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                }
            }
            shippingAddress {
                name
                phone
                address
                province
                ward
            }
            payment {
                transactionId
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
            }
            shippingMethod
            shippingNote
            createdAt
            updatedAt
        }
    }
`;
function yB(e) {
  const t = { ...dv, ...e };
  return n.useMutation(
    pv,
    t
  );
}
const lv = {}, yv = i`
    mutation OrderServiceDeleteOrder($input: OrderServiceDeleteGqlInput!) {
        orderServiceDeleteOrder(input: $input)
    }
`;
function SB(e) {
  const t = { ...lv, ...e };
  return n.useMutation(
    yv,
    t
  );
}
const Cr = {}, hr = i`
    query OrderServiceGetOrder($input: OrderServiceDetailGqlInput!) {
        orderServiceGetOrder(input: $input) {
            branchId
            createdAt
            currency
            discountAmount
            discountAmountFormatted
            id
            payment {
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
                transactionId
            }
            paymentMethod
            paymentStatus
            productTotalAmount
            productTotalAmountFormatted
            point
            pointAmount
            pointAmountFormatted
            products {
                currency
                name
                price
                priceFormatted
                productId
                quantity
                thumbnailUrl
                variant {
                    attributeKey
                    attributeValue
                    name
                    price
                    priceFormatted
                    sku
                }
            }
            promotionId
            shippingAddress {
                address
                name
                phone
                province
                ward
            }
            shippingFee
            shippingFeeFormatted
            shippingMethod
            shippingNote
            shippingStatus
            status
            tenantId
            totalAmount
            totalAmountFormatted
            type
            updatedAt
            userId
            vouchers
        }
    }
`;
function mB(e) {
  const t = { ...Cr, ...e };
  return n.useQuery(
    hr,
    t
  );
}
function vB(e) {
  const t = { ...Cr, ...e };
  return n.useLazyQuery(
    hr,
    t
  );
}
function gB(e) {
  const t = e === n.skipToken ? e : { ...Cr, ...e };
  return n.useSuspenseQuery(
    hr,
    t
  );
}
const kr = {}, Dr = i`
    query OrderServiceGetOrderHistories($input: OrderServiceGetOrderHistoryGqlInput!) {
        orderServiceGetOrderHistories(input: $input) {
            comment
            createdAt
            description
            id
            orderId
            paymentStatus
            shippingStatus
            status
            tenantId
            updatedBy
        }
    }
`;
function fB(e) {
  const t = { ...kr, ...e };
  return n.useQuery(
    Dr,
    t
  );
}
function AB(e) {
  const t = { ...kr, ...e };
  return n.useLazyQuery(
    Dr,
    t
  );
}
function IB(e) {
  const t = e === n.skipToken ? e : { ...kr, ...e };
  return n.useSuspenseQuery(
    Dr,
    t
  );
}
const Pr = {}, Tr = i`
    query OrderServiceGetOrders($input: OrderServiceGetGqlInput!) {
        orderServiceGetOrders(input: $input) {
            branchId
            createdAt
            currency
            discountAmount
            discountAmountFormatted
            id
            payment {
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
                transactionId
            }
            paymentMethod
            paymentStatus
            productTotalAmount
            productTotalAmountFormatted
            point
            pointAmount
            pointAmountFormatted
            products {
                currency
                name
                price
                priceFormatted
                productId
                quantity
                thumbnailUrl
                variant {
                    attributeKey
                    attributeValue
                    name
                    price
                    priceFormatted
                    sku
                }
            }
            promotionId
            shippingAddress {
                address
                name
                phone
                province
                ward
            }
            shippingFee
            shippingFeeFormatted
            shippingMethod
            shippingNote
            shippingStatus
            status
            tenantId
            totalAmount
            totalAmountFormatted
            type
            updatedAt
            userId
            vouchers
        }
    }
`;
function $B(e) {
  const t = { ...Pr, ...e };
  return n.useQuery(
    Tr,
    t
  );
}
function QB(e) {
  const t = { ...Pr, ...e };
  return n.useLazyQuery(
    Tr,
    t
  );
}
function CB(e) {
  const t = e === n.skipToken ? e : { ...Pr, ...e };
  return n.useSuspenseQuery(
    Tr,
    t
  );
}
const Mr = {}, br = i`
    query OrderServiceOrganizationGetOrders($input: OrderServiceGetGqlInput!) {
        orderServiceOrganizationGetOrders(input: $input) {
            code
            branchId
            createdAt
            currency
            discountAmount
            discountAmountFormatted
            id
            payment {
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
                transactionId
            }
            paymentMethod
            paymentStatus
            productTotalAmount
            productTotalAmountFormatted
            point
            pointAmount
            pointAmountFormatted
            products {
                currency
                name
                price
                priceFormatted
                productId
                quantity
                thumbnailUrl
                variant {
                    attributeKey
                    attributeValue
                    name
                    price
                    priceFormatted
                    sku
                }
            }
            promotionId
            shippingAddress {
                address
                name
                phone
                province
                ward
            }
            shippingFee
            shippingFeeFormatted
            shippingMethod
            shippingNote
            shippingStatus
            status
            tenantId
            totalAmount
            totalAmountFormatted
            type
            updatedAt
            userId
            vouchers
        }
    }
`;
function hB(e) {
  const t = { ...Mr, ...e };
  return n.useQuery(
    br,
    t
  );
}
function kB(e) {
  const t = { ...Mr, ...e };
  return n.useLazyQuery(
    br,
    t
  );
}
function DB(e) {
  const t = e === n.skipToken ? e : { ...Mr, ...e };
  return n.useSuspenseQuery(br, t);
}
const Sv = {}, mv = i`
    mutation OrderServiceUpdateOrderStatus($input: OrderServiceUpdateStatusGqlInput!) {
        orderServiceUpdateOrderStatus(input: $input)
    }
`;
function PB(e) {
  const t = { ...Sv, ...e };
  return n.useMutation(
    mv,
    t
  );
}
const vv = {}, gv = i`
    mutation OrderServiceUpdateShipping($input: OrderServiceUpdateShippingGqlInput!) {
        orderServiceUpdateShipping(input: $input) {
            id
            userId
            tenantId
            branchId
            type
            status
            currency
            productTotalAmount
            productTotalAmountFormatted
            discountAmount
            discountAmountFormatted
            shippingFee
            shippingFeeFormatted
            totalAmount
            totalAmountFormatted
            paymentMethod
            paymentStatus
            shippingStatus
            vouchers
            promotionId
            products {
                productId
                name
                price
                priceFormatted
                currency
                quantity
                thumbnailUrl
                variant {
                    name
                    sku
                    price
                    priceFormatted
                    attributeKey
                    attributeValue
                }
            }
            shippingAddress {
                name
                phone
                address
                province
                ward
            }
            payment {
                transactionId
                amountPaid
                amountPaidFormatted
                paidAt
                refundId
            }
            shippingMethod
            shippingNote
            createdAt
            updatedAt
        }
    }
`;
function TB(e) {
  const t = { ...vv, ...e };
  return n.useMutation(
    gv,
    t
  );
}
const Lr = {}, Br = i`
    query OrganizationServiceAdminAllOrganizations($input: OrganizationServiceGetOrganizationsGqlInput!) {
        organizationServiceAdminAllOrganizations(input: $input) {
            createdAt
            createdBy
            deletedAt
            id
            name
            logo
            isEnterprise
            status
            updatedAt
        }
    }
`;
function MB(e) {
  const t = { ...Lr, ...e };
  return n.useQuery(Br, t);
}
function bB(e) {
  const t = { ...Lr, ...e };
  return n.useLazyQuery(Br, t);
}
function LB(e) {
  const t = e === n.skipToken ? e : { ...Lr, ...e };
  return n.useSuspenseQuery(Br, t);
}
const fv = {}, Av = i`
    mutation OrganizationServiceAdminCreateOrganization($input: OrganizationServiceCreateOrganizationGqlInput!) {
        organizationServiceAdminCreateOrganization(input: $input) {
            id
            name
            logo
            isEnterprise
            status
            createdBy
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function BB(e) {
  const t = { ...fv, ...e };
  return n.useMutation(Av, t);
}
const Ur = {}, zr = i`
    query OrganizationServiceAdminOrganizationById($id: String!) {
        organizationServiceAdminOrganizationById(id: $id) {
            createdAt
            createdBy
            deletedAt
            id
            name
            logo
            isEnterprise
            status
            updatedAt
        }
    }
`;
function UB(e) {
  const t = { ...Ur, ...e };
  return n.useQuery(zr, t);
}
function zB(e) {
  const t = { ...Ur, ...e };
  return n.useLazyQuery(zr, t);
}
function FB(e) {
  const t = e === n.skipToken ? e : { ...Ur, ...e };
  return n.useSuspenseQuery(zr, t);
}
const Iv = {}, $v = i`
    mutation OrganizationServiceAdminUpdateOrganization(
        $id: String!
        $input: OrganizationServiceUpdateOrganizationGqlInput!
    ) {
        organizationServiceAdminUpdateOrganization(id: $id, input: $input) {
            id
            name
            status
            createdBy
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function RB(e) {
  const t = { ...Iv, ...e };
  return n.useMutation($v, t);
}
const Fr = {}, Rr = i`
    query OrganizationServiceAllBranches($input: OrganizationServiceGetBranchesGqlInput!) {
        organizationServiceAllBranches(input: $input) {
            address
            createdAt
            deletedAt
            id
            name
            organizationId
            status
            updatedAt
        }
    }
`;
function GB(e) {
  const t = { ...Fr, ...e };
  return n.useQuery(
    Rr,
    t
  );
}
function qB(e) {
  const t = { ...Fr, ...e };
  return n.useLazyQuery(
    Rr,
    t
  );
}
function EB(e) {
  const t = e === n.skipToken ? e : { ...Fr, ...e };
  return n.useSuspenseQuery(
    Rr,
    t
  );
}
const Gr = {}, qr = i`
    query OrganizationServiceBranches($input: OrganizationServiceGetBranchesGqlInput!) {
        organizationServiceBranches(input: $input) {
            id
            address
            name
            organizationId
            status
            tenantId
            createdAt
            deletedAt
            updatedAt
        }
    }
`;
function VB(e) {
  const t = { ...Gr, ...e };
  return n.useQuery(
    qr,
    t
  );
}
function OB(e) {
  const t = { ...Gr, ...e };
  return n.useLazyQuery(
    qr,
    t
  );
}
function xB(e) {
  const t = e === n.skipToken ? e : { ...Gr, ...e };
  return n.useSuspenseQuery(
    qr,
    t
  );
}
const Er = {}, Vr = i`
    query OrganizationServiceBranchById($id: String!) {
        organizationServiceBranchById(id: $id) {
            address
            createdAt
            deletedAt
            id
            name
            organizationId
            status
            updatedAt
        }
    }
`;
function wB(e) {
  const t = { ...Er, ...e };
  return n.useQuery(
    Vr,
    t
  );
}
function HB(e) {
  const t = { ...Er, ...e };
  return n.useLazyQuery(
    Vr,
    t
  );
}
function NB(e) {
  const t = e === n.skipToken ? e : { ...Er, ...e };
  return n.useSuspenseQuery(
    Vr,
    t
  );
}
const Or = {}, xr = i`
    query OrganizationServiceBranchByIds($ids: [String!]!) {
        organizationServiceBranchByIds(ids: $ids) {
            address
            createdAt
            deletedAt
            id
            name
            organizationId
            status
            updatedAt
        }
    }
`;
function WB(e) {
  const t = { ...Or, ...e };
  return n.useQuery(
    xr,
    t
  );
}
function jB(e) {
  const t = { ...Or, ...e };
  return n.useLazyQuery(
    xr,
    t
  );
}
function KB(e) {
  const t = e === n.skipToken ? e : { ...Or, ...e };
  return n.useSuspenseQuery(
    xr,
    t
  );
}
const Qv = {}, Cv = i`
    mutation OrganizationServiceCreateBranch($input: OrganizationServiceCreateBranchGqlInput!) {
        organizationServiceCreateBranch(input: $input) {
            id
            name
            address
            organizationId
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function ZB(e) {
  const t = { ...Qv, ...e };
  return n.useMutation(Cv, t);
}
const hv = {}, kv = i`
    mutation OrganizationServiceDeleteBranch($id: String!) {
        organizationServiceDeleteBranch(id: $id) {
            id
            name
            address
            organizationId
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function YB(e) {
  const t = { ...hv, ...e };
  return n.useMutation(kv, t);
}
const wr = {}, Hr = i`
    query OrganizationServiceGetByDomain($domain: String!) {
        organizationServiceGetByDomain(domain: $domain) {
            createdAt
            createdBy
            deletedAt
            domain
            id
            isEnterprise
            logo
            name
            status
            updatedAt
        }
    }
`;
function JB(e) {
  const t = { ...wr, ...e };
  return n.useQuery(
    Hr,
    t
  );
}
function _B(e) {
  const t = { ...wr, ...e };
  return n.useLazyQuery(
    Hr,
    t
  );
}
function XB(e) {
  const t = e === n.skipToken ? e : { ...wr, ...e };
  return n.useSuspenseQuery(
    Hr,
    t
  );
}
const Nr = {}, Wr = i`
    query OrganizationServiceMyOrg {
        organizationServiceMyOrg {
            createdAt
            createdBy
            deletedAt
            domain
            id
            isEnterprise
            logo
            name
            status
            updatedAt
        }
    }
`;
function eU(e) {
  const t = { ...Nr, ...e };
  return n.useQuery(
    Wr,
    t
  );
}
function tU(e) {
  const t = { ...Nr, ...e };
  return n.useLazyQuery(
    Wr,
    t
  );
}
function nU(e) {
  const t = e === n.skipToken ? e : { ...Nr, ...e };
  return n.useSuspenseQuery(
    Wr,
    t
  );
}
const Dv = {}, Pv = i`
    mutation OrganizationServiceUpdateBranch($id: String!, $input: OrganizationServiceUpdateBranchGqlInput!) {
        organizationServiceUpdateBranch(id: $id, input: $input) {
            id
            name
            address
            organizationId
            status
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function iU(e) {
  const t = { ...Dv, ...e };
  return n.useMutation(Pv, t);
}
const Tv = {}, Mv = i`
    mutation PaymentServiceCreatePaymentVendor($input: PaymentServiceCreatePaymentVendorGqlInput!) {
        paymentServiceCreatePaymentVendor(input: $input) {
            id
            code
            name
            isEnabled
            isDeleted
            momoConfig {
                accessKey
                apiUrl
                ipnUrl
                partnerCode
                redirectUrl
                secretKey
            }
            vnpayConfig {
                vnpApi
                vnpHashSecret
                vnpReturnUrl
                vnpTmnCode
                vnpUrl
                vnpVersion
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function rU(e) {
  const t = { ...Tv, ...e };
  return n.useMutation(Mv, t);
}
const bv = {}, Lv = i`
    mutation PaymentServiceUpdatePaymentVendor($input: PaymentServiceUpdatePaymentVendorGqlInput!) {
        paymentServiceUpdatePaymentVendor(input: $input) {
            id
            code
            name
            isEnabled
            isDeleted
            momoConfig {
                accessKey
                apiUrl
                ipnUrl
                partnerCode
                redirectUrl
                secretKey
            }
            vnpayConfig {
                vnpApi
                vnpHashSecret
                vnpReturnUrl
                vnpTmnCode
                vnpUrl
                vnpVersion
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function sU(e) {
  const t = { ...bv, ...e };
  return n.useMutation(Lv, t);
}
const jr = {}, Kr = i`
    query PaymentServiceUserSubscriptionTransaction($transactionId: String!) {
        paymentServiceUserSubscriptionTransaction(transactionId: $transactionId) {
            id
            subscriptionId
            packageName
            pricingName
            amount
            currency
            duration
            durationUnit
            paymentMethod
            status
            tenantId
            userId
            createdAt
            updatedAt
        }
    }
`;
function oU(e) {
  const t = { ...jr, ...e };
  return n.useQuery(Kr, t);
}
function aU(e) {
  const t = { ...jr, ...e };
  return n.useLazyQuery(Kr, t);
}
function uU(e) {
  const t = e === n.skipToken ? e : { ...jr, ...e };
  return n.useSuspenseQuery(Kr, t);
}
const Zr = {}, Yr = i`
    query PaymentServiceUserSubscriptionTransactions($pagination: PaginationArgs!) {
        paymentServiceUserSubscriptionTransactions(pagination: $pagination) {
            id
            subscriptionId
            packageName
            pricingName
            amount
            currency
            duration
            durationUnit
            paymentMethod
            status
            tenantId
            userId
            createdAt
            updatedAt
        }
    }
`;
function cU(e) {
  const t = { ...Zr, ...e };
  return n.useQuery(Yr, t);
}
function dU(e) {
  const t = { ...Zr, ...e };
  return n.useLazyQuery(Yr, t);
}
function pU(e) {
  const t = e === n.skipToken ? e : { ...Zr, ...e };
  return n.useSuspenseQuery(Yr, t);
}
const Jr = {}, _r = i`
    query PaymentServiceVendor($code: PaymentServiceVendor!) {
        paymentServiceVendor(code: $code) {
            id
            code
            name
            isEnabled
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function lU(e) {
  const t = { ...Jr, ...e };
  return n.useQuery(
    _r,
    t
  );
}
function yU(e) {
  const t = { ...Jr, ...e };
  return n.useLazyQuery(
    _r,
    t
  );
}
function SU(e) {
  const t = e === n.skipToken ? e : { ...Jr, ...e };
  return n.useSuspenseQuery(
    _r,
    t
  );
}
const Xr = {}, es = i`
    query PaymentServiceVendorForAdmin($code: PaymentServiceVendor!) {
        paymentServiceVendorForAdmin(code: $code) {
            id
            code
            name
            isEnabled
            isDeleted
            momoConfig {
                accessKey
                apiUrl
                ipnUrl
                partnerCode
                redirectUrl
                secretKey
            }
            vnpayConfig {
                vnpApi
                vnpHashSecret
                vnpReturnUrl
                vnpTmnCode
                vnpUrl
                vnpVersion
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function mU(e) {
  const t = { ...Xr, ...e };
  return n.useQuery(
    es,
    t
  );
}
function vU(e) {
  const t = { ...Xr, ...e };
  return n.useLazyQuery(
    es,
    t
  );
}
function gU(e) {
  const t = e === n.skipToken ? e : { ...Xr, ...e };
  return n.useSuspenseQuery(
    es,
    t
  );
}
const ts = {}, ns = i`
    query PaymentServiceVendors($pagination: PaginationArgs!) {
        paymentServiceVendors(pagination: $pagination) {
            id
            code
            name
            isEnabled
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function fU(e) {
  const t = { ...ts, ...e };
  return n.useQuery(
    ns,
    t
  );
}
function AU(e) {
  const t = { ...ts, ...e };
  return n.useLazyQuery(
    ns,
    t
  );
}
function IU(e) {
  const t = e === n.skipToken ? e : { ...ts, ...e };
  return n.useSuspenseQuery(
    ns,
    t
  );
}
const is = {}, rs = i`
    query PaymentServiceVendorsForAdmin($pagination: PaginationArgs!) {
        paymentServiceVendorsForAdmin(pagination: $pagination) {
            id
            code
            name
            isEnabled
            isDeleted
            momoConfig {
                accessKey
                apiUrl
                ipnUrl
                partnerCode
                redirectUrl
                secretKey
            }
            vnpayConfig {
                vnpApi
                vnpHashSecret
                vnpReturnUrl
                vnpTmnCode
                vnpUrl
                vnpVersion
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function $U(e) {
  const t = { ...is, ...e };
  return n.useQuery(
    rs,
    t
  );
}
function QU(e) {
  const t = { ...is, ...e };
  return n.useLazyQuery(
    rs,
    t
  );
}
function CU(e) {
  const t = e === n.skipToken ? e : { ...is, ...e };
  return n.useSuspenseQuery(
    rs,
    t
  );
}
const ss = {}, os = i`
    query PaymentServiceTransactionByIdForAdmin($id: String!) {
        paymentServiceTransactionByIdForAdmin(id: $id) {
            id
            amount
            currency
            status
            vendor
            platform
            orderId
            vendorTransactionId
            vendorOriginalTransactionId
            vendorStatus
            vendorMessage
            metadata
            tenantId
            createdBy
            createdAt
            updatedAt
        }
    }
`;
function hU(e) {
  const t = { ...ss, ...e };
  return n.useQuery(os, t);
}
function kU(e) {
  const t = { ...ss, ...e };
  return n.useLazyQuery(os, t);
}
function DU(e) {
  const t = e === n.skipToken ? e : { ...ss, ...e };
  return n.useSuspenseQuery(os, t);
}
const as = {}, us = i`
    query PaymentServiceTransactionsForAdmin($pagination: PaginationArgs!) {
        paymentServiceTransactionsForAdmin(pagination: $pagination) {
            data {
                id
                amount
                currency
                status
                vendor
                platform
                orderId
                vendorTransactionId
                vendorOriginalTransactionId
                vendorStatus
                vendorMessage
                metadata
                tenantId
                createdBy
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function PU(e) {
  const t = { ...as, ...e };
  return n.useQuery(
    us,
    t
  );
}
function TU(e) {
  const t = { ...as, ...e };
  return n.useLazyQuery(us, t);
}
function MU(e) {
  const t = e === n.skipToken ? e : { ...as, ...e };
  return n.useSuspenseQuery(us, t);
}
const Bv = {}, Uv = i`
    mutation PaymentServiceZMACreateTransaction($input: PaymentServiceZMACreateTransactionGqlInput!) {
        paymentServiceZMACreateTransaction(input: $input) {
            amount
            desc
            extradata
            item
            mac
            method
            transactionId
        }
    }
`;
function bU(e) {
  const t = { ...Bv, ...e };
  return n.useMutation(Uv, t);
}
const zv = {}, Fv = i`
    mutation PaymentServiceZMAConfirmTransaction($input: PaymentServiceZMAConfirmTransactionGqlInput!) {
        paymentServiceZMAConfirmTransaction(input: $input)
    }
`;
function LU(e) {
  const t = { ...zv, ...e };
  return n.useMutation(Fv, t);
}
const Rv = {}, Gv = i`
    mutation PaymentServiceZMAUpdateTransactionStatus($input: PaymentServiceZMAUpdateTransactionStatusGqlInput!) {
        paymentServiceZMAUpdateTransactionStatus(input: $input)
    }
`;
function BU(e) {
  const t = { ...Rv, ...e };
  return n.useMutation(Gv, t);
}
const qv = {}, Ev = i`
    mutation PointServiceActivatePointExpiryRule($id: String!) {
        pointServiceActivatePointExpiryRule(id: $id)
    }
`;
function UU(e) {
  const t = { ...qv, ...e };
  return n.useMutation(Ev, t);
}
const Vv = {}, Ov = i`
    mutation PointServiceAddPointsForProfile($input: PointServiceAddPointsForProfileGqlInput!) {
        pointServiceAddPointsForProfile(input: $input) {
            success
        }
    }
`;
function zU(e) {
  const t = { ...Vv, ...e };
  return n.useMutation(Ov, t);
}
const cs = {}, ds = i`
    query PointServiceAllPointExpiryRules($pagination: PaginationArgs!) {
        pointServiceAllPointExpiryRules(pagination: $pagination) {
            data {
                applicableTiersId
                createdAt
                daysValid
                description
                expiryType
                fixedDate
                id
                isActive
                loyaltyProgramId
                name
                tenantId
                updatedAt
            }
            total
        }
    }
`;
function FU(e) {
  const t = { ...cs, ...e };
  return n.useQuery(
    ds,
    t
  );
}
function RU(e) {
  const t = { ...cs, ...e };
  return n.useLazyQuery(
    ds,
    t
  );
}
function GU(e) {
  const t = e === n.skipToken ? e : { ...cs, ...e };
  return n.useSuspenseQuery(
    ds,
    t
  );
}
const xv = {}, wv = i`
    mutation PointServiceCreatePointBalanceProfile($input: PointServiceCreatePointBalanceProfileGqlInput!) {
        pointServiceCreatePointBalanceProfile(input: $input) {
            availablePoints
            createdAt
            expiredPoints
            id
            lastUpdated
            pendingPoints
            pointExpiryBreakdown
            redeemedPoints
            tenantId
            totalPoints
            updatedAt
            userId
        }
    }
`;
function qU(e) {
  const t = { ...xv, ...e };
  return n.useMutation(wv, t);
}
const Hv = {}, Nv = i`
    mutation PointServiceCreatePointExpiryRule($input: PointServiceCreatePointExpiryRuleProfileGqlInput!) {
        pointServiceCreatePointExpiryRule(input: $input)
    }
`;
function EU(e) {
  const t = { ...Hv, ...e };
  return n.useMutation(Nv, t);
}
const Wv = {}, jv = i`
    mutation PointServiceDeactivatePointExpiryRule($id: String!) {
        pointServiceDeactivatePointExpiryRule(id: $id)
    }
`;
function VU(e) {
  const t = { ...Wv, ...e };
  return n.useMutation(jv, t);
}
const ps = {}, ls = i`
    query PointServiceGetPointBalanceById($id: String!) {
        pointServiceGetPointBalanceById(id: $id) {
            id
            availablePoints
            createdAt
            expiredPoints
            lastUpdated
            userId
            pendingPoints
            pointExpiryBreakdown
            redeemedPoints
            tenantId
            totalPoints
            updatedAt
            userId
        }
    }
`;
function OU(e) {
  const t = { ...ps, ...e };
  return n.useQuery(
    ls,
    t
  );
}
function xU(e) {
  const t = { ...ps, ...e };
  return n.useLazyQuery(
    ls,
    t
  );
}
function wU(e) {
  const t = e === n.skipToken ? e : { ...ps, ...e };
  return n.useSuspenseQuery(
    ls,
    t
  );
}
const ys = {}, Ss = i`
    query PointServiceGetPointBalanceByUserId($input: PointServiceGetPointBalanceByUserIdGqlInput!) {
        pointServiceGetPointBalanceByUserId(input: $input) {
            id
            availablePoints
            createdAt
            expiredPoints
            lastUpdated
            userId
            pendingPoints
            pointExpiryBreakdown
            redeemedPoints
            tenantId
            totalPoints
            updatedAt
            userId
        }
    }
`;
function HU(e) {
  const t = { ...ys, ...e };
  return n.useQuery(
    Ss,
    t
  );
}
function NU(e) {
  const t = { ...ys, ...e };
  return n.useLazyQuery(Ss, t);
}
function WU(e) {
  const t = e === n.skipToken ? e : { ...ys, ...e };
  return n.useSuspenseQuery(Ss, t);
}
const ms = {}, vs = i`
    query PointServicePointExpiryRuleById($id: String!) {
        pointServicePointExpiryRuleById(id: $id) {
            id
            applicableTiersId
            createdAt
            daysValid
            description
            expiryType
            fixedDate
            isActive
            loyaltyProgramId
            name
            tenantId
            updatedAt
        }
    }
`;
function jU(e) {
  const t = { ...ms, ...e };
  return n.useQuery(
    vs,
    t
  );
}
function KU(e) {
  const t = { ...ms, ...e };
  return n.useLazyQuery(
    vs,
    t
  );
}
function ZU(e) {
  const t = e === n.skipToken ? e : { ...ms, ...e };
  return n.useSuspenseQuery(
    vs,
    t
  );
}
const gs = {}, fs = i`
    query PointServicePointExpiryRulesByLoyaltyProgramId($loyaltyProgramId: String!) {
        pointServicePointExpiryRulesByLoyaltyProgramId(loyaltyProgramId: $loyaltyProgramId) {
            id
            applicableTiersId
            createdAt
            daysValid
            description
            expiryType
            fixedDate
            isActive
            loyaltyProgramId
            name
            tenantId
            updatedAt
        }
    }
`;
function YU(e) {
  const t = { ...gs, ...e };
  return n.useQuery(fs, t);
}
function JU(e) {
  const t = { ...gs, ...e };
  return n.useLazyQuery(fs, t);
}
function _U(e) {
  const t = e === n.skipToken ? e : { ...gs, ...e };
  return n.useSuspenseQuery(fs, t);
}
const As = {}, Is = i`
    query PointServiceMyPointBalance {
        pointServiceMyPointBalance {
            availablePoints
            createdAt
            expiredPoints
            id
            lastUpdated
            pendingPoints
            pointExpiryBreakdown
            redeemedPoints
            tenantId
            totalPoints
            updatedAt
            userId
        }
    }
`;
function XU(e) {
  const t = { ...As, ...e };
  return n.useQuery(
    Is,
    t
  );
}
function ez(e) {
  const t = { ...As, ...e };
  return n.useLazyQuery(
    Is,
    t
  );
}
function tz(e) {
  const t = e === n.skipToken ? e : { ...As, ...e };
  return n.useSuspenseQuery(
    Is,
    t
  );
}
const $s = {}, Qs = i`
    query PointServiceMyPointTransactions(
        $filter: PointServiceMyPointTransactionsFilterGqlInput
        $pagination: PaginationArgs!
    ) {
        pointServiceMyPointTransactions(filter: $filter, pagination: $pagination) {
            amount
            createdAt
            description
            expiryDate
            id
            isActive
            isExpired
            performedBy
            sourceReference
            tenantId
            transactionType
            updatedAt
            userId
        }
    }
`;
function nz(e) {
  const t = { ...$s, ...e };
  return n.useQuery(
    Qs,
    t
  );
}
function iz(e) {
  const t = { ...$s, ...e };
  return n.useLazyQuery(
    Qs,
    t
  );
}
function rz(e) {
  const t = e === n.skipToken ? e : { ...$s, ...e };
  return n.useSuspenseQuery(
    Qs,
    t
  );
}
const Cs = {}, hs = i`
    query PointServicePointTransactionsByUserId(
        $filter: PointServiceMyPointTransactionsFilterGqlInput
        $pagination: PaginationArgs!
        $userId: String!
    ) {
        pointServicePointTransactionsByUserId(filter: $filter, pagination: $pagination, userId: $userId) {
            amount
            createdAt
            description
            expiryDate
            id
            isActive
            isExpired
            performedBy
            sourceReference
            tenantId
            transactionType
            updatedAt
            userId
        }
    }
`;
function sz(e) {
  const t = { ...Cs, ...e };
  return n.useQuery(hs, t);
}
function oz(e) {
  const t = { ...Cs, ...e };
  return n.useLazyQuery(hs, t);
}
function az(e) {
  const t = e === n.skipToken ? e : { ...Cs, ...e };
  return n.useSuspenseQuery(hs, t);
}
const Kv = {}, Zv = i`
    mutation PointServiceRedeemPointsForVoucher($input: PointServiceRedeemPointsForVoucherGqlInput!) {
        pointServiceRedeemPointsForVoucher(input: $input) {
            message
            quantity
            success
            vouchers {
                code
                createdAt
                discountType
                discountValue
                endDate
                isActive
                isDeleted
                isExpired
                redemptionCount
                maximumDiscount
                minimumPurchase
                redeemedDate
                startDate
                tenantId
                updatedAt
                userId
                voucherTypeId
            }
        }
    }
`;
function uz(e) {
  const t = { ...Kv, ...e };
  return n.useMutation(Zv, t);
}
const Yv = {}, Jv = i`
    mutation PointServiceUpdatePointExpiryRule($input: PointServiceUpdatePointExpiryRuleProfileGqlInput!) {
        pointServiceUpdatePointExpiryRule(input: $input)
    }
`;
function cz(e) {
  const t = { ...Yv, ...e };
  return n.useMutation(Jv, t);
}
const ks = {}, Ds = i`
    query PointServiceCountPointTransactionsByUserId($input: PointServiceCountPointTransactionsByUserIdGqlInput!) {
        pointServiceCountPointTransactionsByUserId(input: $input) {
            count
        }
    }
`;
function dz(e) {
  const t = { ...ks, ...e };
  return n.useQuery(Ds, t);
}
function pz(e) {
  const t = { ...ks, ...e };
  return n.useLazyQuery(Ds, t);
}
function lz(e) {
  const t = e === n.skipToken ? e : { ...ks, ...e };
  return n.useSuspenseQuery(Ds, t);
}
const Ps = {}, Ts = i`
    query PointServiceAllPointTransactions($pagination: PaginationArgs!) {
        pointServiceAllPointTransactions(pagination: $pagination) {
            _id
            amount
            createdAt
            description
            expiryDate
            isActive
            isExpired
            performedBy
            source
            sourceReference
            tenantId
            transactionDate
            transactionType
            updatedAt
            userId
        }
    }
`;
function yz(e) {
  const t = { ...Ps, ...e };
  return n.useQuery(
    Ts,
    t
  );
}
function Sz(e) {
  const t = { ...Ps, ...e };
  return n.useLazyQuery(
    Ts,
    t
  );
}
function mz(e) {
  const t = e === n.skipToken ? e : { ...Ps, ...e };
  return n.useSuspenseQuery(Ts, t);
}
const _v = {}, Xv = i`
    mutation PointServiceCreatePointConfig($input: CreatePointConfigInput!) {
        pointServiceCreatePointConfig(input: $input) {
            id
            createdAt
            currency
            moneyAmount
            pointsPerUnit
        }
    }
`;
function vz(e) {
  const t = { ..._v, ...e };
  return n.useMutation(
    Xv,
    t
  );
}
const Ms = {}, bs = i`
    query PointServicePointExpiryRules {
        pointServicePointExpiryRules {
            _id
            applicableTiers
            createdAt
            daysValid
            description
            expiryType
            fixedDate
            isActive
            loyaltyProgramId
            name
            tenantId
            updatedAt
        }
    }
`;
function gz(e) {
  const t = { ...Ms, ...e };
  return n.useQuery(
    bs,
    t
  );
}
function fz(e) {
  const t = { ...Ms, ...e };
  return n.useLazyQuery(
    bs,
    t
  );
}
function Az(e) {
  const t = e === n.skipToken ? e : { ...Ms, ...e };
  return n.useSuspenseQuery(
    bs,
    t
  );
}
const eg = {}, tg = i`
    mutation PointServiceUpdatePointConfig($input: UpdatePointConfigInput!) {
        pointServiceUpdatePointConfig(input: $input) {
            id
            createdAt
            currency
            moneyAmount
            pointsPerUnit
        }
    }
`;
function Iz(e) {
  const t = { ...eg, ...e };
  return n.useMutation(
    tg,
    t
  );
}
const Ls = {}, Bs = i`
    query PointServicePointConfig {
        pointServicePointConfig {
            id
            createdAt
            currency
            moneyAmount
            pointsPerUnit
            tenantId
            updatedAt
        }
    }
`;
function $z(e) {
  const t = { ...Ls, ...e };
  return n.useQuery(
    Bs,
    t
  );
}
function Qz(e) {
  const t = { ...Ls, ...e };
  return n.useLazyQuery(
    Bs,
    t
  );
}
function Cz(e) {
  const t = e === n.skipToken ? e : { ...Ls, ...e };
  return n.useSuspenseQuery(
    Bs,
    t
  );
}
const Us = {}, zs = i`
    query ProductServiceAllCategories {
        productServiceAllCategories {
            children {
                children {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parent {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                parentId
                tenantId
                updatedAt
            }
            createdAt
            description
            iconUrl
            id
            isDeleted
            isEnabled
            name
            parent {
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parentId
                tenantId
                updatedAt
            }
            parentId
            tenantId
            updatedAt
        }
    }
`;
function hz(e) {
  const t = { ...Us, ...e };
  return n.useQuery(
    zs,
    t
  );
}
function kz(e) {
  const t = { ...Us, ...e };
  return n.useLazyQuery(
    zs,
    t
  );
}
function Dz(e) {
  const t = e === n.skipToken ? e : { ...Us, ...e };
  return n.useSuspenseQuery(
    zs,
    t
  );
}
const Fs = {}, Rs = i`
    query ProductServiceAllColors($pagination: PaginationArgs!) {
        productServiceAllColors(pagination: $pagination) {
            data {
                colorCode
                createdAt
                description
                id
                isDeleted
                isEnabled
                name
                tenantId
                updatedAt
            }
            total
        }
    }
`;
function Pz(e) {
  const t = { ...Fs, ...e };
  return n.useQuery(
    Rs,
    t
  );
}
function Tz(e) {
  const t = { ...Fs, ...e };
  return n.useLazyQuery(
    Rs,
    t
  );
}
function Mz(e) {
  const t = e === n.skipToken ? e : { ...Fs, ...e };
  return n.useSuspenseQuery(
    Rs,
    t
  );
}
const Gs = {}, qs = i`
    query ProductServiceAllProducts($pagination: PaginationArgs!) {
        productServiceAllProducts(pagination: $pagination) {
            data {
                categoryIds
                commonAttributes {
                    key
                    value
                }
                createdAt
                currency
                description
                displayOrder
                id
                isDeleted
                isEnabled
                isFeatured
                isLatest
                mediaUrls
                merchantNames
                shortDescription
                summarizedAttributes {
                    displayName
                    key
                    values
                }
                tags
                tenantId
                thumbnailUrl
                title
                type
                updatedAt
                variants {
                    attributes {
                        key
                        value
                    }
                    basePrice
                    basePriceFormatted
                    flashSale {
                        salePrice
                        saleStartDate
                        saleEndDate
                    }
                    isFlashSale
                    mediaUrls
                    name
                    price
                    priceFormatted
                    sku
                    isEnabled
                    isSale
                    sale {
                        salePrice
                        saleStartDate
                        saleEndDate
                    }
                }
            }
            total
        }
    }
`;
function bz(e) {
  const t = { ...Gs, ...e };
  return n.useQuery(
    qs,
    t
  );
}
function Lz(e) {
  const t = { ...Gs, ...e };
  return n.useLazyQuery(
    qs,
    t
  );
}
function Bz(e) {
  const t = e === n.skipToken ? e : { ...Gs, ...e };
  return n.useSuspenseQuery(
    qs,
    t
  );
}
const Es = {}, Vs = i`
    query ProductServiceAllBrands($pagination: PaginationArgs!) {
        productServiceAllBrands(pagination: $pagination) {
            data {
                id
                name
                description
                logoUrl
                createdAt
                updatedAt
                isDeleted
                isEnabled
            }
            total
        }
    }
`;
function Uz(e) {
  const t = { ...Es, ...e };
  return n.useQuery(
    Vs,
    t
  );
}
function zz(e) {
  const t = { ...Es, ...e };
  return n.useLazyQuery(
    Vs,
    t
  );
}
function Fz(e) {
  const t = e === n.skipToken ? e : { ...Es, ...e };
  return n.useSuspenseQuery(
    Vs,
    t
  );
}
const Os = {}, xs = i`
    query ProductServiceBrandById($id: String!) {
        productServiceBrandById(id: $id) {
            id
            name
            description
            logoUrl
            createdAt
            updatedAt
            isDeleted
            isEnabled
        }
    }
`;
function Rz(e) {
  const t = { ...Os, ...e };
  return n.useQuery(
    xs,
    t
  );
}
function Gz(e) {
  const t = { ...Os, ...e };
  return n.useLazyQuery(
    xs,
    t
  );
}
function qz(e) {
  const t = e === n.skipToken ? e : { ...Os, ...e };
  return n.useSuspenseQuery(
    xs,
    t
  );
}
const ws = {}, Hs = i`
    query ProductServiceColorByCode($code: String!) {
        productServiceColorByCode(code: $code) {
            id
            name
            colorCode
            createdAt
            updatedAt
        }
    }
`;
function Ez(e) {
  const t = { ...ws, ...e };
  return n.useQuery(
    Hs,
    t
  );
}
function Vz(e) {
  const t = { ...ws, ...e };
  return n.useLazyQuery(
    Hs,
    t
  );
}
function Oz(e) {
  const t = e === n.skipToken ? e : { ...ws, ...e };
  return n.useSuspenseQuery(
    Hs,
    t
  );
}
const Ns = {}, Ws = i`
    query ProductServiceEnabledBrands($pagination: PaginationArgs!) {
        productServiceEnabledBrands(pagination: $pagination) {
            data {
                id
                name
                description
                logoUrl
                createdAt
                updatedAt
                isDeleted
                isEnabled
            }
            total
        }
    }
`;
function xz(e) {
  const t = { ...Ns, ...e };
  return n.useQuery(
    Ws,
    t
  );
}
function wz(e) {
  const t = { ...Ns, ...e };
  return n.useLazyQuery(
    Ws,
    t
  );
}
function Hz(e) {
  const t = e === n.skipToken ? e : { ...Ns, ...e };
  return n.useSuspenseQuery(
    Ws,
    t
  );
}
const js = {}, Ks = i`
    query ProductServiceCategoryById($id: String!) {
        productServiceCategoryById(id: $id) {
            children {
                children {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parent {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                parentId
                tenantId
                updatedAt
            }
            createdAt
            description
            iconUrl
            id
            isDeleted
            isEnabled
            name
            parent {
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parentId
                tenantId
                updatedAt
            }
            parentId
            tenantId
            updatedAt
        }
    }
`;
function Nz(e) {
  const t = { ...js, ...e };
  return n.useQuery(
    Ks,
    t
  );
}
function Wz(e) {
  const t = { ...js, ...e };
  return n.useLazyQuery(
    Ks,
    t
  );
}
function jz(e) {
  const t = e === n.skipToken ? e : { ...js, ...e };
  return n.useSuspenseQuery(
    Ks,
    t
  );
}
const Zs = {}, Ys = i`
    query ProductServiceColorById($id: String!) {
        productServiceColorById(id: $id) {
            colorCode
            createdAt
            description
            id
            isDeleted
            isEnabled
            name
            tenantId
            updatedAt
        }
    }
`;
function Kz(e) {
  const t = { ...Zs, ...e };
  return n.useQuery(
    Ys,
    t
  );
}
function Zz(e) {
  const t = { ...Zs, ...e };
  return n.useLazyQuery(
    Ys,
    t
  );
}
function Yz(e) {
  const t = e === n.skipToken ? e : { ...Zs, ...e };
  return n.useSuspenseQuery(
    Ys,
    t
  );
}
const ng = {}, ig = i`
    mutation ProductServiceCreateCategory($input: ProductServiceCreateCategoryGqlInput!) {
        productServiceCreateCategory(input: $input)
    }
`;
function Jz(e) {
  const t = { ...ng, ...e };
  return n.useMutation(
    ig,
    t
  );
}
const rg = {}, sg = i`
    mutation ProductServiceCreateColor($input: ProductServiceCreateColorGqlInput!) {
        productServiceCreateColor(input: $input)
    }
`;
function _z(e) {
  const t = { ...rg, ...e };
  return n.useMutation(
    sg,
    t
  );
}
const og = {}, ag = i`
    mutation ProductServiceCreateProduct($input: ProductServiceProductGqlInput!) {
        productServiceCreateProduct(input: $input)
    }
`;
function Xz(e) {
  const t = { ...og, ...e };
  return n.useMutation(
    ag,
    t
  );
}
const ug = {}, cg = i`
    mutation ProductServiceCreateBrand($input: BrandServiceBrandGqlInput!) {
        productServiceCreateBrand(input: $input)
    }
`;
function eF(e) {
  const t = { ...ug, ...e };
  return n.useMutation(
    cg,
    t
  );
}
const dg = {}, pg = i`
    mutation ProductServiceDeleteCategory($id: String!) {
        productServiceDeleteCategory(id: $id)
    }
`;
function tF(e) {
  const t = { ...dg, ...e };
  return n.useMutation(
    pg,
    t
  );
}
const lg = {}, yg = i`
    mutation ProductServiceDeleteColor($id: String!) {
        productServiceDeleteColor(id: $id)
    }
`;
function nF(e) {
  const t = { ...lg, ...e };
  return n.useMutation(
    yg,
    t
  );
}
const Sg = {}, mg = i`
    mutation ProductServiceDeleteProducts($ids: [String!]!) {
        productServiceDeleteProducts(ids: $ids)
    }
`;
function iF(e) {
  const t = { ...Sg, ...e };
  return n.useMutation(
    mg,
    t
  );
}
const vg = {}, gg = i`
    mutation ProductServiceDeleteBrands($ids: [String!]!) {
        productServiceDeleteBrands(ids: $ids)
    }
`;
function rF(e) {
  const t = { ...vg, ...e };
  return n.useMutation(
    gg,
    t
  );
}
const fg = {}, Ag = i`
    mutation ProductServiceDisableCategories($ids: [String!]!) {
        productServiceDisableCategories(ids: $ids)
    }
`;
function sF(e) {
  const t = { ...fg, ...e };
  return n.useMutation(Ag, t);
}
const Ig = {}, $g = i`
    mutation ProductServiceDisableColors($ids: [String!]!) {
        productServiceDisableColors(ids: $ids)
    }
`;
function oF(e) {
  const t = { ...Ig, ...e };
  return n.useMutation(
    $g,
    t
  );
}
const Qg = {}, Cg = i`
    mutation ProductServiceDisableBrands($ids: [String!]!) {
        productServiceDisableBrands(ids: $ids)
    }
`;
function aF(e) {
  const t = { ...Qg, ...e };
  return n.useMutation(
    Cg,
    t
  );
}
const Js = {}, _s = i`
    query ProductServiceDisabledProducts($pagination: PaginationArgs!) {
        productServiceDisabledProducts(pagination: $pagination) {
            data {
                categoryIds
                commonAttributes {
                    key
                    value
                }
                createdAt
                currency
                description
                displayOrder
                id
                isDeleted
                isEnabled
                isFeatured
                isLatest
                mediaUrls
                merchantNames
                summarizedAttributes {
                    displayName
                    key
                    values
                }
                tags
                tenantId
                thumbnailUrl
                title
                updatedAt
                variants {
                    attributes {
                        key
                        value
                    }
                    basePrice
                    basePriceFormatted
                    flashSale {
                        salePrice
                        saleStartDate
                        saleEndDate
                    }
                    isFlashSale
                    mediaUrls
                    name
                    price
                    priceFormatted
                    sku
                    isEnabled
                    isSale
                    sale {
                        salePrice
                        saleStartDate
                        saleEndDate
                    }
                }
            }
            total
        }
    }
`;
function uF(e) {
  const t = { ...Js, ...e };
  return n.useQuery(
    _s,
    t
  );
}
function cF(e) {
  const t = { ...Js, ...e };
  return n.useLazyQuery(
    _s,
    t
  );
}
function dF(e) {
  const t = e === n.skipToken ? e : { ...Js, ...e };
  return n.useSuspenseQuery(
    _s,
    t
  );
}
const hg = {}, kg = i`
    mutation ProductServiceDisableProducts($ids: [String!]!) {
        productServiceDisableProducts(ids: $ids)
    }
`;
function pF(e) {
  const t = { ...hg, ...e };
  return n.useMutation(
    kg,
    t
  );
}
const Dg = {}, Pg = i`
    mutation ProductServiceEnableCategories($ids: [String!]!) {
        productServiceEnableCategories(ids: $ids)
    }
`;
function lF(e) {
  const t = { ...Dg, ...e };
  return n.useMutation(
    Pg,
    t
  );
}
const Tg = {}, Mg = i`
    mutation ProductServiceEnableColors($ids: [String!]!) {
        productServiceEnableColors(ids: $ids)
    }
`;
function yF(e) {
  const t = { ...Tg, ...e };
  return n.useMutation(
    Mg,
    t
  );
}
const bg = {}, Lg = i`
    mutation ProductServiceEnableBrands($ids: [String!]!) {
        productServiceEnableBrands(ids: $ids)
    }
`;
function SF(e) {
  const t = { ...bg, ...e };
  return n.useMutation(
    Lg,
    t
  );
}
const Xs = {}, eo = i`
    query ProductServiceEnabledProducts($pagination: PaginationArgs!) {
        productServiceEnabledProducts(pagination: $pagination) {
            data {
                categoryIds
                commonAttributes {
                    key
                    value
                }
                createdAt
                currency
                description
                displayOrder
                id
                isDeleted
                isEnabled
                isFeatured
                isLatest
                mediaUrls
                merchantNames
                summarizedAttributes {
                    displayName
                    key
                    values
                }
                tags
                tenantId
                thumbnailUrl
                title
                updatedAt
                variants {
                    attributes {
                        key
                        value
                    }
                    basePrice
                    basePriceFormatted
                    flashSale {
                        salePrice
                        saleStartDate
                        saleEndDate
                    }
                    isFlashSale
                    mediaUrls
                    name
                    price
                    priceFormatted
                    sku
                    isEnabled
                    isSale
                    sale {
                        salePrice
                        saleStartDate
                        saleEndDate
                    }
                }
            }
            total
        }
    }
`;
function mF(e) {
  const t = { ...Xs, ...e };
  return n.useQuery(
    eo,
    t
  );
}
function vF(e) {
  const t = { ...Xs, ...e };
  return n.useLazyQuery(
    eo,
    t
  );
}
function gF(e) {
  const t = e === n.skipToken ? e : { ...Xs, ...e };
  return n.useSuspenseQuery(
    eo,
    t
  );
}
const Bg = {}, Ug = i`
    mutation ProductServiceEnableProducts($ids: [String!]!) {
        productServiceEnableProducts(ids: $ids)
    }
`;
function fF(e) {
  const t = { ...Bg, ...e };
  return n.useMutation(
    Ug,
    t
  );
}
const to = {}, no = i`
    query ProductServiceFeaturedProducts($pagination: PaginationArgs!) {
        productServiceFeaturedProducts(pagination: $pagination) {
            categoryIds
            commonAttributes {
                key
                value
            }
            createdAt
            currency
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isFlashSale
                mediaUrls
                name
                price
                priceFormatted
                sku
                isEnabled
                isSale
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
            }
        }
    }
`;
function AF(e) {
  const t = { ...to, ...e };
  return n.useQuery(
    no,
    t
  );
}
function IF(e) {
  const t = { ...to, ...e };
  return n.useLazyQuery(
    no,
    t
  );
}
function $F(e) {
  const t = e === n.skipToken ? e : { ...to, ...e };
  return n.useSuspenseQuery(
    no,
    t
  );
}
const io = {}, ro = i`
    query ProductServiceLatestProducts($pagination: PaginationArgs!) {
        productServiceLatestProducts(pagination: $pagination) {
            categoryIds
            commonAttributes {
                key
                value
            }
            createdAt
            currency
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isFlashSale
                mediaUrls
                name
                price
                priceFormatted
                sku
                isEnabled
                isSale
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
            }
        }
    }
`;
function QF(e) {
  const t = { ...io, ...e };
  return n.useQuery(
    ro,
    t
  );
}
function CF(e) {
  const t = { ...io, ...e };
  return n.useLazyQuery(
    ro,
    t
  );
}
function hF(e) {
  const t = e === n.skipToken ? e : { ...io, ...e };
  return n.useSuspenseQuery(
    ro,
    t
  );
}
const so = {}, oo = i`
    query ProductServiceProductById($id: String!) {
        productServiceProductById(id: $id) {
            categoryIds
            commonAttributes {
                key
                value
            }
            createdAt
            currency
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            shortDescription
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isFlashSale
                mediaUrls
                name
                price
                priceFormatted
                sku
                isEnabled
                isSale
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
            }
        }
    }
`;
function kF(e) {
  const t = { ...so, ...e };
  return n.useQuery(
    oo,
    t
  );
}
function DF(e) {
  const t = { ...so, ...e };
  return n.useLazyQuery(
    oo,
    t
  );
}
function PF(e) {
  const t = e === n.skipToken ? e : { ...so, ...e };
  return n.useSuspenseQuery(
    oo,
    t
  );
}
const ao = {}, uo = i`
    query ProductServicePublicCategories {
        productServicePublicCategories {
            children {
                children {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parent {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                parentId
                tenantId
                updatedAt
            }
            createdAt
            description
            iconUrl
            id
            isDeleted
            isEnabled
            name
            parent {
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parentId
                tenantId
                updatedAt
            }
            parentId
            tenantId
            updatedAt
        }
    }
`;
function TF(e) {
  const t = { ...ao, ...e };
  return n.useQuery(
    uo,
    t
  );
}
function MF(e) {
  const t = { ...ao, ...e };
  return n.useLazyQuery(
    uo,
    t
  );
}
function bF(e) {
  const t = e === n.skipToken ? e : { ...ao, ...e };
  return n.useSuspenseQuery(
    uo,
    t
  );
}
const co = {}, po = i`
    query ProductServicePublicProducts($pagination: PaginationArgs!) {
        productServicePublicProducts(pagination: $pagination) {
            categoryIds
            commonAttributes {
                key
                value
            }
            createdAt
            currency
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            shortDescription
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            type
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isFlashSale
                mediaUrls
                name
                price
                priceFormatted
                sku
                isEnabled
                isSale
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
            }
        }
    }
`;
function LF(e) {
  const t = { ...co, ...e };
  return n.useQuery(
    po,
    t
  );
}
function BF(e) {
  const t = { ...co, ...e };
  return n.useLazyQuery(
    po,
    t
  );
}
function UF(e) {
  const t = e === n.skipToken ? e : { ...co, ...e };
  return n.useSuspenseQuery(
    po,
    t
  );
}
const lo = {}, yo = i`
    query ProductServicePublicSubCategories($parentId: String!) {
        productServicePublicSubCategories(parentId: $parentId) {
            children {
                children {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parent {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                parentId
                tenantId
                updatedAt
            }
            createdAt
            description
            iconUrl
            id
            isDeleted
            isEnabled
            name
            parent {
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parentId
                tenantId
                updatedAt
            }
            parentId
            tenantId
            updatedAt
        }
    }
`;
function zF(e) {
  const t = { ...lo, ...e };
  return n.useQuery(
    yo,
    t
  );
}
function FF(e) {
  const t = { ...lo, ...e };
  return n.useLazyQuery(
    yo,
    t
  );
}
function RF(e) {
  const t = e === n.skipToken ? e : { ...lo, ...e };
  return n.useSuspenseQuery(yo, t);
}
const So = {}, mo = i`
    query ProductServiceSearchProducts($input: ProductServiceSearchProductGqlInput!, $pagination: PaginationArgs!) {
        productServiceSearchProducts(input: $input, pagination: $pagination) {
            categoryIds
            commonAttributes {
                key
                value
            }
            createdAt
            currency
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            shortDescription
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            type
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isFlashSale
                mediaUrls
                name
                price
                priceFormatted
                sku
                isEnabled
                isSale
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
            }
        }
    }
`;
function GF(e) {
  const t = { ...So, ...e };
  return n.useQuery(
    mo,
    t
  );
}
function qF(e) {
  const t = { ...So, ...e };
  return n.useLazyQuery(
    mo,
    t
  );
}
function EF(e) {
  const t = e === n.skipToken ? e : { ...So, ...e };
  return n.useSuspenseQuery(
    mo,
    t
  );
}
const vo = {}, go = i`
    query ProductServiceSubCategories($parentId: String!) {
        productServiceSubCategories(parentId: $parentId) {
            children {
                children {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parent {
                    createdAt
                    description
                    iconUrl
                    id
                    isDeleted
                    isEnabled
                    name
                    parentId
                    tenantId
                    updatedAt
                }
                parentId
                tenantId
                updatedAt
            }
            createdAt
            description
            iconUrl
            id
            isDeleted
            isEnabled
            name
            parent {
                createdAt
                description
                iconUrl
                id
                isDeleted
                isEnabled
                name
                parentId
                tenantId
                updatedAt
            }
            parentId
            tenantId
            updatedAt
        }
    }
`;
function VF(e) {
  const t = { ...vo, ...e };
  return n.useQuery(
    go,
    t
  );
}
function OF(e) {
  const t = { ...vo, ...e };
  return n.useLazyQuery(
    go,
    t
  );
}
function xF(e) {
  const t = e === n.skipToken ? e : { ...vo, ...e };
  return n.useSuspenseQuery(
    go,
    t
  );
}
const zg = {}, Fg = i`
    mutation ProductServiceUpdateCategory($id: String!, $input: ProductServiceCreateCategoryGqlInput!) {
        productServiceUpdateCategory(id: $id, input: $input)
    }
`;
function wF(e) {
  const t = { ...zg, ...e };
  return n.useMutation(
    Fg,
    t
  );
}
const Rg = {}, Gg = i`
    mutation ProductServiceUpdateColor($id: String!, $input: ProductServiceCreateColorGqlInput!) {
        productServiceUpdateColor(id: $id, input: $input)
    }
`;
function HF(e) {
  const t = { ...Rg, ...e };
  return n.useMutation(
    Gg,
    t
  );
}
const qg = {}, Eg = i`
    mutation ProductServiceUpdateProduct($id: String!, $input: ProductServiceProductGqlInput!) {
        productServiceUpdateProduct(id: $id, input: $input)
    }
`;
function NF(e) {
  const t = { ...qg, ...e };
  return n.useMutation(
    Eg,
    t
  );
}
const Vg = {}, Og = i`
    mutation ProductServiceUpdateBrand($id: String!, $input: BrandServiceBrandGqlInput!) {
        productServiceUpdateBrand(id: $id, input: $input)
    }
`;
function WF(e) {
  const t = { ...Vg, ...e };
  return n.useMutation(
    Og,
    t
  );
}
const fo = {}, Ao = i`
    query ProductServiceAllHomeCategories($pagination: PaginationArgs!) {
        productServiceAllHomeCategories(pagination: $pagination) {
            data {
                createdAt
                displayOrder
                id
                isDeleted
                isEnabled
                name
                productIds
                tenantId
                updatedAt
            }
            total
        }
    }
`;
function jF(e) {
  const t = { ...fo, ...e };
  return n.useQuery(
    Ao,
    t
  );
}
function KF(e) {
  const t = { ...fo, ...e };
  return n.useLazyQuery(
    Ao,
    t
  );
}
function ZF(e) {
  const t = e === n.skipToken ? e : { ...fo, ...e };
  return n.useSuspenseQuery(
    Ao,
    t
  );
}
const Io = {}, $o = i`
    query ProductServiceHomeCategoryById($id: String!) {
        productServiceHomeCategoryById(id: $id) {
            createdAt
            displayOrder
            id
            isDeleted
            isEnabled
            name
            productIds
            tenantId
            updatedAt
        }
    }
`;
function YF(e) {
  const t = { ...Io, ...e };
  return n.useQuery(
    $o,
    t
  );
}
function JF(e) {
  const t = { ...Io, ...e };
  return n.useLazyQuery(
    $o,
    t
  );
}
function _F(e) {
  const t = e === n.skipToken ? e : { ...Io, ...e };
  return n.useSuspenseQuery(
    $o,
    t
  );
}
const Qo = {}, Co = i`
    query ProductServicePublicHomeCategories($pagination: PaginationArgs!) {
        productServicePublicHomeCategories(pagination: $pagination) {
            createdAt
            displayOrder
            id
            isDeleted
            isEnabled
            name
            productIds
            tenantId
            updatedAt
        }
    }
`;
function XF(e) {
  const t = { ...Qo, ...e };
  return n.useQuery(
    Co,
    t
  );
}
function eR(e) {
  const t = { ...Qo, ...e };
  return n.useLazyQuery(Co, t);
}
function tR(e) {
  const t = e === n.skipToken ? e : { ...Qo, ...e };
  return n.useSuspenseQuery(Co, t);
}
const ho = {}, ko = i`
    query ProductServiceProductsFromHomeCategory($id: String!, $pagination: PaginationArgs!) {
        productServiceProductsFromHomeCategory(id: $id, pagination: $pagination) {
            brandIds
            categoryIds
            commonAttributes {
                key
                value
            }
            contentId
            createdAt
            currency
            deletedAt
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            shortDescription
            source
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isEnabled
                isFlashSale
                isSale
                mediaUrls
                name
                price
                priceFormatted
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                sku
            }
        }
    }
`;
function nR(e) {
  const t = { ...ho, ...e };
  return n.useQuery(ko, t);
}
function iR(e) {
  const t = { ...ho, ...e };
  return n.useLazyQuery(ko, t);
}
function rR(e) {
  const t = e === n.skipToken ? e : { ...ho, ...e };
  return n.useSuspenseQuery(ko, t);
}
const xg = {}, wg = i`
    mutation ProductServiceCreateHomeCategory($input: ProductServiceCreateHomeCategoryGqlInput!) {
        productServiceCreateHomeCategory(input: $input)
    }
`;
function sR(e) {
  const t = { ...xg, ...e };
  return n.useMutation(wg, t);
}
const Hg = {}, Ng = i`
    mutation ProductServiceUpdateHomeCategory($id: String!, $input: ProductServiceUpdateHomeCategoryGqlInput!) {
        productServiceUpdateHomeCategory(id: $id, input: $input)
    }
`;
function oR(e) {
  const t = { ...Hg, ...e };
  return n.useMutation(Ng, t);
}
const Wg = {}, jg = i`
    mutation ProductServiceDeleteHomeCategory($id: String!) {
        productServiceDeleteHomeCategory(id: $id)
    }
`;
function aR(e) {
  const t = { ...Wg, ...e };
  return n.useMutation(jg, t);
}
const Do = {}, Po = i`
    query ProductServicePublicServices($pagination: PaginationArgs!) {
        productServicePublicServices(pagination: $pagination) {
            categoryIds
            commonAttributes {
                key
                value
            }
            createdAt
            currency
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            shortDescription
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            type
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isFlashSale
                mediaUrls
                name
                price
                priceFormatted
                sku
                isEnabled
                isSale
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
            }
        }
    }
`;
function uR(e) {
  const t = { ...Do, ...e };
  return n.useQuery(
    Po,
    t
  );
}
function cR(e) {
  const t = { ...Do, ...e };
  return n.useLazyQuery(
    Po,
    t
  );
}
function dR(e) {
  const t = e === n.skipToken ? e : { ...Do, ...e };
  return n.useSuspenseQuery(
    Po,
    t
  );
}
const To = {}, Mo = i`
    query ProductServiceSearchServices($input: ProductServiceSearchProductGqlInput!, $pagination: PaginationArgs!) {
        productServiceSearchServices(input: $input, pagination: $pagination) {
            categoryIds
            commonAttributes {
                key
                value
            }
            createdAt
            currency
            description
            displayOrder
            id
            isDeleted
            isEnabled
            isFeatured
            isLatest
            mediaUrls
            merchantNames
            shortDescription
            summarizedAttributes {
                displayName
                key
                values
            }
            tags
            tenantId
            thumbnailUrl
            title
            type
            updatedAt
            variants {
                attributes {
                    key
                    value
                }
                basePrice
                basePriceFormatted
                flashSale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
                isFlashSale
                mediaUrls
                name
                price
                priceFormatted
                sku
                isEnabled
                isSale
                sale {
                    salePrice
                    saleStartDate
                    saleEndDate
                }
            }
        }
    }
`;
function pR(e) {
  const t = { ...To, ...e };
  return n.useQuery(
    Mo,
    t
  );
}
function lR(e) {
  const t = { ...To, ...e };
  return n.useLazyQuery(
    Mo,
    t
  );
}
function yR(e) {
  const t = e === n.skipToken ? e : { ...To, ...e };
  return n.useSuspenseQuery(
    Mo,
    t
  );
}
const bo = {}, Lo = i`
    query RatingServiceCheckRatingStatus($input: RatingServiceCheckRatingStatusGqlInput!) {
        ratingServiceCheckRatingStatus(input: $input) {
            hasRated
            rating {
                id
                userId
                referenceId
                referenceType
                rating
                comment
                createdAt
                updatedAt
            }
        }
    }
`;
function SR(e) {
  const t = { ...bo, ...e };
  return n.useQuery(
    Lo,
    t
  );
}
function mR(e) {
  const t = { ...bo, ...e };
  return n.useLazyQuery(
    Lo,
    t
  );
}
function vR(e) {
  const t = e === n.skipToken ? e : { ...bo, ...e };
  return n.useSuspenseQuery(
    Lo,
    t
  );
}
const Bo = {}, Uo = i`
    query RatingServiceCheckFavoriteStatus($input: RatingServiceCheckGqlInput!) {
        ratingServiceCheckFavoriteStatus(input: $input) {
            isFavorited
            favoriteId
        }
    }
`;
function gR(e) {
  const t = { ...Bo, ...e };
  return n.useQuery(
    Uo,
    t
  );
}
function fR(e) {
  const t = { ...Bo, ...e };
  return n.useLazyQuery(
    Uo,
    t
  );
}
function AR(e) {
  const t = e === n.skipToken ? e : { ...Bo, ...e };
  return n.useSuspenseQuery(Uo, t);
}
const zo = {}, Fo = i`
    query RatingServiceGetMyFavorites($input: RatingServiceGetFavoritesGqlInput!, $pagination: PaginationArgs!) {
        ratingServiceGetMyFavorites(input: $input, pagination: $pagination) {
            data {
                id
                userId
                referenceId
                referenceType
                isFavorited
                tenantId
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function IR(e) {
  const t = { ...zo, ...e };
  return n.useQuery(
    Fo,
    t
  );
}
function $R(e) {
  const t = { ...zo, ...e };
  return n.useLazyQuery(
    Fo,
    t
  );
}
function QR(e) {
  const t = e === n.skipToken ? e : { ...zo, ...e };
  return n.useSuspenseQuery(
    Fo,
    t
  );
}
const Ro = {}, Go = i`
    query RatingServiceGetRatingDetails($id: String!) {
        ratingServiceGetRatingDetails(id: $id) {
            id
            userId
            referenceId
            referenceType
            rating
            comment
            mediaUrls
            tenantId
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function CR(e) {
  const t = { ...Ro, ...e };
  return n.useQuery(
    Go,
    t
  );
}
function hR(e) {
  const t = { ...Ro, ...e };
  return n.useLazyQuery(
    Go,
    t
  );
}
function kR(e) {
  const t = e === n.skipToken ? e : { ...Ro, ...e };
  return n.useSuspenseQuery(
    Go,
    t
  );
}
const qo = {}, Eo = i`
    query RatingServiceGetRatingsByFilter($input: RatingServiceGetRatingsGqlInput, $pagination: PaginationArgs!) {
        ratingServiceGetRatingsByFilter(input: $input, pagination: $pagination) {
            data {
                id
                userId
                referenceId
                referenceType
                rating
                comment
                mediaUrls
                tenantId
                createdAt
                updatedAt
                deletedAt
            }
            total
        }
    }
`;
function DR(e) {
  const t = { ...qo, ...e };
  return n.useQuery(
    Eo,
    t
  );
}
function PR(e) {
  const t = { ...qo, ...e };
  return n.useLazyQuery(
    Eo,
    t
  );
}
function TR(e) {
  const t = e === n.skipToken ? e : { ...qo, ...e };
  return n.useSuspenseQuery(
    Eo,
    t
  );
}
const Vo = {}, Oo = i`
    query RatingServiceMyRatings($pagination: PaginationArgs!) {
        ratingServiceMyRatings(pagination: $pagination) {
            data {
                id
                userId
                referenceId
                referenceType
                rating
                comment
                mediaUrls
                tenantId
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function MR(e) {
  const t = { ...Vo, ...e };
  return n.useQuery(
    Oo,
    t
  );
}
function bR(e) {
  const t = { ...Vo, ...e };
  return n.useLazyQuery(
    Oo,
    t
  );
}
function LR(e) {
  const t = e === n.skipToken ? e : { ...Vo, ...e };
  return n.useSuspenseQuery(
    Oo,
    t
  );
}
const xo = {}, wo = i`
    query RatingServiceRatingSummary($referenceId: String!, $referenceType: RatingReferenceTypeEnum!) {
        ratingServiceRatingSummary(referenceId: $referenceId, referenceType: $referenceType) {
            id
            referenceId
            referenceType
            averageRating
            totalRatings
            totalComments
            ratingDistribution
            tenantId
            lastUpdated
        }
    }
`;
function BR(e) {
  const t = { ...xo, ...e };
  return n.useQuery(
    wo,
    t
  );
}
function UR(e) {
  const t = { ...xo, ...e };
  return n.useLazyQuery(
    wo,
    t
  );
}
function zR(e) {
  const t = e === n.skipToken ? e : { ...xo, ...e };
  return n.useSuspenseQuery(
    wo,
    t
  );
}
const Kg = {}, Zg = i`
    mutation RatingServiceCreateRating($input: RatingServiceCreateRatingGqlInput!) {
        ratingServiceCreateRating(input: $input) {
            id
            userId
            referenceId
            referenceType
            rating
            comment
            mediaUrls
            tenantId
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function FR(e) {
  const t = { ...Kg, ...e };
  return n.useMutation(
    Zg,
    t
  );
}
const Yg = {}, Jg = i`
    mutation RatingServiceDeleteRating($id: String!) {
        ratingServiceDeleteRating(id: $id)
    }
`;
function RR(e) {
  const t = { ...Yg, ...e };
  return n.useMutation(
    Jg,
    t
  );
}
const _g = {}, Xg = i`
    mutation RatingServiceDeleteRatingForAdmin($id: String!) {
        ratingServiceDeleteRatingForAdmin(id: $id)
    }
`;
function GR(e) {
  const t = { ..._g, ...e };
  return n.useMutation(Xg, t);
}
const ef = {}, tf = i`
    mutation RatingServiceToggleFavorite($input: RatingServiceToggleFavoriteGqlInput!) {
        ratingServiceToggleFavorite(input: $input) {
            id
            isFavorited
            referenceId
            referenceType
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function qR(e) {
  const t = { ...ef, ...e };
  return n.useMutation(
    tf,
    t
  );
}
const nf = {}, rf = i`
    mutation RatingServiceUpdateRating($id: String!, $input: RatingServiceUpdateRatingGqlInput!) {
        ratingServiceUpdateRating(id: $id, input: $input) {
            id
            userId
            referenceId
            referenceType
            rating
            comment
            mediaUrls
            tenantId
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function ER(e) {
  const t = { ...nf, ...e };
  return n.useMutation(
    rf,
    t
  );
}
const sf = {}, of = i`
    mutation RbacServiceAssignRoleToUser($input: RbacServiceAssignRoleGqlInput!) {
        rbacServiceAssignRoleToUser(input: $input)
    }
`;
function VR(e) {
  const t = { ...sf, ...e };
  return n.useMutation(
    of,
    t
  );
}
const af = {}, uf = i`
    mutation RbacServiceCreateRole($input: RbacServiceCreateRoleGqlInput!) {
        rbacServiceCreateRole(input: $input) {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function OR(e) {
  const t = { ...af, ...e };
  return n.useMutation(
    uf,
    t
  );
}
const cf = {}, df = i`
    mutation RbacServiceDeleteRole($roleId: String!) {
        rbacServiceDeleteRole(roleId: $roleId)
    }
`;
function xR(e) {
  const t = { ...cf, ...e };
  return n.useMutation(
    df,
    t
  );
}
const pf = {}, lf = i`
    mutation RbacServiceUnassignRoleFromUser($input: RbacServiceAssignRoleGqlInput!) {
        rbacServiceUnassignRoleFromUser(input: $input)
    }
`;
function wR(e) {
  const t = { ...pf, ...e };
  return n.useMutation(lf, t);
}
const yf = {}, Sf = i`
    mutation RbacServiceUpdateRole($input: RbacServiceUpdateRoleGqlInput!, $roleId: String!) {
        rbacServiceUpdateRole(input: $input, roleId: $roleId) {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function HR(e) {
  const t = { ...yf, ...e };
  return n.useMutation(
    Sf,
    t
  );
}
const mf = {}, vf = i`
    mutation RbacServiceValidatePermission($permission: RbacServicePermissionGqlInput!) {
        rbacServiceValidatePermission(permission: $permission)
    }
`;
function NR(e) {
  const t = { ...mf, ...e };
  return n.useMutation(
    vf,
    t
  );
}
const Ho = {}, No = i`
    query RbacServiceAvailablePermissions {
        rbacServiceAvailablePermissions {
            action
            possession
            resource
        }
    }
`;
function WR(e) {
  const t = { ...Ho, ...e };
  return n.useQuery(
    No,
    t
  );
}
function jR(e) {
  const t = { ...Ho, ...e };
  return n.useLazyQuery(
    No,
    t
  );
}
function KR(e) {
  const t = e === n.skipToken ? e : { ...Ho, ...e };
  return n.useSuspenseQuery(
    No,
    t
  );
}
const Wo = {}, jo = i`
    query RbacServiceCurrentUserRole {
        rbacServiceCurrentUserRole {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function ZR(e) {
  const t = { ...Wo, ...e };
  return n.useQuery(
    jo,
    t
  );
}
function YR(e) {
  const t = { ...Wo, ...e };
  return n.useLazyQuery(
    jo,
    t
  );
}
function JR(e) {
  const t = e === n.skipToken ? e : { ...Wo, ...e };
  return n.useSuspenseQuery(
    jo,
    t
  );
}
const Ko = {}, Zo = i`
    query RbacServiceRoleById($roleId: String!) {
        rbacServiceRoleById(roleId: $roleId) {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function _R(e) {
  const t = { ...Ko, ...e };
  return n.useQuery(
    Zo,
    t
  );
}
function XR(e) {
  const t = { ...Ko, ...e };
  return n.useLazyQuery(
    Zo,
    t
  );
}
function eG(e) {
  const t = e === n.skipToken ? e : { ...Ko, ...e };
  return n.useSuspenseQuery(
    Zo,
    t
  );
}
const Yo = {}, Jo = i`
    query RbacServiceRoles {
        rbacServiceRoles {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function tG(e) {
  const t = { ...Yo, ...e };
  return n.useQuery(Jo, t);
}
function nG(e) {
  const t = { ...Yo, ...e };
  return n.useLazyQuery(
    Jo,
    t
  );
}
function iG(e) {
  const t = e === n.skipToken ? e : { ...Yo, ...e };
  return n.useSuspenseQuery(
    Jo,
    t
  );
}
const _o = {}, Xo = i`
    query RbacServiceRolesByOrganization {
        rbacServiceRolesByOrganization {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function rG(e) {
  const t = { ..._o, ...e };
  return n.useQuery(
    Xo,
    t
  );
}
function sG(e) {
  const t = { ..._o, ...e };
  return n.useLazyQuery(
    Xo,
    t
  );
}
function oG(e) {
  const t = e === n.skipToken ? e : { ..._o, ...e };
  return n.useSuspenseQuery(
    Xo,
    t
  );
}
const ea = {}, ta = i`
    query RbacServiceRolesByOwn {
        rbacServiceRolesByOwn {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function aG(e) {
  const t = { ...ea, ...e };
  return n.useQuery(
    ta,
    t
  );
}
function uG(e) {
  const t = { ...ea, ...e };
  return n.useLazyQuery(
    ta,
    t
  );
}
function cG(e) {
  const t = e === n.skipToken ? e : { ...ea, ...e };
  return n.useSuspenseQuery(
    ta,
    t
  );
}
const na = {}, ia = i`
    query RbacServiceRolesByTenant {
        rbacServiceRolesByTenant {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function dG(e) {
  const t = { ...na, ...e };
  return n.useQuery(
    ia,
    t
  );
}
function pG(e) {
  const t = { ...na, ...e };
  return n.useLazyQuery(
    ia,
    t
  );
}
function lG(e) {
  const t = e === n.skipToken ? e : { ...na, ...e };
  return n.useSuspenseQuery(
    ia,
    t
  );
}
const ra = {}, sa = i`
    query RbacServiceUserRoles($userIds: [String!]!) {
        rbacServiceUserRoles(userIds: $userIds) {
            id
            name
            description
            isActive
            isDeleted
            createdAt
            updatedAt
            createdBy
            tenantId
            organizationId
            permissions {
                action
                possession
                resource
            }
        }
    }
`;
function yG(e) {
  const t = { ...ra, ...e };
  return n.useQuery(
    sa,
    t
  );
}
function SG(e) {
  const t = { ...ra, ...e };
  return n.useLazyQuery(
    sa,
    t
  );
}
function mG(e) {
  const t = e === n.skipToken ? e : { ...ra, ...e };
  return n.useSuspenseQuery(
    sa,
    t
  );
}
const oa = {}, aa = i`
    query ReferralServiceCommissionHistory($input: PaginationArgs) {
        referralServiceCommissionHistory(input: $input) {
            commissions {
                amount
                createdAt
                id
                level
                parentUserId
                percentage
                processedAt
                sourceAmount
                sourceReference
                status
            }
            hasNextPage
            totalCount
        }
    }
`;
function vG(e) {
  const t = { ...oa, ...e };
  return n.useQuery(
    aa,
    t
  );
}
function gG(e) {
  const t = { ...oa, ...e };
  return n.useLazyQuery(
    aa,
    t
  );
}
function fG(e) {
  const t = e === n.skipToken ? e : { ...oa, ...e };
  return n.useSuspenseQuery(aa, t);
}
const gf = {}, ff = i`
    mutation ReferralServiceConfigureReferralSystemForAgency($input: ReferralConfigInput!) {
        referralServiceConfigureReferralSystemForAgency(input: $input) {
            success
            config {
                allowCustomCodes
                codePrefix
                commissionRates {
                    fixedAmount
                    level
                    percentage
                    type
                }
                id
                isActive
                maxLevels
                minPayoutAmount
                voucherTypeId
            }
        }
    }
`;
function AG(e) {
  const t = { ...gf, ...e };
  return n.useMutation(ff, t);
}
const Af = {}, If = i`
    mutation ReferralServiceConfigureReferralSystemForOrganization($input: ReferralConfigInput!) {
        referralServiceConfigureReferralSystemForOrganization(input: $input) {
            success
            config {
                allowCustomCodes
                codePrefix
                commissionRates {
                    fixedAmount
                    level
                    percentage
                    type
                }
                id
                isActive
                maxLevels
                minPayoutAmount
                voucherTypeId
            }
        }
    }
`;
function IG(e) {
  const t = { ...Af, ...e };
  return n.useMutation(If, t);
}
const $f = {}, Qf = i`
    mutation ReferralServiceCreateReferralCode {
        referralServiceCreateReferralCode {
            code
            success
        }
    }
`;
function $G(e) {
  const t = { ...$f, ...e };
  return n.useMutation(Qf, t);
}
const ua = {}, ca = i`
    query ReferralServiceMyReferralCode {
        referralServiceMyReferralCode {
            code
            createdAt
            isActive
            usageCount
        }
    }
`;
function QG(e) {
  const t = { ...ua, ...e };
  return n.useQuery(
    ca,
    t
  );
}
function CG(e) {
  const t = { ...ua, ...e };
  return n.useLazyQuery(
    ca,
    t
  );
}
function hG(e) {
  const t = e === n.skipToken ? e : { ...ua, ...e };
  return n.useSuspenseQuery(
    ca,
    t
  );
}
const da = {}, pa = i`
    query ReferralServiceMyReferralTree {
        referralServiceMyReferralTree {
            userId
            totalCommissionEarned
            totalReferrals
            children {
                userId
                joinedAt
                level
                totalCommissionEarned
                totalReferrals
                children {
                    userId
                    joinedAt
                    level
                    totalCommissionEarned
                    totalReferrals
                }
            }
        }
    }
`;
function kG(e) {
  const t = { ...da, ...e };
  return n.useQuery(
    pa,
    t
  );
}
function DG(e) {
  const t = { ...da, ...e };
  return n.useLazyQuery(
    pa,
    t
  );
}
function PG(e) {
  const t = e === n.skipToken ? e : { ...da, ...e };
  return n.useSuspenseQuery(
    pa,
    t
  );
}
const Cf = {}, hf = i`
    mutation ReferralServiceProcessReferral($input: ReferralProcessingInput!) {
        referralServiceProcessReferral(input: $input) {
            commissionsProcessed
            success
            totalCommissionDistributed
        }
    }
`;
function TG(e) {
  const t = { ...Cf, ...e };
  return n.useMutation(
    hf,
    t
  );
}
const la = {}, ya = i`
    query ReferralServiceReferralConfig {
        referralServiceReferralConfig {
            success
            config {
                allowCustomCodes
                codePrefix
                commissionRates {
                    fixedAmount
                    level
                    percentage
                    type
                }
                description
                id
                isActive
                maxLevels
                minPayoutAmount
                rewardVoucherTypeIds {
                    qty
                    voucherTypeId
                }
                title
                voucherTypeId
            }
        }
    }
`;
function MG(e) {
  const t = { ...la, ...e };
  return n.useQuery(
    ya,
    t
  );
}
function bG(e) {
  const t = { ...la, ...e };
  return n.useLazyQuery(
    ya,
    t
  );
}
function LG(e) {
  const t = e === n.skipToken ? e : { ...la, ...e };
  return n.useSuspenseQuery(
    ya,
    t
  );
}
const Sa = {}, ma = i`
    query ReferralServiceReferralConfigForAgency {
        referralServiceReferralConfigForAgency {
            success
            config {
                allowCustomCodes
                codePrefix
                commissionRates {
                    fixedAmount
                    level
                    percentage
                    type
                }
                id
                isActive
                maxLevels
                minPayoutAmount
                voucherTypeId
            }
        }
    }
`;
function BG(e) {
  const t = { ...Sa, ...e };
  return n.useQuery(ma, t);
}
function UG(e) {
  const t = { ...Sa, ...e };
  return n.useLazyQuery(ma, t);
}
function zG(e) {
  const t = e === n.skipToken ? e : { ...Sa, ...e };
  return n.useSuspenseQuery(ma, t);
}
const va = {}, ga = i`
    query ReferralServiceReferralStatistics {
        referralServiceReferralStatistics {
            pendingCommissions
            thisMonthCommission
            thisMonthReferrals
            totalCommissionEarned
            totalReferrals
        }
    }
`;
function FG(e) {
  const t = { ...va, ...e };
  return n.useQuery(
    ga,
    t
  );
}
function RG(e) {
  const t = { ...va, ...e };
  return n.useLazyQuery(
    ga,
    t
  );
}
function GG(e) {
  const t = e === n.skipToken ? e : { ...va, ...e };
  return n.useSuspenseQuery(ga, t);
}
const fa = {}, Aa = i`
    query ReferralServiceReferralTreeForAgency($input: GetReferralTreeInput!) {
        referralServiceReferralTreeForAgency(input: $input) {
            userId
            totalCommissionEarned
            totalReferrals
            children {
                userId
                joinedAt
                level
                totalCommissionEarned
                totalReferrals
                children {
                    userId
                    joinedAt
                    level
                    totalCommissionEarned
                    totalReferrals
                }
            }
        }
    }
`;
function qG(e) {
  const t = { ...fa, ...e };
  return n.useQuery(Aa, t);
}
function EG(e) {
  const t = { ...fa, ...e };
  return n.useLazyQuery(Aa, t);
}
function VG(e) {
  const t = e === n.skipToken ? e : { ...fa, ...e };
  return n.useSuspenseQuery(Aa, t);
}
const Ia = {}, $a = i`
    query ReferralServiceReferralTreeForOrganization($input: GetReferralTreeInput!) {
        referralServiceReferralTreeForOrganization(input: $input) {
            userId
            totalCommissionEarned
            totalReferrals
            children {
                userId
                joinedAt
                level
                totalCommissionEarned
                totalReferrals
                children {
                    userId
                    joinedAt
                    level
                    totalCommissionEarned
                    totalReferrals
                }
            }
        }
    }
`;
function OG(e) {
  const t = { ...Ia, ...e };
  return n.useQuery($a, t);
}
function xG(e) {
  const t = { ...Ia, ...e };
  return n.useLazyQuery($a, t);
}
function wG(e) {
  const t = e === n.skipToken ? e : { ...Ia, ...e };
  return n.useSuspenseQuery($a, t);
}
const kf = {}, Df = i`
    mutation ReferralServiceSaveReferral($input: SaveReferralInput!) {
        referralServiceSaveReferral(input: $input) {
            level
            parentUserId
            success
        }
    }
`;
function HG(e) {
  const t = { ...kf, ...e };
  return n.useMutation(
    Df,
    t
  );
}
const Pf = {}, Tf = i`
    mutation ReferralServiceUseReferralCode($input: UseReferralCodeInput!) {
        referralServiceUseReferralCode(input: $input) {
            level
            message
            parentUserId
            success
        }
    }
`;
function NG(e) {
  const t = { ...Pf, ...e };
  return n.useMutation(
    Tf,
    t
  );
}
const Qa = {}, Ca = i`
    query SduiServiceBlock($id: String!) {
        sduiServiceBlock(id: $id) {
            id
            code
            tenantId
            configs {
                key
                type
                value
            }
            createdAt
            updatedAt
        }
    }
`;
function WG(e) {
  const t = { ...Qa, ...e };
  return n.useQuery(Ca, t);
}
function jG(e) {
  const t = { ...Qa, ...e };
  return n.useLazyQuery(
    Ca,
    t
  );
}
function KG(e) {
  const t = e === n.skipToken ? e : { ...Qa, ...e };
  return n.useSuspenseQuery(
    Ca,
    t
  );
}
const ha = {}, ka = i`
    query SduiServiceBlockByCode($code: String!) {
        sduiServiceBlockByCode(code: $code) {
            id
            code
            tenantId
            configs {
                key
                type
                value
            }
            createdAt
            updatedAt
        }
    }
`;
function ZG(e) {
  const t = { ...ha, ...e };
  return n.useQuery(
    ka,
    t
  );
}
function YG(e) {
  const t = { ...ha, ...e };
  return n.useLazyQuery(
    ka,
    t
  );
}
function JG(e) {
  const t = e === n.skipToken ? e : { ...ha, ...e };
  return n.useSuspenseQuery(
    ka,
    t
  );
}
const Da = {}, Pa = i`
    query SduiServiceBlocks {
        sduiServiceBlocks {
            id
            code
            tenantId
            configs {
                key
                type
                value
            }
            createdAt
            updatedAt
        }
    }
`;
function _G(e) {
  const t = { ...Da, ...e };
  return n.useQuery(Pa, t);
}
function XG(e) {
  const t = { ...Da, ...e };
  return n.useLazyQuery(
    Pa,
    t
  );
}
function eq(e) {
  const t = e === n.skipToken ? e : { ...Da, ...e };
  return n.useSuspenseQuery(
    Pa,
    t
  );
}
const Mf = {}, bf = i`
    mutation SduiServiceCreateBlock($input: SduiServiceCreateBlockGqlInput!) {
        sduiServiceCreateBlock(input: $input)
    }
`;
function tq(e) {
  const t = { ...Mf, ...e };
  return n.useMutation(
    bf,
    t
  );
}
const Lf = {}, Bf = i`
    mutation SduiServiceCreateLayout($input: SduiServiceCreateLayoutGqlInput!) {
        sduiServiceCreateLayout(input: $input)
    }
`;
function nq(e) {
  const t = { ...Lf, ...e };
  return n.useMutation(
    Bf,
    t
  );
}
const Uf = {}, zf = i`
    mutation SduiServiceCreatePage($input: SduiServiceCreatePageGqlInput!) {
        sduiServiceCreatePage(input: $input)
    }
`;
function iq(e) {
  const t = { ...Uf, ...e };
  return n.useMutation(
    zf,
    t
  );
}
const Ff = {}, Rf = i`
    mutation SduiServiceDeleteBlock($id: String!) {
        sduiServiceDeleteBlock(id: $id)
    }
`;
function rq(e) {
  const t = { ...Ff, ...e };
  return n.useMutation(
    Rf,
    t
  );
}
const Gf = {}, qf = i`
    mutation SduiServiceDeletePage($id: String!) {
        sduiServiceDeletePage(id: $id)
    }
`;
function sq(e) {
  const t = { ...Gf, ...e };
  return n.useMutation(
    qf,
    t
  );
}
const Ta = {}, Ma = i`
    query SduiServiceGetAllLayouts {
        sduiServiceGetAllLayouts {
            id
            layoutId
            tenantId
            components {
                banner {
                    action {
                        route
                        target
                        type
                        value
                    }
                    imageUrl
                }
                bottomNavBar {
                    items {
                        action {
                            route
                            target
                            type
                            value
                        }
                        icon
                        label
                    }
                    selectedIndex
                }
            }
            customFields {
                fieldName
                fieldType
                fieldValue
            }
            modules {
                action {
                    route
                    target
                    type
                    value
                }
                featureCode
                icon
                isShow
                title
            }
            theme {
                backgroundColor
                buttonStyle
                color
                fontFamily
                fontSize
                primaryColor
                secondaryColor
                themeName
            }
        }
    }
`;
function oq(e) {
  const t = { ...Ta, ...e };
  return n.useQuery(
    Ma,
    t
  );
}
function aq(e) {
  const t = { ...Ta, ...e };
  return n.useLazyQuery(
    Ma,
    t
  );
}
function uq(e) {
  const t = e === n.skipToken ? e : { ...Ta, ...e };
  return n.useSuspenseQuery(
    Ma,
    t
  );
}
const ba = {}, La = i`
    query SduiServiceGetLayoutDetail($id: String!) {
        sduiServiceGetLayoutDetail(id: $id) {
            id
            layoutId
            tenantId
            components {
                banner {
                    action {
                        route
                        target
                        type
                        value
                    }
                    imageUrl
                }
                bottomNavBar {
                    items {
                        action {
                            route
                            target
                            type
                            value
                        }
                        icon
                        label
                    }
                    selectedIndex
                }
            }
            customFields {
                fieldName
                fieldType
                fieldValue
            }
            modules {
                action {
                    route
                    target
                    type
                    value
                }
                featureCode
                icon
                isShow
                title
            }
            theme {
                backgroundColor
                buttonStyle
                color
                fontFamily
                fontSize
                primaryColor
                secondaryColor
                themeName
            }
        }
    }
`;
function cq(e) {
  const t = { ...ba, ...e };
  return n.useQuery(
    La,
    t
  );
}
function dq(e) {
  const t = { ...ba, ...e };
  return n.useLazyQuery(
    La,
    t
  );
}
function pq(e) {
  const t = e === n.skipToken ? e : { ...ba, ...e };
  return n.useSuspenseQuery(
    La,
    t
  );
}
const Ba = {}, Ua = i`
    query SduiServiceGetLayout {
        sduiServiceGetLayout {
            id
            layoutId
            tenantId
            components {
                banner {
                    action {
                        route
                        target
                        type
                        value
                    }
                    imageUrl
                }
                bottomNavBar {
                    items {
                        action {
                            route
                            target
                            type
                            value
                        }
                        icon
                        label
                    }
                    selectedIndex
                }
            }
            customFields {
                fieldName
                fieldType
                fieldValue
            }
            modules {
                action {
                    route
                    target
                    type
                    value
                }
                featureCode
                icon
                isShow
                title
            }
            theme {
                backgroundColor
                buttonStyle
                color
                fontFamily
                fontSize
                primaryColor
                secondaryColor
                themeName
            }
        }
    }
`;
function lq(e) {
  const t = { ...Ba, ...e };
  return n.useQuery(
    Ua,
    t
  );
}
function yq(e) {
  const t = { ...Ba, ...e };
  return n.useLazyQuery(
    Ua,
    t
  );
}
function Sq(e) {
  const t = e === n.skipToken ? e : { ...Ba, ...e };
  return n.useSuspenseQuery(
    Ua,
    t
  );
}
const za = {}, Fa = i`
    query SduiServiceGetLayouts {
        sduiServiceGetLayouts {
            id
            layoutId
            tenantId
            components {
                banner {
                    action {
                        route
                        target
                        type
                        value
                    }
                    imageUrl
                }
                bottomNavBar {
                    items {
                        action {
                            route
                            target
                            type
                            value
                        }
                        icon
                        label
                    }
                    selectedIndex
                }
            }
            customFields {
                fieldName
                fieldType
                fieldValue
            }
            modules {
                action {
                    route
                    target
                    type
                    value
                }
                featureCode
                icon
                isShow
                title
            }
            theme {
                backgroundColor
                buttonStyle
                color
                fontFamily
                fontSize
                primaryColor
                secondaryColor
                themeName
            }
        }
    }
`;
function mq(e) {
  const t = { ...za, ...e };
  return n.useQuery(
    Fa,
    t
  );
}
function vq(e) {
  const t = { ...za, ...e };
  return n.useLazyQuery(
    Fa,
    t
  );
}
function gq(e) {
  const t = e === n.skipToken ? e : { ...za, ...e };
  return n.useSuspenseQuery(
    Fa,
    t
  );
}
const Ra = {}, Ga = i`
    query SduiServiceGetTenantLayout {
        sduiServiceGetTenantLayout {
            id
            layoutId
            tenantId
            components {
                banner {
                    action {
                        route
                        target
                        type
                        value
                    }
                    imageUrl
                }
                bottomNavBar {
                    items {
                        action {
                            route
                            target
                            type
                            value
                        }
                        icon
                        label
                    }
                    selectedIndex
                }
            }
            customFields {
                fieldName
                fieldType
                fieldValue
            }
            modules {
                action {
                    route
                    target
                    type
                    value
                }
                featureCode
                icon
                isShow
                title
            }
            theme {
                backgroundColor
                buttonStyle
                color
                fontFamily
                fontSize
                primaryColor
                secondaryColor
                themeName
            }
        }
    }
`;
function fq(e) {
  const t = { ...Ra, ...e };
  return n.useQuery(
    Ga,
    t
  );
}
function Aq(e) {
  const t = { ...Ra, ...e };
  return n.useLazyQuery(
    Ga,
    t
  );
}
function Iq(e) {
  const t = e === n.skipToken ? e : { ...Ra, ...e };
  return n.useSuspenseQuery(
    Ga,
    t
  );
}
const qa = {}, Ea = i`
    query SduiServicePage($id: String!) {
        sduiServicePage(id: $id) {
            id
            key
            tenantId
            blocks {
                block
                title
                configs {
                    key
                    type
                    value
                }
            }
            createdAt
            updatedAt
        }
    }
`;
function $q(e) {
  const t = { ...qa, ...e };
  return n.useQuery(Ea, t);
}
function Qq(e) {
  const t = { ...qa, ...e };
  return n.useLazyQuery(Ea, t);
}
function Cq(e) {
  const t = e === n.skipToken ? e : { ...qa, ...e };
  return n.useSuspenseQuery(
    Ea,
    t
  );
}
const Va = {}, Oa = i`
    query SduiServicePageByKey($key: String!) {
        sduiServicePageByKey(key: $key) {
            id
            key
            tenantId
            blocks {
                block
                title
                configs {
                    key
                    type
                    value
                }
            }
            createdAt
            updatedAt
        }
    }
`;
function hq(e) {
  const t = { ...Va, ...e };
  return n.useQuery(
    Oa,
    t
  );
}
function kq(e) {
  const t = { ...Va, ...e };
  return n.useLazyQuery(
    Oa,
    t
  );
}
function Dq(e) {
  const t = e === n.skipToken ? e : { ...Va, ...e };
  return n.useSuspenseQuery(
    Oa,
    t
  );
}
const xa = {}, wa = i`
    query SduiServicePages {
        sduiServicePages {
            id
            key
            tenantId
            blocks {
                block
                title
                configs {
                    key
                    type
                    value
                }
            }
            createdAt
            updatedAt
        }
    }
`;
function Pq(e) {
  const t = { ...xa, ...e };
  return n.useQuery(wa, t);
}
function Tq(e) {
  const t = { ...xa, ...e };
  return n.useLazyQuery(
    wa,
    t
  );
}
function Mq(e) {
  const t = e === n.skipToken ? e : { ...xa, ...e };
  return n.useSuspenseQuery(
    wa,
    t
  );
}
const Ef = {}, Vf = i`
    mutation SduiServiceToggleLayout($id: String!) {
        sduiServiceToggleLayout(id: $id)
    }
`;
function bq(e) {
  const t = { ...Ef, ...e };
  return n.useMutation(
    Vf,
    t
  );
}
const Of = {}, xf = i`
    mutation SduiServiceUpdateBlock($id: String!, $input: SduiServiceUpdateBlockGqlInput!) {
        sduiServiceUpdateBlock(id: $id, input: $input)
    }
`;
function Lq(e) {
  const t = { ...Of, ...e };
  return n.useMutation(
    xf,
    t
  );
}
const wf = {}, Hf = i`
    mutation SduiServiceUpdateLayout($id: String!, $input: SduiServiceUpdateLayoutGqlInput!) {
        sduiServiceUpdateLayout(id: $id, input: $input)
    }
`;
function Bq(e) {
  const t = { ...wf, ...e };
  return n.useMutation(
    Hf,
    t
  );
}
const Nf = {}, Wf = i`
    mutation SduiServiceUpdatePage($id: String!, $input: SduiServiceUpdatePageGqlInput!) {
        sduiServiceUpdatePage(id: $id, input: $input)
    }
`;
function Uq(e) {
  const t = { ...Nf, ...e };
  return n.useMutation(
    Wf,
    t
  );
}
const jf = {}, Kf = i`
    mutation SduiServiceUpdateTenantLayout($input: SduiServiceUpdateTenantLayoutGqlInput!) {
        sduiServiceUpdateTenantLayout(input: $input)
    }
`;
function zq(e) {
  const t = { ...jf, ...e };
  return n.useMutation(
    Kf,
    t
  );
}
const Ha = {}, Na = i`
    query ShippingServiceProviders {
        shippingServiceProviders {
            id
            description
            fixedPrice
            logoUrl
            name
            status
        }
    }
`;
function Fq(e) {
  const t = { ...Ha, ...e };
  return n.useQuery(
    Na,
    t
  );
}
function Rq(e) {
  const t = { ...Ha, ...e };
  return n.useLazyQuery(
    Na,
    t
  );
}
function Gq(e) {
  const t = e === n.skipToken ? e : { ...Ha, ...e };
  return n.useSuspenseQuery(
    Na,
    t
  );
}
const Zf = {}, Yf = i`
    mutation ShippingServiceShippingMethodCreate($providerId: String!) {
        shippingServiceShippingMethodCreate(providerId: $providerId) {
            id
            tenantId
            providerId
            provider
            providerLogoUrl
            amount
            amountFormatted
            status
            createdAt
            updatedAt
        }
    }
`;
function qq(e) {
  const t = { ...Zf, ...e };
  return n.useMutation(Yf, t);
}
const Wa = {}, ja = i`
    query ShippingServiceShippingMethodsAvailable(
        $address: String!
        $cartIds: [String!]!
        $provinceId: String!
        $wardId: String!
    ) {
        shippingServiceShippingMethodsAvailable(
            address: $address
            cartIds: $cartIds
            provinceId: $provinceId
            wardId: $wardId
        ) {
            id
            amount
            amountFormatted
            createdAt
            provider
            providerId
            providerLogoUrl
            status
            tenantId
            updatedAt
        }
    }
`;
function Eq(e) {
  const t = { ...Wa, ...e };
  return n.useQuery(ja, t);
}
function Vq(e) {
  const t = { ...Wa, ...e };
  return n.useLazyQuery(ja, t);
}
function Oq(e) {
  const t = e === n.skipToken ? e : { ...Wa, ...e };
  return n.useSuspenseQuery(ja, t);
}
const Ka = {}, Za = i`
    query ShippingServiceShippingMethods {
        shippingServiceShippingMethods {
            id
            amount
            amountFormatted
            createdAt
            provider
            providerId
            providerLogoUrl
            status
            tenantId
            updatedAt
        }
    }
`;
function xq(e) {
  const t = { ...Ka, ...e };
  return n.useQuery(
    Za,
    t
  );
}
function wq(e) {
  const t = { ...Ka, ...e };
  return n.useLazyQuery(
    Za,
    t
  );
}
function Hq(e) {
  const t = e === n.skipToken ? e : { ...Ka, ...e };
  return n.useSuspenseQuery(
    Za,
    t
  );
}
const Jf = {}, _f = i`
    mutation ShippingServiceShippingMethodUpdateStatus($shippingMethodId: String!, $status: Boolean!) {
        shippingServiceShippingMethodUpdateStatus(shippingMethodId: $shippingMethodId, status: $status) {
            id
            tenantId
            providerId
            provider
            providerLogoUrl
            amount
            amountFormatted
            status
            createdAt
            updatedAt
        }
    }
`;
function Nq(e) {
  const t = { ...Jf, ...e };
  return n.useMutation(_f, t);
}
const Xf = {}, eA = i`
    mutation ShippingServiceShippingMethodUpdateFixedPrice($shippingMethodId: String!, $fixedPrice: Float!) {
        shippingServiceShippingMethodUpdateFixedPrice(shippingMethodId: $shippingMethodId, fixedPrice: $fixedPrice) {
            id
            tenantId
            providerId
            provider
            providerLogoUrl
            amount
            amountFormatted
            status
            createdAt
            updatedAt
        }
    }
`;
function Wq(e) {
  const t = { ...Xf, ...e };
  return n.useMutation(eA, t);
}
const Ya = {}, Ja = i`
    query StorageServiceGetFileMetadata($id: String!) {
        storageServiceGetFileMetadata(id: $id) {
            id
            mimeType
            ownerEntityId
            ownerService
            provider
            bucketKey
            bucketName
            sizeInBytes
            status
            tenantId
            createdAt
            updatedAt
        }
    }
`;
function jq(e) {
  const t = { ...Ya, ...e };
  return n.useQuery(
    Ja,
    t
  );
}
function Kq(e) {
  const t = { ...Ya, ...e };
  return n.useLazyQuery(
    Ja,
    t
  );
}
function Zq(e) {
  const t = e === n.skipToken ? e : { ...Ya, ...e };
  return n.useSuspenseQuery(
    Ja,
    t
  );
}
const tA = {}, nA = i`
    mutation SubscriptionServiceArchivePlan($id: ID!) {
        subscriptionServiceArchivePlan(id: $id) {
            id
            name
            code
            version
            description
            category
            pricing {
                monthly
                yearly
                setupFee
                trial {
                    days
                    autoConvert
                }
            }
            features
            usageMetrics
            billing {
                cycles
                proration
                downgradeProration
                upgradeProration
            }
            permissions
            roles
            isActive
            isArchived
            createdAt
            updatedAt
            createdBy
        }
    }
`;
function Yq(e) {
  const t = { ...tA, ...e };
  return n.useMutation(
    nA,
    t
  );
}
const _a = {}, Xa = i`
    query SubscriptionServiceAuditEvents($params: SubscriptionServiceAuditEventListParamsGqlInput) {
        subscriptionServiceAuditEvents(params: $params) {
            events {
                id
                subscriptionId
                tenantId
                eventType
                version
                changes
                initiatedBy
                reason
                metadata
                createdAt
                correlationId
            }
            total
            page
            limit
        }
    }
`;
function Jq(e) {
  const t = { ..._a, ...e };
  return n.useQuery(
    Xa,
    t
  );
}
function _q(e) {
  const t = { ..._a, ...e };
  return n.useLazyQuery(
    Xa,
    t
  );
}
function Xq(e) {
  const t = e === n.skipToken ? e : { ..._a, ...e };
  return n.useSuspenseQuery(
    Xa,
    t
  );
}
const eu = {}, tu = i`
    query SubscriptionServiceBillingTransactions($params: SubscriptionServiceBillingTransactionListParamsGqlInput) {
        subscriptionServiceBillingTransactions(params: $params) {
            transactions {
                id
                tenantId
                subscriptionId
                type
                amount
                currency
                status
                payment {
                    gateway
                    method
                    transactionId
                    invoiceId
                }
                billingPeriod {
                    start
                    end
                }
                invoice {
                    number
                    items {
                        description
                        quantity
                        unitPrice
                        total
                    }
                    subtotal
                    taxes
                    total
                    dueDate
                }
                processedAt
                processedBy
                retryCount
            }
            total
            page
            limit
        }
    }
`;
function eE(e) {
  const t = { ...eu, ...e };
  return n.useQuery(tu, t);
}
function tE(e) {
  const t = { ...eu, ...e };
  return n.useLazyQuery(tu, t);
}
function nE(e) {
  const t = e === n.skipToken ? e : { ...eu, ...e };
  return n.useSuspenseQuery(tu, t);
}
const iA = {}, rA = i`
    mutation SubscriptionServiceCancelSubscription($id: ID!, $input: SubscriptionServiceCancelSubscriptionGqlInput!) {
        subscriptionServiceCancelSubscription(id: $id, input: $input) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function iE(e) {
  const t = { ...iA, ...e };
  return n.useMutation(rA, t);
}
const sA = {}, oA = i`
    mutation SubscriptionServiceCreatePlan($input: SubscriptionServiceCreatePlanGqlInput!) {
        subscriptionServiceCreatePlan(input: $input) {
            id
            name
            code
            version
            description
            category
            pricing {
                monthly
                yearly
                setupFee
                trial {
                    days
                    autoConvert
                }
            }
            features
            usageMetrics
            billing {
                cycles
                proration
                downgradeProration
                upgradeProration
            }
            permissions
            roles
            isActive
            isArchived
            createdAt
            updatedAt
            createdBy
        }
    }
`;
function rE(e) {
  const t = { ...sA, ...e };
  return n.useMutation(
    oA,
    t
  );
}
const aA = {}, uA = i`
    mutation SubscriptionServiceCreateSubscription($input: SubscriptionServiceCreateSubscriptionGqlInput!) {
        subscriptionServiceCreateSubscription(input: $input) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function sE(e) {
  const t = { ...aA, ...e };
  return n.useMutation(uA, t);
}
const cA = {}, dA = i`
    mutation SubscriptionServicePauseSubscription($id: ID!, $reason: String!) {
        subscriptionServicePauseSubscription(id: $id, reason: $reason) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function oE(e) {
  const t = { ...cA, ...e };
  return n.useMutation(dA, t);
}
const nu = {}, iu = i`
    query SubscriptionServicePlan($id: ID!) {
        subscriptionServicePlan(id: $id) {
            id
            name
            code
            version
            description
            category
            pricing {
                monthly
                yearly
                setupFee
                trial {
                    days
                    autoConvert
                }
            }
            features
            usageMetrics
            billing {
                cycles
                proration
                downgradeProration
                upgradeProration
            }
            permissions
            roles
            isActive
            isArchived
            createdAt
            updatedAt
            createdBy
        }
    }
`;
function aE(e) {
  const t = { ...nu, ...e };
  return n.useQuery(
    iu,
    t
  );
}
function uE(e) {
  const t = { ...nu, ...e };
  return n.useLazyQuery(
    iu,
    t
  );
}
function cE(e) {
  const t = e === n.skipToken ? e : { ...nu, ...e };
  return n.useSuspenseQuery(
    iu,
    t
  );
}
const ru = {}, su = i`
    query SubscriptionServicePlans($params: SubscriptionServicePlanListParamsGqlInput) {
        subscriptionServicePlans(params: $params) {
            plans {
                id
                name
                code
                version
                description
                category
                pricing {
                    monthly
                    yearly
                    setupFee
                    trial {
                        days
                        autoConvert
                    }
                }
                features
                usageMetrics
                billing {
                    cycles
                    proration
                    downgradeProration
                    upgradeProration
                }
                permissions
                roles
                isActive
                isArchived
                createdAt
                updatedAt
                createdBy
            }
            total
            page
            limit
        }
    }
`;
function dE(e) {
  const t = { ...ru, ...e };
  return n.useQuery(
    su,
    t
  );
}
function pE(e) {
  const t = { ...ru, ...e };
  return n.useLazyQuery(
    su,
    t
  );
}
function lE(e) {
  const t = e === n.skipToken ? e : { ...ru, ...e };
  return n.useSuspenseQuery(
    su,
    t
  );
}
const pA = {}, lA = i`
    mutation SubscriptionServiceProcessRefund($id: ID!, $amount: Money!, $reason: String!) {
        subscriptionServiceProcessRefund(id: $id, amount: $amount, reason: $reason) {
            id
            tenantId
            subscriptionId
            type
            amount
            currency
            status
            payment {
                gateway
                method
                transactionId
                invoiceId
            }
            billingPeriod {
                start
                end
            }
            invoice {
                number
                items {
                    description
                    quantity
                    unitPrice
                    total
                }
                subtotal
                taxes
                total
                dueDate
            }
            processedAt
            processedBy
            retryCount
        }
    }
`;
function yE(e) {
  const t = { ...pA, ...e };
  return n.useMutation(lA, t);
}
const yA = {}, SA = i`
    mutation SubscriptionServiceResumeSubscription($id: ID!) {
        subscriptionServiceResumeSubscription(id: $id) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function SE(e) {
  const t = { ...yA, ...e };
  return n.useMutation(SA, t);
}
const mA = {}, vA = i`
    mutation SubscriptionServiceRetryPayment($id: ID!) {
        subscriptionServiceRetryPayment(id: $id) {
            id
            tenantId
            subscriptionId
            type
            amount
            currency
            status
            payment {
                gateway
                method
                transactionId
                invoiceId
            }
            billingPeriod {
                start
                end
            }
            invoice {
                number
                items {
                    description
                    quantity
                    unitPrice
                    total
                }
                subtotal
                taxes
                total
                dueDate
            }
            processedAt
            processedBy
            retryCount
        }
    }
`;
function mE(e) {
  const t = { ...mA, ...e };
  return n.useMutation(vA, t);
}
const ou = {}, au = i`
    query SubscriptionServiceSubscription($id: ID!) {
        subscriptionServiceSubscription(id: $id) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function vE(e) {
  const t = { ...ou, ...e };
  return n.useQuery(
    au,
    t
  );
}
function gE(e) {
  const t = { ...ou, ...e };
  return n.useLazyQuery(
    au,
    t
  );
}
function fE(e) {
  const t = e === n.skipToken ? e : { ...ou, ...e };
  return n.useSuspenseQuery(
    au,
    t
  );
}
const uu = {}, cu = i`
    query SubscriptionServiceSubscriptionByTenant($tenantId: String!) {
        subscriptionServiceSubscriptionByTenant(tenantId: $tenantId) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function AE(e) {
  const t = { ...uu, ...e };
  return n.useQuery(cu, t);
}
function IE(e) {
  const t = { ...uu, ...e };
  return n.useLazyQuery(cu, t);
}
function $E(e) {
  const t = e === n.skipToken ? e : { ...uu, ...e };
  return n.useSuspenseQuery(cu, t);
}
const du = {}, pu = i`
    query SubscriptionServiceSubscriptions($params: SubscriptionServiceSubscriptionListParamsGqlInput) {
        subscriptionServiceSubscriptions(params: $params) {
            subscriptions {
                id
                tenantId
                customerId
                planId
                planVersion
                planName
                state
                trialInfo {
                    isActive
                    startedAt
                    endsAt
                    autoConvert
                }
                billing {
                    cycle
                    billingDate
                    nextBillingDate
                    currentPeriod {
                        start
                        end
                    }
                    paymentMethod
                }
                financial {
                    proratedAmount
                    creditsApplied
                    discounts
                    taxes
                    totalAmount
                    currency
                }
                usage {
                    period {
                        start
                        end
                    }
                    metrics
                    alerts {
                        metric
                        threshold
                        current
                        triggeredAt
                    }
                }
                changeHistory {
                    action
                    timestamp
                    actor
                    details
                }
                createdAt
                updatedAt
                deletedAt
            }
            total
            page
            limit
        }
    }
`;
function QE(e) {
  const t = { ...du, ...e };
  return n.useQuery(
    pu,
    t
  );
}
function CE(e) {
  const t = { ...du, ...e };
  return n.useLazyQuery(
    pu,
    t
  );
}
function hE(e) {
  const t = e === n.skipToken ? e : { ...du, ...e };
  return n.useSuspenseQuery(pu, t);
}
const gA = {}, fA = i`
    mutation SubscriptionServiceUpdatePlan($id: ID!, $input: SubscriptionServiceUpdatePlanGqlInput!) {
        subscriptionServiceUpdatePlan(id: $id, input: $input) {
            id
            name
            code
            version
            description
            category
            pricing {
                monthly
                yearly
                setupFee
                trial {
                    days
                    autoConvert
                }
            }
            features
            usageMetrics
            billing {
                cycles
                proration
                downgradeProration
                upgradeProration
            }
            permissions
            roles
            isActive
            isArchived
            createdAt
            updatedAt
            createdBy
        }
    }
`;
function kE(e) {
  const t = { ...gA, ...e };
  return n.useMutation(
    fA,
    t
  );
}
const AA = {}, IA = i`
    mutation SubscriptionServiceUpdateSubscription($id: ID!, $input: SubscriptionServiceUpdateSubscriptionGqlInput!) {
        subscriptionServiceUpdateSubscription(id: $id, input: $input) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function DE(e) {
  const t = { ...AA, ...e };
  return n.useMutation(IA, t);
}
const $A = {}, QA = i`
    mutation SubscriptionServiceUpgradeSubscription(
        $id: ID!
        $input: SubscriptionServiceProrationCalculationGqlInput!
    ) {
        subscriptionServiceUpgradeSubscription(id: $id, input: $input) {
            id
            tenantId
            customerId
            planId
            planVersion
            planName
            state
            trialInfo {
                isActive
                startedAt
                endsAt
                autoConvert
            }
            billing {
                cycle
                billingDate
                nextBillingDate
                currentPeriod {
                    start
                    end
                }
                paymentMethod
            }
            financial {
                proratedAmount
                creditsApplied
                discounts
                taxes
                totalAmount
                currency
            }
            usage {
                period {
                    start
                    end
                }
                metrics
                alerts {
                    metric
                    threshold
                    current
                    triggeredAt
                }
            }
            changeHistory {
                action
                timestamp
                actor
                details
            }
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function PE(e) {
  const t = { ...$A, ...e };
  return n.useMutation(QA, t);
}
const lu = {}, yu = i`
    query SubscriptionServiceUsageMetrics($params: SubscriptionServiceUsageMetricListParamsGqlInput) {
        subscriptionServiceUsageMetrics(params: $params) {
            metrics {
                id
                tenantId
                subscriptionId
                metric
                period {
                    start
                    end
                }
                value
                unit
                cost
                isOverage
                alertTriggered
                timestamp
                source
                metadata
            }
            total
            page
            limit
        }
    }
`;
function TE(e) {
  const t = { ...lu, ...e };
  return n.useQuery(
    yu,
    t
  );
}
function ME(e) {
  const t = { ...lu, ...e };
  return n.useLazyQuery(
    yu,
    t
  );
}
function bE(e) {
  const t = e === n.skipToken ? e : { ...lu, ...e };
  return n.useSuspenseQuery(
    yu,
    t
  );
}
const CA = {}, hA = i`
    mutation SyncServicesyncProduct {
        syncServicesyncProduct {
            success
            message
        }
    }
`;
function LE(e) {
  const t = { ...CA, ...e };
  return n.useMutation(
    hA,
    t
  );
}
const kA = {}, DA = i`
    mutation SyncServicesyncInventory {
        syncServicesyncInventory {
            success
            message
        }
    }
`;
function BE(e) {
  const t = { ...kA, ...e };
  return n.useMutation(
    DA,
    t
  );
}
const PA = {}, TA = i`
    mutation SyncServicesyncCategory {
        syncServicesyncCategory {
            success
            message
        }
    }
`;
function UE(e) {
  const t = { ...PA, ...e };
  return n.useMutation(
    TA,
    t
  );
}
const MA = {}, bA = i`
    mutation SyncServicesyncOrder {
        syncServicesyncOrder {
            success
            message
        }
    }
`;
function zE(e) {
  const t = { ...MA, ...e };
  return n.useMutation(
    bA,
    t
  );
}
const Su = {}, mu = i`
    query TemplateServiceGetTemplate($id: String) {
        templateServiceGetTemplate(id: $id) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function FE(e) {
  const t = { ...Su, ...e };
  return n.useQuery(
    mu,
    t
  );
}
function RE(e) {
  const t = { ...Su, ...e };
  return n.useLazyQuery(
    mu,
    t
  );
}
function GE(e) {
  const t = e === n.skipToken ? e : { ...Su, ...e };
  return n.useSuspenseQuery(
    mu,
    t
  );
}
const vu = {}, gu = i`
    query TemplateServiceGetApprovedTemplate($id: String, $tenantId: String) {
        templateServiceGetApprovedTemplate(id: $id, tenantId: $tenantId) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function qE(e) {
  const t = { ...vu, ...e };
  return n.useQuery(
    gu,
    t
  );
}
function EE(e) {
  const t = { ...vu, ...e };
  return n.useLazyQuery(gu, t);
}
function VE(e) {
  const t = e === n.skipToken ? e : { ...vu, ...e };
  return n.useSuspenseQuery(gu, t);
}
const fu = {}, Au = i`
    query TemplateServiceGetEditingTemplate($templateId: String, $tenantId: String) {
        templateServiceGetEditingTemplate(templateId: $templateId, tenantId: $tenantId) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function OE(e) {
  const t = { ...fu, ...e };
  return n.useQuery(
    Au,
    t
  );
}
function xE(e) {
  const t = { ...fu, ...e };
  return n.useLazyQuery(
    Au,
    t
  );
}
function wE(e) {
  const t = e === n.skipToken ? e : { ...fu, ...e };
  return n.useSuspenseQuery(Au, t);
}
const Iu = {}, $u = i`
    query TemplateServiceGetTemplateHistory($templateId: String, $tenantId: String) {
        templateServiceGetTemplateHistory(templateId: $templateId, tenantId: $tenantId) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function HE(e) {
  const t = { ...Iu, ...e };
  return n.useQuery(
    $u,
    t
  );
}
function NE(e) {
  const t = { ...Iu, ...e };
  return n.useLazyQuery(
    $u,
    t
  );
}
function WE(e) {
  const t = e === n.skipToken ? e : { ...Iu, ...e };
  return n.useSuspenseQuery($u, t);
}
const Qu = {}, Cu = i`
    query TemplateServiceGetTemplatesByTemplateId($templateId: String, $tenantId: String) {
        templateServiceGetTemplatesByTemplateId(templateId: $templateId, tenantId: $tenantId) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function jE(e) {
  const t = { ...Qu, ...e };
  return n.useQuery(Cu, t);
}
function KE(e) {
  const t = { ...Qu, ...e };
  return n.useLazyQuery(Cu, t);
}
function ZE(e) {
  const t = e === n.skipToken ? e : { ...Qu, ...e };
  return n.useSuspenseQuery(Cu, t);
}
const hu = {}, ku = i`
    query TemplateServiceListTemplates($filter: TemplateServiceTemplateFilterInput) {
        templateServiceListTemplates(filter: $filter) {
            templates {
                id
                templateId
                version
                tenantId
                templateCode
                type
                name
                content
                variables
                status
                createdBy
                approvedBy
                approvedAt
                rejectedReason
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function YE(e) {
  const t = { ...hu, ...e };
  return n.useQuery(
    ku,
    t
  );
}
function JE(e) {
  const t = { ...hu, ...e };
  return n.useLazyQuery(
    ku,
    t
  );
}
function _E(e) {
  const t = e === n.skipToken ? e : { ...hu, ...e };
  return n.useSuspenseQuery(
    ku,
    t
  );
}
const Du = {}, Pu = i`
    query TemplateServiceListApprovedTemplates($tenantId: String, $type: String, $limit: Int, $skip: Int) {
        templateServiceListApprovedTemplates(tenantId: $tenantId, type: $type, limit: $limit, skip: $skip) {
            templates {
                id
                templateId
                version
                tenantId
                templateCode
                type
                name
                content
                variables
                status
                createdBy
                approvedBy
                approvedAt
                rejectedReason
                createdAt
                updatedAt
            }
            total
        }
    }
`;
function XE(e) {
  const t = { ...Du, ...e };
  return n.useQuery(Pu, t);
}
function eV(e) {
  const t = { ...Du, ...e };
  return n.useLazyQuery(Pu, t);
}
function tV(e) {
  const t = e === n.skipToken ? e : { ...Du, ...e };
  return n.useSuspenseQuery(Pu, t);
}
const Tu = {}, Mu = i`
    query TemplateServiceListTemplateIds($tenantId: String, $type: String, $limit: Int, $skip: Int) {
        templateServiceListTemplateIds(tenantId: $tenantId, type: $type, limit: $limit, skip: $skip) {
            templateIds {
                templateId
                templateCode
                createdAt
            }
            total
        }
    }
`;
function nV(e) {
  const t = { ...Tu, ...e };
  return n.useQuery(
    Mu,
    t
  );
}
function iV(e) {
  const t = { ...Tu, ...e };
  return n.useLazyQuery(
    Mu,
    t
  );
}
function rV(e) {
  const t = e === n.skipToken ? e : { ...Tu, ...e };
  return n.useSuspenseQuery(
    Mu,
    t
  );
}
const bu = {}, Lu = i`
    query TemplateServiceValidateVariables($input: TemplateServiceValidateVariablesInput) {
        templateServiceValidateVariables(input: $input) {
            isValid
            missingVariables
            unusedVariables
        }
    }
`;
function sV(e) {
  const t = { ...bu, ...e };
  return n.useQuery(
    Lu,
    t
  );
}
function oV(e) {
  const t = { ...bu, ...e };
  return n.useLazyQuery(
    Lu,
    t
  );
}
function aV(e) {
  const t = e === n.skipToken ? e : { ...bu, ...e };
  return n.useSuspenseQuery(Lu, t);
}
const LA = {}, BA = i`
    mutation TemplateServiceCreateTemplate($input: TemplateServiceCreateTemplateInput) {
        templateServiceCreateTemplate(input: $input) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function uV(e) {
  const t = { ...LA, ...e };
  return n.useMutation(
    BA,
    t
  );
}
const UA = {}, zA = i`
    mutation TemplateServiceUpdateTemplate($id: String, $input: TemplateServiceUpdateTemplateInput) {
        templateServiceUpdateTemplate(id: $id, input: $input) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function cV(e) {
  const t = { ...UA, ...e };
  return n.useMutation(
    zA,
    t
  );
}
const FA = {}, RA = i`
    mutation TemplateServiceSubmitTemplate($input: TemplateServiceSubmitTemplateInput) {
        templateServiceSubmitTemplate(input: $input) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function dV(e) {
  const t = { ...FA, ...e };
  return n.useMutation(
    RA,
    t
  );
}
const GA = {}, qA = i`
    mutation TemplateServiceApproveTemplate($input: TemplateServiceApproveTemplateInput) {
        templateServiceApproveTemplate(input: $input) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function pV(e) {
  const t = { ...GA, ...e };
  return n.useMutation(
    qA,
    t
  );
}
const EA = {}, VA = i`
    mutation TemplateServiceRejectTemplate($input: TemplateServiceRejectTemplateInput) {
        templateServiceRejectTemplate(input: $input) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function lV(e) {
  const t = { ...EA, ...e };
  return n.useMutation(
    VA,
    t
  );
}
const OA = {}, xA = i`
    mutation TemplateServiceRollbackTemplate($input: TemplateServiceRollbackTemplateInput) {
        templateServiceRollbackTemplate(input: $input) {
            id
            templateId
            version
            tenantId
            templateCode
            type
            name
            content
            variables
            status
            createdBy
            approvedBy
            approvedAt
            rejectedReason
            createdAt
            updatedAt
        }
    }
`;
function yV(e) {
  const t = { ...OA, ...e };
  return n.useMutation(xA, t);
}
const wA = {}, HA = i`
    mutation TemplateServiceDeleteTemplate($id: String) {
        templateServiceDeleteTemplate(id: $id)
    }
`;
function SV(e) {
  const t = { ...wA, ...e };
  return n.useMutation(
    HA,
    t
  );
}
const NA = {}, WA = i`
    mutation UploadServiceRequestUpload($input: UploadServiceRequestGqlInput!) {
        uploadServiceRequestUpload(input: $input) {
            fileId
            uploadUrl
        }
    }
`;
function mV(e) {
  const t = { ...NA, ...e };
  return n.useMutation(
    WA,
    t
  );
}
const jA = {}, KA = i`
    mutation UploadServiceCompleteUpload($input: UploadServiceCompleteGqlInput!) {
        uploadServiceCompleteUpload(input: $input) {
            fileUrl
            status
        }
    }
`;
function vV(e) {
  const t = { ...jA, ...e };
  return n.useMutation(
    KA,
    t
  );
}
const Bu = {}, Uu = i`
    query UploadTest {
        uploadTest
    }
`;
function gV(e) {
  const t = { ...Bu, ...e };
  return n.useQuery(Uu, t);
}
function fV(e) {
  const t = { ...Bu, ...e };
  return n.useLazyQuery(Uu, t);
}
function AV(e) {
  const t = e === n.skipToken ? e : { ...Bu, ...e };
  return n.useSuspenseQuery(Uu, t);
}
const zu = {}, Fu = i`
    query UserServiceAdminAllTenant($input: PaginationArgs!, $organizationId: String!) {
        userServiceAdminAllTenant(input: $input, organizationId: $organizationId) {
            id
            billingStatus
            miniAppUrl
            createdAt
            domain
            logo
            name
            oaId
            organizationId
            type
            registerEnabled
            status
            updatedAt
            zaloAppId
            zaloAppSecret
            checkoutPrivateKey
            title
            description
            favicon
            banner
        }
    }
`;
function IV(e) {
  const t = { ...zu, ...e };
  return n.useQuery(
    Fu,
    t
  );
}
function $V(e) {
  const t = { ...zu, ...e };
  return n.useLazyQuery(
    Fu,
    t
  );
}
function QV(e) {
  const t = e === n.skipToken ? e : { ...zu, ...e };
  return n.useSuspenseQuery(
    Fu,
    t
  );
}
const ZA = {}, YA = i`
    mutation UserServiceAdminCreateTenant($input: UserServiceCreateTenantGqlInput!) {
        userServiceAdminCreateTenant(input: $input) {
            id
            logo
            name
            oaId
            organizationId
            type
            status
            billingStatus
            miniAppUrl
            zaloAppId
            zaloAppSecret
            checkoutPrivateKey
            createdAt
            updatedAt
            title
            description
            favicon
            banner
        }
    }
`;
function CV(e) {
  const t = { ...ZA, ...e };
  return n.useMutation(
    YA,
    t
  );
}
const JA = {}, _A = i`
    mutation UserServiceAdminUpdateTenant($input: UserServiceUpdateTenantGqlInput!) {
        userServiceAdminUpdateTenant(input: $input) {
            id
            logo
            name
            oaId
            organizationId
            type
            status
            billingStatus
            miniAppUrl
            zaloAppId
            zaloAppSecret
            checkoutPrivateKey
            createdAt
            updatedAt
            title
            description
            favicon
            banner
        }
    }
`;
function hV(e) {
  const t = { ...JA, ...e };
  return n.useMutation(
    _A,
    t
  );
}
const XA = {}, eI = i`
    mutation UserServiceCreateAgency($input: UserServiceCreateBasicUserGqlInput!) {
        userServiceCreateAgency(input: $input) {
            avatarUrl
            birthDate
            createdAt
            email
            firstName
            fullName
            gender
            id
            lastName
            organizationId
            phoneNumber
            status
            tenantId
            type
            updatedAt
            zaloId
            zaloOAId
        }
    }
`;
function kV(e) {
  const t = { ...XA, ...e };
  return n.useMutation(
    eI,
    t
  );
}
const tI = {}, nI = i`
    mutation UserServiceCreateOrganizationAdmin($input: UserServiceCreateUserGqlInput!) {
        userServiceCreateOrganizationAdmin(input: $input) {
            id
            email
            firstName
            lastName
            fullName
            phoneNumber
            avatarUrl
            birthDate
            gender
            status
            type
            organizationId
            tenantId
            zaloId
            createdAt
            updatedAt
        }
    }
`;
function DV(e) {
  const t = { ...tI, ...e };
  return n.useMutation(nI, t);
}
const iI = {}, rI = i`
    mutation UserServiceCreateTenantAdmin($input: UserServiceCreateUserGqlInput!) {
        userServiceCreateTenantAdmin(input: $input) {
            id
            email
            firstName
            lastName
            phoneNumber
            avatarUrl
            status
            type
            tenantId
            createdAt
            updatedAt
            zaloId
        }
    }
`;
function PV(e) {
  const t = { ...iI, ...e };
  return n.useMutation(
    rI,
    t
  );
}
const Ru = {}, Gu = i`
    query UserServiceAllTenant($input: UserServiceGetTenantsGqlInput!) {
        userServiceAllTenant(input: $input) {
            id
            billingStatus
            createdAt
            domain
            logo
            name
            oaId
            organizationId
            type
            registerEnabled
            status
            updatedAt
            zaloAppId
            zaloAppSecret
            checkoutPrivateKey
            miniAppUrl
            title
            description
            favicon
            banner
        }
    }
`;
function TV(e) {
  const t = { ...Ru, ...e };
  return n.useQuery(
    Gu,
    t
  );
}
function MV(e) {
  const t = { ...Ru, ...e };
  return n.useLazyQuery(
    Gu,
    t
  );
}
function bV(e) {
  const t = e === n.skipToken ? e : { ...Ru, ...e };
  return n.useSuspenseQuery(
    Gu,
    t
  );
}
const qu = {}, Eu = i`
    query UserServiceAllUserOfTenant($input: PaginationArgs!) {
        userServiceAllUserOfTenant(input: $input) {
            id
            avatarUrl
            birthDate
            createdAt
            email
            firstName
            fullName
            gender
            lastName
            organizationId
            phoneNumber
            status
            tenantId
            lastActive
            type
            updatedAt
            zaloId
            zaloOAId
        }
    }
`;
function LV(e) {
  const t = { ...qu, ...e };
  return n.useQuery(
    Eu,
    t
  );
}
function BV(e) {
  const t = { ...qu, ...e };
  return n.useLazyQuery(
    Eu,
    t
  );
}
function UV(e) {
  const t = e === n.skipToken ? e : { ...qu, ...e };
  return n.useSuspenseQuery(
    Eu,
    t
  );
}
const Vu = {}, Ou = i`
    query UserServiceAllZaloUserOfTenant($input: UserServiceGetZaloUsersGqlInput!) {
        userServiceAllZaloUserOfTenant(input: $input) {
            id
            avatarUrl
            birthDate
            createdAt
            email
            firstName
            fullName
            gender
            lastName
            organizationId
            phoneNumber
            status
            tenantId
            lastActive
            type
            updatedAt
            zaloId
            zaloOAId
        }
    }
`;
function zV(e) {
  const t = { ...Vu, ...e };
  return n.useQuery(
    Ou,
    t
  );
}
function FV(e) {
  const t = { ...Vu, ...e };
  return n.useLazyQuery(
    Ou,
    t
  );
}
function RV(e) {
  const t = e === n.skipToken ? e : { ...Vu, ...e };
  return n.useSuspenseQuery(
    Ou,
    t
  );
}
const sI = {}, oI = i`
    mutation UserServiceCreateTenant($input: UserServiceCreateTenantGqlInput!) {
        userServiceCreateTenant(input: $input) {
            id
            logo
            name
            oaId
            organizationId
            type
            status
            billingStatus
            miniAppUrl
            zaloAppId
            zaloAppSecret
            checkoutPrivateKey
            title
            description
            favicon
            banner
            createdAt
            updatedAt
        }
    }
`;
function GV(e) {
  const t = { ...sI, ...e };
  return n.useMutation(
    oI,
    t
  );
}
const aI = {}, uI = i`
    mutation UserServiceDeleteUser {
        userServiceDeleteUser
    }
`;
function qV(e) {
  const t = { ...aI, ...e };
  return n.useMutation(
    uI,
    t
  );
}
const xu = {}, wu = i`
    query UserServiceGetUserById {
        userServiceGetUserById {
            id
            email
            firstName
            lastName
            fullName
            phoneNumber
            avatarUrl
            birthDate
            gender
            status
            type
            organizationId
            tenantId
            zaloId
            createdAt
            updatedAt
        }
    }
`;
function EV(e) {
  const t = { ...xu, ...e };
  return n.useQuery(
    wu,
    t
  );
}
function VV(e) {
  const t = { ...xu, ...e };
  return n.useLazyQuery(
    wu,
    t
  );
}
function OV(e) {
  const t = e === n.skipToken ? e : { ...xu, ...e };
  return n.useSuspenseQuery(
    wu,
    t
  );
}
const Hu = {}, Nu = i`
    query UserServiceGetUserByIds($ids: [String!]!) {
        userServiceGetUserByIds(ids: $ids) {
            id
            email
            firstName
            lastName
            fullName
            phoneNumber
            avatarUrl
            birthDate
            gender
            status
            type
            organizationId
            tenantId
            zaloId
            createdAt
            updatedAt
        }
    }
`;
function xV(e) {
  const t = { ...Hu, ...e };
  return n.useQuery(
    Nu,
    t
  );
}
function wV(e) {
  const t = { ...Hu, ...e };
  return n.useLazyQuery(
    Nu,
    t
  );
}
function HV(e) {
  const t = e === n.skipToken ? e : { ...Hu, ...e };
  return n.useSuspenseQuery(
    Nu,
    t
  );
}
const cI = {}, dI = i`
    mutation UserServiceTenantStatus($input: UserServiceTenantStatusGqlInput!) {
        userServiceTenantStatus(input: $input) {
            id
            logo
            name
            oaId
            organizationId
            type
            status
            billingStatus
            zaloAppId
            zaloAppSecret
            createdAt
            updatedAt
        }
    }
`;
function NV(e) {
  const t = { ...cI, ...e };
  return n.useMutation(
    dI,
    t
  );
}
const Wu = {}, ju = i`
    query UserServiceTenantByDomain($domain: String!) {
        userServiceTenantByDomain(domain: $domain) {
            banner
            billingStatus
            createdAt
            description
            domain
            favicon
            id
            logo
            miniAppUrl
            name
            oaId
            organizationId
            registerEnabled
            status
            title
            type
            updatedAt
            zaloAppId
        }
    }
`;
function WV(e) {
  const t = { ...Wu, ...e };
  return n.useQuery(
    ju,
    t
  );
}
function jV(e) {
  const t = { ...Wu, ...e };
  return n.useLazyQuery(
    ju,
    t
  );
}
function KV(e) {
  const t = e === n.skipToken ? e : { ...Wu, ...e };
  return n.useSuspenseQuery(
    ju,
    t
  );
}
const Ku = {}, Zu = i`
    query UserServiceTenantById {
        userServiceTenantById {
            banner
            billingStatus
            createdAt
            description
            domain
            favicon
            id
            logo
            miniAppUrl
            name
            oaId
            organizationId
            registerEnabled
            status
            title
            type
            updatedAt
            zaloAppId
        }
    }
`;
function ZV(e) {
  const t = { ...Ku, ...e };
  return n.useQuery(
    Zu,
    t
  );
}
function YV(e) {
  const t = { ...Ku, ...e };
  return n.useLazyQuery(
    Zu,
    t
  );
}
function JV(e) {
  const t = e === n.skipToken ? e : { ...Ku, ...e };
  return n.useSuspenseQuery(
    Zu,
    t
  );
}
const Yu = {}, Ju = i`
    query UserServiceTenantIdFromDomain($domain: String!) {
        userServiceTenantIdFromDomain(domain: $domain)
    }
`;
function _V(e) {
  const t = { ...Yu, ...e };
  return n.useQuery(
    Ju,
    t
  );
}
function XV(e) {
  const t = { ...Yu, ...e };
  return n.useLazyQuery(
    Ju,
    t
  );
}
function eO(e) {
  const t = e === n.skipToken ? e : { ...Yu, ...e };
  return n.useSuspenseQuery(
    Ju,
    t
  );
}
const _u = {}, Xu = i`
    query UserServiceTenantOfUser {
        userServiceTenantOfUser {
            banner
            billingStatus
            createdAt
            description
            domain
            favicon
            id
            logo
            miniAppUrl
            name
            oaId
            organizationId
            registerEnabled
            status
            title
            type
            updatedAt
            zaloAppId
        }
    }
`;
function tO(e) {
  const t = { ..._u, ...e };
  return n.useQuery(
    Xu,
    t
  );
}
function nO(e) {
  const t = { ..._u, ...e };
  return n.useLazyQuery(
    Xu,
    t
  );
}
function iO(e) {
  const t = e === n.skipToken ? e : { ..._u, ...e };
  return n.useSuspenseQuery(
    Xu,
    t
  );
}
const pI = {}, lI = i`
    mutation UserServiceUpdateAvatar($input: UserServiceUpdateAvatarGqlInput!) {
        userServiceUpdateAvatar(input: $input) {
            id
            email
            firstName
            lastName
            fullName
            phoneNumber
            avatarUrl
            birthDate
            gender
            status
            type
            organizationId
            tenantId
            zaloId
            createdAt
            updatedAt
        }
    }
`;
function rO(e) {
  const t = { ...pI, ...e };
  return n.useMutation(
    lI,
    t
  );
}
const yI = {}, SI = i`
    mutation UserServiceUpdateProfile($input: UserServiceUpdateProfileGqlInput!) {
        userServiceUpdateProfile(input: $input) {
            id
            email
            firstName
            lastName
            fullName
            phoneNumber
            avatarUrl
            birthDate
            gender
            status
            type
            organizationId
            tenantId
            zaloId
            createdAt
            updatedAt
        }
    }
`;
function sO(e) {
  const t = { ...yI, ...e };
  return n.useMutation(
    SI,
    t
  );
}
const mI = {}, vI = i`
    mutation UserServiceUpdateTenant($input: UserServiceUpdateTenantGqlInput!) {
        userServiceUpdateTenant(input: $input) {
            id
            logo
            name
            oaId
            organizationId
            type
            status
            billingStatus
            miniAppUrl
            zaloAppId
            zaloAppSecret
            checkoutPrivateKey
            title
            description
            favicon
            banner
            createdAt
            updatedAt
        }
    }
`;
function oO(e) {
  const t = { ...mI, ...e };
  return n.useMutation(
    vI,
    t
  );
}
const gI = {}, fI = i`
    mutation UserServiceUpdateTenantType($input: UserServiceTenantTypeGqlInput!) {
        userServiceUpdateTenantType(input: $input) {
            id
            billingStatus
            createdAt
            domain
            logo
            name
            oaId
            organizationId
            registerEnabled
            status
            type
            updatedAt
            zaloAppId
            zaloAppSecret
        }
    }
`;
function aO(e) {
  const t = { ...gI, ...e };
  return n.useMutation(
    fI,
    t
  );
}
const AI = {}, II = i`
    mutation UserServiceUpdateZaloOAId($input: UserServiceUpdateZaloOAIdGqlInput!) {
        userServiceUpdateZaloOAId(input: $input) {
            id
            email
            firstName
            lastName
            fullName
            phoneNumber
            avatarUrl
            birthDate
            gender
            status
            type
            organizationId
            tenantId
            zaloId
            createdAt
            updatedAt
        }
    }
`;
function uO(e) {
  const t = { ...AI, ...e };
  return n.useMutation(
    II,
    t
  );
}
const ec = {}, tc = i`
    query UserServiceUsersOfTenantForAdmin($input: UserServiceFindUsersForAdminInput, $pagination: PaginationArgs!) {
        userServiceUsersOfTenantForAdmin(input: $input, pagination: $pagination) {
            data {
                id
                avatarUrl
                birthDate
                createdAt
                email
                firstName
                fullName
                gender
                lastName
                organizationId
                phoneNumber
                status
                tenantId
                type
                updatedAt
                zaloId
            }
            total
        }
    }
`;
function cO(e) {
  const t = { ...ec, ...e };
  return n.useQuery(
    tc,
    t
  );
}
function dO(e) {
  const t = { ...ec, ...e };
  return n.useLazyQuery(
    tc,
    t
  );
}
function pO(e) {
  const t = e === n.skipToken ? e : { ...ec, ...e };
  return n.useSuspenseQuery(tc, t);
}
const nc = {}, ic = i`
    query UserServiceGetUserByIdForAdmin($id: String!) {
        userServiceGetUserByIdForAdmin(id: $id) {
            id
            avatarUrl
            birthDate
            createdAt
            email
            firstName
            fullName
            gender
            lastName
            organizationId
            phoneNumber
            status
            tenantId
            type
            updatedAt
            zaloId
        }
    }
`;
function lO(e) {
  const t = { ...nc, ...e };
  return n.useQuery(
    ic,
    t
  );
}
function yO(e) {
  const t = { ...nc, ...e };
  return n.useLazyQuery(
    ic,
    t
  );
}
function SO(e) {
  const t = e === n.skipToken ? e : { ...nc, ...e };
  return n.useSuspenseQuery(
    ic,
    t
  );
}
const rc = {}, sc = i`
    query UserServiceUsersByType($input: UserServiceFindUsersByTypeInput, $pagination: PaginationArgs!) {
        userServiceUsersByType(input: $input, pagination: $pagination) {
            data {
                id
                email
                firstName
                lastName
                phoneNumber
                avatarUrl
                status
                type
                organizationId
                tenantId
                createdAt
                updatedAt
                zaloId
            }
            total
        }
    }
`;
function mO(e) {
  const t = { ...rc, ...e };
  return n.useQuery(
    sc,
    t
  );
}
function vO(e) {
  const t = { ...rc, ...e };
  return n.useLazyQuery(
    sc,
    t
  );
}
function gO(e) {
  const t = e === n.skipToken ? e : { ...rc, ...e };
  return n.useSuspenseQuery(
    sc,
    t
  );
}
const oc = {}, ac = i`
    query VoucherServiceAllVouchers($pagination: PaginationArgs!) {
        voucherServiceAllVouchers(pagination: $pagination) {
            data {
                id
                code
                createdAt
                discountType
                discountValue
                endDate
                isActive
                isDeleted
                isExpired
                redemptionCount
                maximumDiscount
                minimumPurchase
                redeemedDate
                startDate
                tenantId
                updatedAt
                userId
                voucherTypeId
            }
            total
        }
    }
`;
function fO(e) {
  const t = { ...oc, ...e };
  return n.useQuery(
    ac,
    t
  );
}
function AO(e) {
  const t = { ...oc, ...e };
  return n.useLazyQuery(
    ac,
    t
  );
}
function IO(e) {
  const t = e === n.skipToken ? e : { ...oc, ...e };
  return n.useSuspenseQuery(
    ac,
    t
  );
}
const uc = {}, cc = i`
    query VoucherServiceAllVoucherTypes($pagination: PaginationArgs!, $isRedeemable: Boolean) {
        voucherServiceAllVoucherTypes(pagination: $pagination, isRedeemable: $isRedeemable) {
            data {
                id
                applicableCategoryIds
                applicableLoyaltyTierIds
                applicableProductIds
                createdAt
                description
                discountType
                discountValue
                excludedProductIds
                expiryDate
                imageUrl
                isDeleted
                isEnabled
                isRedeemableWithPoints
                isSharedCode
                isStackable
                issuedLimitPerUser
                maximumDiscount
                minimumPurchase
                name
                pointsRequired
                redemptionLimitPerUser
                sharedCode
                tenantId
                termsAndConditions
                totalIssuedCount
                totalIssuedLimit
                totalRedemptionCount
                totalRedemptionLimit
                updatedAt
                validityDays
            }
            total
        }
    }
`;
function $O(e) {
  const t = { ...uc, ...e };
  return n.useQuery(
    cc,
    t
  );
}
function QO(e) {
  const t = { ...uc, ...e };
  return n.useLazyQuery(
    cc,
    t
  );
}
function CO(e) {
  const t = e === n.skipToken ? e : { ...uc, ...e };
  return n.useSuspenseQuery(
    cc,
    t
  );
}
const dc = {}, pc = i`
    query VoucherServiceLoyaltyVoucherType($pagination: PaginationArgs!) {
        voucherServiceLoyaltyVoucherType(pagination: $pagination) {
            data {
                id
                name
                description
                discountType
                discountValue
                maximumDiscount
                minimumPurchase
                applicableProductIds
                applicableCategoryIds
                applicableLoyaltyTierIds
                issuedLimitPerUser
                isEnabled
                isDeleted
                createdAt
                updatedAt
                tenantId
            }
            total
        }
    }
`;
function hO(e) {
  const t = { ...dc, ...e };
  return n.useQuery(
    pc,
    t
  );
}
function kO(e) {
  const t = { ...dc, ...e };
  return n.useLazyQuery(
    pc,
    t
  );
}
function DO(e) {
  const t = e === n.skipToken ? e : { ...dc, ...e };
  return n.useSuspenseQuery(pc, t);
}
const $I = {}, QI = i`
    mutation VoucherServiceBulkIssueToAllUsers($input: VoucherServiceBulkIssueAllGqlInput!) {
        voucherServiceBulkIssueToAllUsers(input: $input)
    }
`;
function PO(e) {
  const t = { ...$I, ...e };
  return n.useMutation(QI, t);
}
const CI = {}, hI = i`
    mutation VoucherServiceBulkIssueToUsers($input: VoucherServiceBulkIssueGqlInput!) {
        voucherServiceBulkIssueToUsers(input: $input)
    }
`;
function TO(e) {
  const t = { ...CI, ...e };
  return n.useMutation(
    hI,
    t
  );
}
const kI = {}, DI = i`
    mutation VoucherServiceCreateVoucher($input: VoucherServiceCreateVoucherGqlInput!) {
        voucherServiceCreateVoucher(input: $input)
    }
`;
function MO(e) {
  const t = { ...kI, ...e };
  return n.useMutation(
    DI,
    t
  );
}
const PI = {}, TI = i`
    mutation VoucherServiceCreateVoucherType($input: VoucherServiceCreateVoucherTypeGqlInput!) {
        voucherServiceCreateVoucherType(input: $input)
    }
`;
function bO(e) {
  const t = { ...PI, ...e };
  return n.useMutation(TI, t);
}
const lc = {}, yc = i`
    query VoucherServiceDeletedVoucherTypes($pagination: PaginationArgs!) {
        voucherServiceDeletedVoucherTypes(pagination: $pagination) {
            id
            applicableCategoryIds
            applicableProductIds
            createdAt
            description
            discountType
            discountValue
            excludedProductIds
            expiryDate
            imageUrl
            isDeleted
            isEnabled
            isSharedCode
            isStackable
            issuedLimitPerUser
            maximumDiscount
            minimumPurchase
            name
            pointsRequired
            redemptionLimitPerUser
            sharedCode
            tenantId
            termsAndConditions
            totalIssuedCount
            totalIssuedLimit
            totalRedemptionCount
            totalRedemptionLimit
            updatedAt
            validityDays
        }
    }
`;
function LO(e) {
  const t = { ...lc, ...e };
  return n.useQuery(
    yc,
    t
  );
}
function BO(e) {
  const t = { ...lc, ...e };
  return n.useLazyQuery(
    yc,
    t
  );
}
function UO(e) {
  const t = e === n.skipToken ? e : { ...lc, ...e };
  return n.useSuspenseQuery(yc, t);
}
const MI = {}, bI = i`
    mutation VoucherServiceDeleteVouchers($ids: [String!]!) {
        voucherServiceDeleteVouchers(ids: $ids)
    }
`;
function zO(e) {
  const t = { ...MI, ...e };
  return n.useMutation(
    bI,
    t
  );
}
const LI = {}, BI = i`
    mutation VoucherServiceDeleteVoucherTypeById($id: String!) {
        voucherServiceDeleteVoucherTypeById(id: $id)
    }
`;
function FO(e) {
  const t = { ...LI, ...e };
  return n.useMutation(BI, t);
}
const Sc = {}, mc = i`
    query VoucherServiceDisabledVouchers($pagination: PaginationArgs!) {
        voucherServiceDisabledVouchers(pagination: $pagination) {
            id
            applicableCategoryIds
            applicableProductIds
            campaignId
            code
            createdAt
            description
            discountType
            discountValue
            endDate
            excludedProductIds
            imageUrl
            isActive
            isDeleted
            isExpired
            redemptionCount
            issueDate
            maximumDiscount
            minimumPurchase
            name
            redeemedDate
            redeemedOrderId
            startDate
            tenantId
            updatedAt
            userId
            voucherTypeId
        }
    }
`;
function RO(e) {
  const t = { ...Sc, ...e };
  return n.useQuery(
    mc,
    t
  );
}
function GO(e) {
  const t = { ...Sc, ...e };
  return n.useLazyQuery(
    mc,
    t
  );
}
function qO(e) {
  const t = e === n.skipToken ? e : { ...Sc, ...e };
  return n.useSuspenseQuery(
    mc,
    t
  );
}
const vc = {}, gc = i`
    query VoucherServiceDisabledVoucherTypes($pagination: PaginationArgs!) {
        voucherServiceDisabledVoucherTypes(pagination: $pagination) {
            id
            applicableCategoryIds
            applicableProductIds
            createdAt
            description
            discountType
            discountValue
            excludedProductIds
            expiryDate
            imageUrl
            isDeleted
            isEnabled
            isSharedCode
            isStackable
            issuedLimitPerUser
            maximumDiscount
            minimumPurchase
            name
            pointsRequired
            redemptionLimitPerUser
            sharedCode
            tenantId
            termsAndConditions
            totalIssuedCount
            totalIssuedLimit
            totalRedemptionCount
            totalRedemptionLimit
            updatedAt
            validityDays
        }
    }
`;
function EO(e) {
  const t = { ...vc, ...e };
  return n.useQuery(
    gc,
    t
  );
}
function VO(e) {
  const t = { ...vc, ...e };
  return n.useLazyQuery(gc, t);
}
function OO(e) {
  const t = e === n.skipToken ? e : { ...vc, ...e };
  return n.useSuspenseQuery(gc, t);
}
const UI = {}, zI = i`
    mutation VoucherServiceDisableVoucherTypeById($id: String!) {
        voucherServiceDisableVoucherTypeById(id: $id)
    }
`;
function xO(e) {
  const t = { ...UI, ...e };
  return n.useMutation(zI, t);
}
const fc = {}, Ac = i`
    query VoucherServiceEnabledVouchers($pagination: PaginationArgs!) {
        voucherServiceEnabledVouchers(pagination: $pagination) {
            id
            applicableCategoryIds
            applicableProductIds
            campaignId
            code
            createdAt
            description
            discountType
            discountValue
            endDate
            excludedProductIds
            imageUrl
            isActive
            isDeleted
            isExpired
            redemptionCount
            issueDate
            maximumDiscount
            minimumPurchase
            name
            redeemedDate
            redeemedOrderId
            startDate
            tenantId
            updatedAt
            userId
            voucherTypeId
        }
    }
`;
function wO(e) {
  const t = { ...fc, ...e };
  return n.useQuery(
    Ac,
    t
  );
}
function HO(e) {
  const t = { ...fc, ...e };
  return n.useLazyQuery(
    Ac,
    t
  );
}
function NO(e) {
  const t = e === n.skipToken ? e : { ...fc, ...e };
  return n.useSuspenseQuery(
    Ac,
    t
  );
}
const Ic = {}, $c = i`
    query VoucherServiceEnabledVoucherTypes($pagination: PaginationArgs!) {
        voucherServiceEnabledVoucherTypes(pagination: $pagination) {
            id
            applicableCategoryIds
            applicableProductIds
            createdAt
            description
            discountType
            discountValue
            excludedProductIds
            expiryDate
            imageUrl
            isDeleted
            isEnabled
            isSharedCode
            isStackable
            issuedLimitPerUser
            maximumDiscount
            minimumPurchase
            name
            pointsRequired
            redemptionLimitPerUser
            sharedCode
            tenantId
            termsAndConditions
            totalIssuedCount
            totalIssuedLimit
            totalRedemptionCount
            totalRedemptionLimit
            updatedAt
            validityDays
        }
    }
`;
function WO(e) {
  const t = { ...Ic, ...e };
  return n.useQuery(
    $c,
    t
  );
}
function jO(e) {
  const t = { ...Ic, ...e };
  return n.useLazyQuery(
    $c,
    t
  );
}
function KO(e) {
  const t = e === n.skipToken ? e : { ...Ic, ...e };
  return n.useSuspenseQuery($c, t);
}
const FI = {}, RI = i`
    mutation VoucherServiceEnableVouchers($ids: [String!]!) {
        voucherServiceEnableVouchers(ids: $ids)
    }
`;
function ZO(e) {
  const t = { ...FI, ...e };
  return n.useMutation(
    RI,
    t
  );
}
const GI = {}, qI = i`
    mutation VoucherServiceEnableVoucherTypeById($id: String!) {
        voucherServiceEnableVoucherTypeById(id: $id)
    }
`;
function YO(e) {
  const t = { ...GI, ...e };
  return n.useMutation(qI, t);
}
const Qc = {}, Cc = i`
    query VoucherServiceMyVouchers($filter: VoucherServiceMyVouchersFilterGqlInput, $pagination: PaginationArgs!) {
        voucherServiceMyVouchers(filter: $filter, pagination: $pagination) {
            code
            createdAt
            discountType
            discountValue
            endDate
            isActive
            isDeleted
            isExpired
            redemptionCount
            maximumDiscount
            minimumPurchase
            redeemedDate
            startDate
            tenantId
            updatedAt
            userId
            voucherTypeId
            applicableCategoryIds
            applicableProductIds
            campaignId
            description
            excludedProductIds
            id
            imageUrl
            issueDate
            name
            redeemedOrderId
        }
    }
`;
function JO(e) {
  const t = { ...Qc, ...e };
  return n.useQuery(
    Cc,
    t
  );
}
function _O(e) {
  const t = { ...Qc, ...e };
  return n.useLazyQuery(
    Cc,
    t
  );
}
function XO(e) {
  const t = e === n.skipToken ? e : { ...Qc, ...e };
  return n.useSuspenseQuery(
    Cc,
    t
  );
}
const hc = {}, kc = i`
    query VoucherServiceRedeemableVoucherTypes($pagination: PaginationArgs!) {
        voucherServiceRedeemableVoucherTypes(pagination: $pagination) {
            id
            applicableCategoryIds
            applicableProductIds
            canRedeem
            createdAt
            description
            discountType
            discountValue
            excludedProductIds
            expiryDate
            imageUrl
            isDeleted
            isEnabled
            isSharedCode
            isStackable
            issuedLimitPerUser
            maximumDiscount
            minimumPurchase
            name
            pointsRequired
            redemptionLimitPerUser
            sharedCode
            tenantId
            termsAndConditions
            totalIssuedCount
            totalIssuedLimit
            totalRedemptionCount
            totalRedemptionLimit
            updatedAt
            userRedemptionCount
            validityDays
        }
    }
`;
function ex(e) {
  const t = { ...hc, ...e };
  return n.useQuery(kc, t);
}
function tx(e) {
  const t = { ...hc, ...e };
  return n.useLazyQuery(kc, t);
}
function nx(e) {
  const t = e === n.skipToken ? e : { ...hc, ...e };
  return n.useSuspenseQuery(kc, t);
}
const Dc = {}, Pc = i`
    query VoucherServiceSearchVouchers($pagination: PaginationArgs!, $search: String!) {
        voucherServiceSearchVouchers(pagination: $pagination, search: $search) {
            id
            applicableCategoryIds
            applicableProductIds
            campaignId
            code
            createdAt
            description
            discountType
            discountValue
            endDate
            excludedProductIds
            imageUrl
            isActive
            isDeleted
            isExpired
            redemptionCount
            issueDate
            maximumDiscount
            minimumPurchase
            name
            redeemedDate
            redeemedOrderId
            startDate
            tenantId
            updatedAt
            userId
            voucherTypeId
        }
    }
`;
function ix(e) {
  const t = { ...Dc, ...e };
  return n.useQuery(
    Pc,
    t
  );
}
function rx(e) {
  const t = { ...Dc, ...e };
  return n.useLazyQuery(
    Pc,
    t
  );
}
function sx(e) {
  const t = e === n.skipToken ? e : { ...Dc, ...e };
  return n.useSuspenseQuery(
    Pc,
    t
  );
}
const EI = {}, VI = i`
    mutation VoucherServiceUpdateVoucher($id: String!, $input: VoucherServiceUpdateVoucherGqlInput!) {
        voucherServiceUpdateVoucher(id: $id, input: $input)
    }
`;
function ox(e) {
  const t = { ...EI, ...e };
  return n.useMutation(
    VI,
    t
  );
}
const OI = {}, xI = i`
    mutation VoucherServiceUpdateVoucherType($id: String!, $input: VoucherServiceUpdateVoucherTypeGqlInput!) {
        voucherServiceUpdateVoucherType(id: $id, input: $input)
    }
`;
function ax(e) {
  const t = { ...OI, ...e };
  return n.useMutation(xI, t);
}
const Tc = {}, Mc = i`
    query VoucherServiceVoucherById($id: String!) {
        voucherServiceVoucherById(id: $id) {
            id
            applicableCategoryIds
            applicableProductIds
            campaignId
            code
            createdAt
            description
            discountType
            discountValue
            endDate
            excludedProductIds
            imageUrl
            isActive
            isDeleted
            isExpired
            redemptionCount
            issueDate
            maximumDiscount
            minimumPurchase
            name
            redeemedDate
            redeemedOrderId
            startDate
            tenantId
            updatedAt
            userId
            voucherTypeId
        }
    }
`;
function ux(e) {
  const t = { ...Tc, ...e };
  return n.useQuery(
    Mc,
    t
  );
}
function cx(e) {
  const t = { ...Tc, ...e };
  return n.useLazyQuery(
    Mc,
    t
  );
}
function dx(e) {
  const t = e === n.skipToken ? e : { ...Tc, ...e };
  return n.useSuspenseQuery(
    Mc,
    t
  );
}
const bc = {}, Lc = i`
    query VoucherServiceVouchersByIds($ids: [String!]!) {
        voucherServiceVouchersByIds(ids: $ids) {
            id
            applicableCategoryIds
            applicableProductIds
            campaignId
            code
            createdAt
            description
            discountType
            discountValue
            endDate
            excludedProductIds
            imageUrl
            isActive
            isDeleted
            isExpired
            redemptionCount
            issueDate
            maximumDiscount
            minimumPurchase
            name
            redeemedDate
            redeemedOrderId
            startDate
            tenantId
            updatedAt
            userId
            voucherTypeId
        }
    }
`;
function px(e) {
  const t = { ...bc, ...e };
  return n.useQuery(
    Lc,
    t
  );
}
function lx(e) {
  const t = { ...bc, ...e };
  return n.useLazyQuery(
    Lc,
    t
  );
}
function yx(e) {
  const t = e === n.skipToken ? e : { ...bc, ...e };
  return n.useSuspenseQuery(
    Lc,
    t
  );
}
const Bc = {}, Uc = i`
    query VoucherServiceVoucherTypeById($id: String!) {
        voucherServiceVoucherTypeById(id: $id) {
            id
            isRedeemableWithPoints
            applicableCategoryIds
            applicableLoyaltyTierIds
            applicableProductIds
            createdAt
            description
            discountType
            discountValue
            excludedProductIds
            expiryDate
            imageUrl
            isDeleted
            isEnabled
            isSharedCode
            isStackable
            issuedLimitPerUser
            maximumDiscount
            minimumPurchase
            name
            pointsRequired
            redemptionLimitPerUser
            sharedCode
            tenantId
            termsAndConditions
            totalIssuedCount
            totalIssuedLimit
            totalRedemptionCount
            totalRedemptionLimit
            updatedAt
            validityDays
        }
    }
`;
function Sx(e) {
  const t = { ...Bc, ...e };
  return n.useQuery(
    Uc,
    t
  );
}
function mx(e) {
  const t = { ...Bc, ...e };
  return n.useLazyQuery(
    Uc,
    t
  );
}
function vx(e) {
  const t = e === n.skipToken ? e : { ...Bc, ...e };
  return n.useSuspenseQuery(
    Uc,
    t
  );
}
const zc = {}, Fc = i`
    query AddressServiceAllAddress($input: PaginationArgs!) {
        addressServiceAllAddress(input: $input) {
            id
            address
            createdAt
            deletedAt
            fullAddress
            isDefault
            name
            phone
            province
            updatedAt
            ward
        }
    }
`;
function gx(e) {
  const t = { ...zc, ...e };
  return n.useQuery(
    Fc,
    t
  );
}
function fx(e) {
  const t = { ...zc, ...e };
  return n.useLazyQuery(
    Fc,
    t
  );
}
function Ax(e) {
  const t = e === n.skipToken ? e : { ...zc, ...e };
  return n.useSuspenseQuery(
    Fc,
    t
  );
}
const Rc = {}, Gc = i`
    query AddressServiceCountries {
        addressServiceCountries {
            id
            code
            name
        }
    }
`;
function Ix(e) {
  const t = { ...Rc, ...e };
  return n.useQuery(
    Gc,
    t
  );
}
function $x(e) {
  const t = { ...Rc, ...e };
  return n.useLazyQuery(
    Gc,
    t
  );
}
function Qx(e) {
  const t = e === n.skipToken ? e : { ...Rc, ...e };
  return n.useSuspenseQuery(
    Gc,
    t
  );
}
const wI = {}, HI = i`
    mutation AddressServiceCreateAddress($input: AddressServiceCreateAddressGqlInput!) {
        addressServiceCreateAddress(input: $input) {
            id
            name
            phone
            address
            province
            ward
            fullAddress
            isDefault
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function Cx(e) {
  const t = { ...wI, ...e };
  return n.useMutation(
    HI,
    t
  );
}
const NI = {}, WI = i`
    mutation AddressServiceDeleteAddress($id: String!) {
        addressServiceDeleteAddress(id: $id) {
            id
            name
            phone
            address
            province
            ward
            fullAddress
            isDefault
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function hx(e) {
  const t = { ...NI, ...e };
  return n.useMutation(
    WI,
    t
  );
}
const qc = {}, Ec = i`
    query AddressServiceDefaultAddress {
        addressServiceDefaultAddress {
            id
            address
            createdAt
            deletedAt
            fullAddress
            isDefault
            name
            phone
            province
            updatedAt
            ward
        }
    }
`;
function kx(e) {
  const t = { ...qc, ...e };
  return n.useQuery(
    Ec,
    t
  );
}
function Dx(e) {
  const t = { ...qc, ...e };
  return n.useLazyQuery(
    Ec,
    t
  );
}
function Px(e) {
  const t = e === n.skipToken ? e : { ...qc, ...e };
  return n.useSuspenseQuery(
    Ec,
    t
  );
}
const Vc = {}, Oc = i`
    query AddressServiceProvinces {
        addressServiceProvinces {
            id
            code
            name
        }
    }
`;
function Tx(e) {
  const t = { ...Vc, ...e };
  return n.useQuery(
    Oc,
    t
  );
}
function Mx(e) {
  const t = { ...Vc, ...e };
  return n.useLazyQuery(
    Oc,
    t
  );
}
function bx(e) {
  const t = e === n.skipToken ? e : { ...Vc, ...e };
  return n.useSuspenseQuery(
    Oc,
    t
  );
}
const jI = {}, KI = i`
    mutation AddressServiceUpdateAddress($input: AddressServiceUpdateAddressGqlInput!) {
        addressServiceUpdateAddress(input: $input) {
            id
            name
            phone
            address
            province
            ward
            fullAddress
            isDefault
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function Lx(e) {
  const t = { ...jI, ...e };
  return n.useMutation(
    KI,
    t
  );
}
const ZI = {}, YI = i`
    mutation AddressServiceUpdateDefaultAddress($input: AddressServiceUpdateDefaultGqlInput!) {
        addressServiceUpdateDefaultAddress(input: $input) {
            id
            name
            phone
            address
            province
            ward
            fullAddress
            isDefault
            createdAt
            updatedAt
            deletedAt
        }
    }
`;
function Bx(e) {
  const t = { ...ZI, ...e };
  return n.useMutation(YI, t);
}
const xc = {}, wc = i`
    query AddressServiceWardsByProvinceId($provinceId: String!) {
        addressServiceWardsByProvinceId(provinceId: $provinceId) {
            id
            code
            name
            provinceId
            type
        }
    }
`;
function Ux(e) {
  const t = { ...xc, ...e };
  return n.useQuery(
    wc,
    t
  );
}
function zx(e) {
  const t = { ...xc, ...e };
  return n.useLazyQuery(
    wc,
    t
  );
}
function Fx(e) {
  const t = e === n.skipToken ? e : { ...xc, ...e };
  return n.useSuspenseQuery(
    wc,
    t
  );
}
export {
  U$ as $,
  s as A,
  Lc as A0,
  px as A1,
  lx as A2,
  yx as A3,
  Uc as A4,
  Sx as A5,
  mx as A6,
  vx as A7,
  st as A8,
  ck as A9,
  Mx as AA,
  bx as AB,
  KI as AC,
  Lx as AD,
  YI as AE,
  Bx as AF,
  wc as AG,
  Ux as AH,
  zx as AI,
  Fx as AJ,
  dk as Aa,
  pk as Ab,
  at as Ac,
  lk as Ad,
  yk as Ae,
  Sk as Af,
  il as Ag,
  mk as Ah,
  Fc as Ai,
  gx as Aj,
  fx as Ak,
  Ax as Al,
  Gc as Am,
  Ix as An,
  $x as Ao,
  Qx as Ap,
  HI as Aq,
  Cx as Ar,
  WI as As,
  hx as At,
  Ec as Au,
  kx as Av,
  Dx as Aw,
  Px as Ax,
  Oc as Ay,
  Tx as Az,
  f$ as B,
  A as C,
  A$ as D,
  I$ as E,
  $$ as F,
  Nc as G,
  Q$ as H,
  $ as I,
  C$ as J,
  h$ as K,
  k$ as L,
  jc as M,
  D$ as N,
  Zc as O,
  P$ as P,
  Jc as Q,
  T$ as R,
  Xc as S,
  M$ as T,
  td as U,
  b$ as V,
  id as W,
  L$ as X,
  sd as Y,
  B$ as Z,
  C as _,
  XI as a,
  PQ as a$,
  z$ as a0,
  F$ as a1,
  k as a2,
  R$ as a3,
  G$ as a4,
  q$ as a5,
  P as a6,
  E$ as a7,
  V$ as a8,
  O$ as a9,
  aQ as aA,
  uQ as aB,
  w as aC,
  cQ as aD,
  dQ as aE,
  pQ as aF,
  N as aG,
  lQ as aH,
  yQ as aI,
  SQ as aJ,
  j as aK,
  mQ as aL,
  vQ as aM,
  gQ as aN,
  Z as aO,
  fQ as aP,
  AQ as aQ,
  IQ as aR,
  J as aS,
  $Q as aT,
  QQ as aU,
  CQ as aV,
  X as aW,
  hQ as aX,
  kQ as aY,
  DQ as aZ,
  te as a_,
  M as aa,
  x$ as ab,
  w$ as ac,
  H$ as ad,
  L as ae,
  N$ as af,
  W$ as ag,
  j$ as ah,
  U as ai,
  K$ as aj,
  Z$ as ak,
  Y$ as al,
  F as am,
  J$ as an,
  _$ as ao,
  X$ as ap,
  G as aq,
  eQ as ar,
  tQ as as,
  nQ as at,
  E as au,
  iQ as av,
  rQ as aw,
  sQ as ax,
  O as ay,
  oQ as az,
  e$ as b,
  uC as b$,
  TQ as b0,
  MQ as b1,
  ie as b2,
  bQ as b3,
  LQ as b4,
  BQ as b5,
  se as b6,
  UQ as b7,
  zQ as b8,
  FQ as b9,
  Ud as bA,
  ZQ as bB,
  Fd as bC,
  YQ as bD,
  Gd as bE,
  JQ as bF,
  Ed as bG,
  _Q as bH,
  Od as bI,
  XQ as bJ,
  wd as bK,
  eC as bL,
  Nd as bM,
  tC as bN,
  jd as bO,
  nC as bP,
  Zd as bQ,
  iC as bR,
  Jd as bS,
  rC as bT,
  Xd as bU,
  sC as bV,
  tp as bW,
  oC as bX,
  ip as bY,
  aC as bZ,
  ae as b_,
  ad as ba,
  RQ as bb,
  cd as bc,
  GQ as bd,
  pd as be,
  qQ as bf,
  yd as bg,
  EQ as bh,
  md as bi,
  VQ as bj,
  gd as bk,
  OQ as bl,
  Ad as bm,
  xQ as bn,
  $d as bo,
  wQ as bp,
  Cd as bq,
  HQ as br,
  kd as bs,
  NQ as bt,
  Pd as bu,
  WQ as bv,
  Md as bw,
  jQ as bx,
  Ld as by,
  KQ as bz,
  a as c,
  ZC as c$,
  cC as c0,
  dC as c1,
  sp as c2,
  pC as c3,
  ap as c4,
  lC as c5,
  cp as c6,
  yC as c7,
  pp as c8,
  SC as c9,
  Cp as cA,
  BC as cB,
  Fh as cC,
  zh as cD,
  kp as cE,
  UC as cF,
  ge as cG,
  zC as cH,
  FC as cI,
  RC as cJ,
  Ae as cK,
  GC as cL,
  qC as cM,
  EC as cN,
  $e as cO,
  VC as cP,
  OC as cQ,
  xC as cR,
  Ce as cS,
  wC as cT,
  HC as cU,
  NC as cV,
  ke as cW,
  WC as cX,
  jC as cY,
  KC as cZ,
  Pe as c_,
  yp as ca,
  mC as cb,
  mp as cc,
  vC as cd,
  gp as ce,
  gC as cf,
  ce as cg,
  fC as ch,
  AC as ci,
  IC as cj,
  Ap as ck,
  $C as cl,
  pe as cm,
  QC as cn,
  CC as co,
  hC as cp,
  ye as cq,
  kC as cr,
  DC as cs,
  PC as ct,
  me as cu,
  TC as cv,
  MC as cw,
  bC as cx,
  $p as cy,
  LC as cz,
  t$ as d,
  Ze as d$,
  YC as d0,
  JC as d1,
  Pp as d2,
  _C as d3,
  Mp as d4,
  XC as d5,
  Lp as d6,
  eh as d7,
  Up as d8,
  th as d9,
  Ah as dA,
  Ee as dB,
  Ih as dC,
  $h as dD,
  Qh as dE,
  Oe as dF,
  Ch as dG,
  hh as dH,
  kh as dI,
  we as dJ,
  Dh as dK,
  Ph as dL,
  Th as dM,
  Ne as dN,
  Mh as dO,
  bh as dP,
  Lh as dQ,
  Op as dR,
  Bh as dS,
  wp as dT,
  Uh as dU,
  Np as dV,
  Eh as dW,
  je as dX,
  Vh as dY,
  Oh as dZ,
  xh as d_,
  Fp as da,
  nh as db,
  Gp as dc,
  ih as dd,
  Me as de,
  rh as df,
  sh as dg,
  oh as dh,
  Ep as di,
  ah as dj,
  Le as dk,
  uh as dl,
  ch as dm,
  dh as dn,
  Ue as dp,
  ph as dq,
  lh as dr,
  yh as ds,
  Fe as dt,
  Sh as du,
  mh as dv,
  vh as dw,
  Ge as dx,
  gh as dy,
  fh as dz,
  n$ as e,
  qk as e$,
  wh as e0,
  Hh as e1,
  Nh as e2,
  jp as e3,
  Wh as e4,
  Je as e5,
  jh as e6,
  Kh as e7,
  Zh as e8,
  Xe as e9,
  $k as eA,
  yt as eB,
  Qk as eC,
  Ck as eD,
  hk as eE,
  mt as eF,
  kk as eG,
  Dk as eH,
  Pk as eI,
  gt as eJ,
  Tk as eK,
  Mk as eL,
  bk as eM,
  sl as eN,
  Lk as eO,
  al as eP,
  Bk as eQ,
  cl as eR,
  Uk as eS,
  pl as eT,
  zk as eU,
  yl as eV,
  Fk as eW,
  ml as eX,
  Rk as eY,
  At as eZ,
  Gk as e_,
  Yh as ea,
  Jh as eb,
  _h as ec,
  tt as ed,
  Xh as ee,
  ek as ef,
  tk as eg,
  it as eh,
  nk as ei,
  ik as ej,
  rk as ek,
  Zp as el,
  sk as em,
  Jp as en,
  ok as eo,
  Xp as ep,
  ak as eq,
  tl as er,
  uk as es,
  ct as et,
  vk as eu,
  gk as ev,
  fk as ew,
  pt as ex,
  Ak as ey,
  Ik as ez,
  i$ as f,
  jl as f$,
  Ek as f0,
  gl as f1,
  Vk as f2,
  Al as f3,
  Ok as f4,
  $t as f5,
  xk as f6,
  wk as f7,
  Hk as f8,
  Ct as f9,
  uD as fA,
  Ul as fB,
  cD as fC,
  Fl as fD,
  dD as fE,
  Gl as fF,
  pD as fG,
  El as fH,
  lD as fI,
  Ol as fJ,
  yD as fK,
  wl as fL,
  SD as fM,
  Lt as fN,
  mD as fO,
  vD as fP,
  gD as fQ,
  Ut as fR,
  fD as fS,
  AD as fT,
  ID as fU,
  Ft as fV,
  $D as fW,
  QD as fX,
  CD as fY,
  Nl as fZ,
  hD as f_,
  Nk as fa,
  Wk as fb,
  jk as fc,
  kt as fd,
  Kk as fe,
  Zk as ff,
  Yk as fg,
  $l as fh,
  Jk as fi,
  Cl as fj,
  _k as fk,
  kl as fl,
  Xk as fm,
  Pl as fn,
  eD as fo,
  Ml as fp,
  tD as fq,
  Pt as fr,
  nD as fs,
  iD as ft,
  rD as fu,
  Ll as fv,
  sD as fw,
  Mt as fx,
  oD as fy,
  aD as fz,
  c as g,
  Xt as g$,
  kD as g0,
  Zl as g1,
  DD as g2,
  Jl as g3,
  PD as g4,
  Xl as g5,
  TD as g6,
  ty as g7,
  MD as g8,
  Gt as g9,
  jD as gA,
  KD as gB,
  ZD as gC,
  yy as gD,
  YD as gE,
  jt as gF,
  JD as gG,
  _D as gH,
  XD as gI,
  my as gJ,
  eP as gK,
  gy as gL,
  tP as gM,
  Zt as gN,
  nP as gO,
  iP as gP,
  rP as gQ,
  Ay as gR,
  sP as gS,
  $y as gT,
  oP as gU,
  Jt as gV,
  aP as gW,
  uP as gX,
  cP as gY,
  Cy as gZ,
  dP as g_,
  bD as ga,
  LD as gb,
  BD as gc,
  Et as gd,
  UD as ge,
  zD as gf,
  FD as gg,
  iy as gh,
  RD as gi,
  Ot as gj,
  GD as gk,
  qD as gl,
  ED as gm,
  sy as gn,
  VD as go,
  ay as gp,
  OD as gq,
  wt as gr,
  xD as gs,
  wD as gt,
  HD as gu,
  cy as gv,
  ND as gw,
  py as gx,
  WD as gy,
  Nt as gz,
  r$ as h,
  Dn as h$,
  pP as h0,
  lP as h1,
  yP as h2,
  ky as h3,
  SP as h4,
  tn as h5,
  mP as h6,
  vP as h7,
  gP as h8,
  rn as h9,
  RP as hA,
  GP as hB,
  qP as hC,
  vn as hD,
  EP as hE,
  VP as hF,
  OP as hG,
  fn as hH,
  xP as hI,
  wP as hJ,
  HP as hK,
  Uy as hL,
  NP as hM,
  Fy as hN,
  WP as hO,
  In as hP,
  jP as hQ,
  KP as hR,
  ZP as hS,
  Qn as hT,
  YP as hU,
  JP as hV,
  _P as hW,
  hn as hX,
  XP as hY,
  eT as hZ,
  tT as h_,
  fP as ha,
  AP as hb,
  IP as hc,
  on as hd,
  $P as he,
  QP as hf,
  CP as hg,
  un as hh,
  hP as hi,
  kP as hj,
  DP as hk,
  dn as hl,
  PP as hm,
  TP as hn,
  MP as ho,
  ln as hp,
  bP as hq,
  LP as hr,
  BP as hs,
  Py as ht,
  UP as hu,
  My as hv,
  zP as hw,
  Ly as hx,
  FP as hy,
  Sn as hz,
  s$ as i,
  ET as i$,
  nT as i0,
  iT as i1,
  rT as i2,
  Gy as i3,
  sT as i4,
  Ey as i5,
  oT as i6,
  Oy as i7,
  aT as i8,
  wy as i9,
  CT as iA,
  iS as iB,
  hT as iC,
  sS as iD,
  kT as iE,
  aS as iF,
  DT as iG,
  cS as iH,
  PT as iI,
  pS as iJ,
  TT as iK,
  yS as iL,
  MT as iM,
  mS as iN,
  bT as iO,
  gS as iP,
  LT as iQ,
  zn as iR,
  BT as iS,
  UT as iT,
  zT as iU,
  Rn as iV,
  FT as iW,
  RT as iX,
  GT as iY,
  qn as iZ,
  qT as i_,
  uT as ia,
  Ny as ib,
  cT as ic,
  jy as id,
  dT as ie,
  Tn as ig,
  pT as ih,
  lT as ii,
  yT as ij,
  Zy as ik,
  ST as il,
  Jy as im,
  mT as io,
  bn as ip,
  vT as iq,
  gT as ir,
  fT as is,
  Bn as it,
  AT as iu,
  IT as iv,
  $T as iw,
  Xy as ix,
  QT as iy,
  tS as iz,
  o$ as j,
  bM as j$,
  VT as j0,
  Vn as j1,
  OT as j2,
  xT as j3,
  wT as j4,
  xn as j5,
  HT as j6,
  NT as j7,
  WT as j8,
  Hn as j9,
  yM as jA,
  ri as jB,
  SM as jC,
  mM as jD,
  vM as jE,
  oi as jF,
  gM as jG,
  fM as jH,
  AM as jI,
  AS as jJ,
  IM as jK,
  $S as jL,
  $M as jM,
  CS as jN,
  QM as jO,
  kS as jP,
  CM as jQ,
  PS as jR,
  hM as jS,
  MS as jT,
  kM as jU,
  ui as jV,
  DM as jW,
  PM as jX,
  TM as jY,
  di as jZ,
  MM as j_,
  jT as ja,
  KT as jb,
  ZT as jc,
  Wn as jd,
  YT as je,
  JT as jf,
  _T as jg,
  Kn as jh,
  XT as ji,
  eM as jj,
  tM as jk,
  Yn as jl,
  nM as jm,
  iM as jn,
  rM as jo,
  _n as jp,
  sM as jq,
  oM as jr,
  aM as js,
  ei as jt,
  uM as ju,
  cM as jv,
  dM as jw,
  ni as jx,
  pM as jy,
  lM as jz,
  p as k,
  XS as k$,
  LM as k0,
  li as k1,
  BM as k2,
  UM as k3,
  zM as k4,
  LS as k5,
  FM as k6,
  US as k7,
  RM as k8,
  FS as k9,
  eb as kA,
  tb as kB,
  nb as kC,
  hi as kD,
  ib as kE,
  rb as kF,
  sb as kG,
  NS as kH,
  ob as kI,
  jS as kJ,
  ab as kK,
  ZS as kL,
  ub as kM,
  Di as kN,
  cb as kO,
  db as kP,
  pb as kQ,
  Ti as kR,
  lb as kS,
  yb as kT,
  Sb as kU,
  JS as kV,
  mb as kW,
  bi as kX,
  vb as kY,
  gb as kZ,
  fb as k_,
  GM as ka,
  Si as kb,
  qM as kc,
  EM as kd,
  VM as ke,
  GS as kf,
  OM as kg,
  ES as kh,
  xM as ki,
  OS as kj,
  wM as kk,
  wS as kl,
  HM as km,
  vi as kn,
  NM as ko,
  WM as kp,
  jM as kq,
  fi as kr,
  KM as ks,
  ZM as kt,
  YM as ku,
  Ii as kv,
  JM as kw,
  _M as kx,
  XM as ky,
  Qi as kz,
  a$ as l,
  Am as l$,
  Ab as l0,
  Bi as l1,
  Ib as l2,
  $b as l3,
  Qb as l4,
  tm as l5,
  Cb as l6,
  zi as l7,
  hb as l8,
  kb as l9,
  wb as lA,
  Hb as lB,
  Nb as lC,
  Wi as lD,
  Wb as lE,
  jb as lF,
  Kb as lG,
  Ki as lH,
  Zb as lI,
  Yb as lJ,
  Jb as lK,
  pm as lL,
  _b as lM,
  ym as lN,
  Xb as lO,
  Yi as lP,
  eL as lQ,
  tL as lR,
  nL as lS,
  _i as lT,
  iL as lU,
  rL as lV,
  sL as lW,
  mm as lX,
  oL as lY,
  gm as lZ,
  aL as l_,
  Db as la,
  im as lb,
  Pb as lc,
  sm as ld,
  Tb as le,
  am as lf,
  Mb as lg,
  Ri as lh,
  bb as li,
  Lb as lj,
  Bb as lk,
  qi as ll,
  Ub as lm,
  zb as ln,
  Fb as lo,
  Vi as lp,
  Rb as lq,
  Gb as lr,
  qb as ls,
  xi as lt,
  Eb as lu,
  Vb as lv,
  Ob as lw,
  cm as lx,
  xb as ly,
  Hi as lz,
  u$ as m,
  WL as m$,
  uL as m0,
  $m as m1,
  cL as m2,
  Cm as m3,
  dL as m4,
  km as m5,
  pL as m6,
  Pm as m7,
  lL as m8,
  Mm as m9,
  DL as mA,
  er as mB,
  PL as mC,
  TL as mD,
  ML as mE,
  nr as mF,
  bL as mG,
  LL as mH,
  BL as mI,
  rr as mJ,
  UL as mK,
  zL as mL,
  FL as mM,
  or as mN,
  RL as mO,
  GL as mP,
  qL as mQ,
  ur as mR,
  EL as mS,
  VL as mT,
  OL as mU,
  dr as mV,
  xL as mW,
  wL as mX,
  HL as mY,
  lr as mZ,
  NL as m_,
  yL as ma,
  Lm as mb,
  SL as mc,
  Um as md,
  mL as me,
  Fm as mf,
  vL as mg,
  Gm as mh,
  gL as mi,
  Em as mj,
  fL as mk,
  Om as ml,
  AL as mm,
  wm as mn,
  IL as mo,
  Nm as mp,
  $L as mq,
  jm as mr,
  QL as ms,
  Zm as mt,
  CL as mu,
  Jm as mv,
  hL as mw,
  Xm as mx,
  kL as my,
  tv as mz,
  c$ as n,
  FB as n$,
  jL as n0,
  Sr as n1,
  KL as n2,
  ZL as n3,
  YL as n4,
  vr as n5,
  JL as n6,
  _L as n7,
  XL as n8,
  fr as n9,
  vB as nA,
  gB as nB,
  Dr as nC,
  fB as nD,
  AB as nE,
  IB as nF,
  Tr as nG,
  $B as nH,
  QB as nI,
  CB as nJ,
  br as nK,
  hB as nL,
  kB as nM,
  DB as nN,
  mv as nO,
  PB as nP,
  gv as nQ,
  TB as nR,
  Br as nS,
  MB as nT,
  bB as nU,
  LB as nV,
  Av as nW,
  BB as nX,
  zr as nY,
  UB as nZ,
  zB as n_,
  eB as na,
  tB as nb,
  nB as nc,
  Ir as nd,
  iB as ne,
  rB as nf,
  sB as ng,
  Qr as nh,
  oB as ni,
  aB as nj,
  uB as nk,
  Rh as nl,
  iv as nm,
  cB as nn,
  sv as no,
  dB as np,
  av as nq,
  pB as nr,
  cv as ns,
  lB as nt,
  pv as nu,
  yB as nv,
  yv as nw,
  SB as nx,
  hr as ny,
  mB as nz,
  y as o,
  DU as o$,
  $v as o0,
  RB as o1,
  Rr as o2,
  GB as o3,
  qB as o4,
  EB as o5,
  qr as o6,
  VB as o7,
  OB as o8,
  xB as o9,
  Kr as oA,
  oU as oB,
  aU as oC,
  uU as oD,
  Yr as oE,
  cU as oF,
  dU as oG,
  pU as oH,
  _r as oI,
  lU as oJ,
  yU as oK,
  SU as oL,
  es as oM,
  mU as oN,
  vU as oO,
  gU as oP,
  ns as oQ,
  fU as oR,
  AU as oS,
  IU as oT,
  rs as oU,
  $U as oV,
  QU as oW,
  CU as oX,
  os as oY,
  hU as oZ,
  kU as o_,
  Vr as oa,
  wB as ob,
  HB as oc,
  NB as od,
  xr as oe,
  WB as of,
  jB as og,
  KB as oh,
  Cv as oi,
  ZB as oj,
  kv as ok,
  YB as ol,
  Hr as om,
  JB as on,
  _B as oo,
  XB as op,
  Wr as oq,
  eU as or,
  tU as os,
  nU as ot,
  Pv as ou,
  iU as ov,
  Mv as ow,
  rU as ox,
  Lv as oy,
  sU as oz,
  d$ as p,
  mz as p$,
  us as p0,
  PU as p1,
  TU as p2,
  MU as p3,
  Uv as p4,
  bU as p5,
  Fv as p6,
  LU as p7,
  Gv as p8,
  BU as p9,
  fs as pA,
  YU as pB,
  JU as pC,
  _U as pD,
  Is as pE,
  XU as pF,
  ez as pG,
  tz as pH,
  Qs as pI,
  nz as pJ,
  iz as pK,
  rz as pL,
  hs as pM,
  sz as pN,
  oz as pO,
  az as pP,
  Zv as pQ,
  uz as pR,
  Jv as pS,
  cz as pT,
  Ds as pU,
  dz as pV,
  pz as pW,
  lz as pX,
  Ts as pY,
  yz as pZ,
  Sz as p_,
  Ev as pa,
  UU as pb,
  Ov as pc,
  zU as pd,
  ds as pe,
  FU as pf,
  RU as pg,
  GU as ph,
  wv as pi,
  qU as pj,
  Nv as pk,
  EU as pl,
  jv as pm,
  VU as pn,
  ls as po,
  OU as pp,
  xU as pq,
  wU as pr,
  Ss as ps,
  HU as pt,
  NU as pu,
  WU as pv,
  vs as pw,
  jU as px,
  KU as py,
  ZU as pz,
  p$ as q,
  gg as q$,
  Xv as q0,
  vz as q1,
  bs as q2,
  gz as q3,
  fz as q4,
  Az as q5,
  tg as q6,
  Iz as q7,
  Bs as q8,
  $z as q9,
  Oz as qA,
  Ws as qB,
  xz as qC,
  wz as qD,
  Hz as qE,
  Ks as qF,
  Nz as qG,
  Wz as qH,
  jz as qI,
  Ys as qJ,
  Kz as qK,
  Zz as qL,
  Yz as qM,
  ig as qN,
  Jz as qO,
  sg as qP,
  _z as qQ,
  ag as qR,
  Xz as qS,
  cg as qT,
  eF as qU,
  pg as qV,
  tF as qW,
  yg as qX,
  nF as qY,
  mg as qZ,
  iF as q_,
  Qz as qa,
  Cz as qb,
  Gh as qc,
  zs as qd,
  hz as qe,
  kz as qf,
  Dz as qg,
  Rs as qh,
  Pz as qi,
  Tz as qj,
  Mz as qk,
  qs as ql,
  bz as qm,
  Lz as qn,
  Bz as qo,
  Vs as qp,
  Uz as qq,
  zz as qr,
  Fz as qs,
  xs as qt,
  Rz as qu,
  Gz as qv,
  qz as qw,
  Hs as qx,
  Ez as qy,
  Vz as qz,
  l$ as r,
  Og as r$,
  rF as r0,
  Ag as r1,
  sF as r2,
  $g as r3,
  oF as r4,
  Cg as r5,
  aF as r6,
  _s as r7,
  uF as r8,
  cF as r9,
  PF as rA,
  uo as rB,
  TF as rC,
  MF as rD,
  bF as rE,
  po as rF,
  LF as rG,
  BF as rH,
  UF as rI,
  yo as rJ,
  zF as rK,
  FF as rL,
  RF as rM,
  mo as rN,
  GF as rO,
  qF as rP,
  EF as rQ,
  go as rR,
  VF as rS,
  OF as rT,
  xF as rU,
  Fg as rV,
  wF as rW,
  Gg as rX,
  HF as rY,
  Eg as rZ,
  NF as r_,
  dF as ra,
  kg as rb,
  pF as rc,
  Pg as rd,
  lF as re,
  Mg as rf,
  yF as rg,
  Lg as rh,
  SF as ri,
  eo as rj,
  mF as rk,
  vF as rl,
  gF as rm,
  Ug as rn,
  fF as ro,
  no as rp,
  AF as rq,
  IF as rr,
  $F as rs,
  ro as rt,
  QF as ru,
  CF as rv,
  hF as rw,
  oo as rx,
  kF as ry,
  DF as rz,
  m as s,
  Xg as s$,
  WF as s0,
  Ao as s1,
  jF as s2,
  KF as s3,
  ZF as s4,
  $o as s5,
  YF as s6,
  JF as s7,
  _F as s8,
  Co as s9,
  gR as sA,
  fR as sB,
  AR as sC,
  Fo as sD,
  IR as sE,
  $R as sF,
  QR as sG,
  Go as sH,
  CR as sI,
  hR as sJ,
  kR as sK,
  Eo as sL,
  DR as sM,
  PR as sN,
  TR as sO,
  Oo as sP,
  MR as sQ,
  bR as sR,
  LR as sS,
  wo as sT,
  BR as sU,
  UR as sV,
  zR as sW,
  Zg as sX,
  FR as sY,
  Jg as sZ,
  RR as s_,
  XF as sa,
  eR as sb,
  tR as sc,
  ko as sd,
  nR as se,
  iR as sf,
  rR as sg,
  wg as sh,
  sR as si,
  Ng as sj,
  oR as sk,
  jg as sl,
  aR as sm,
  Po as sn,
  uR as so,
  cR as sp,
  dR as sq,
  Mo as sr,
  pR as ss,
  lR as st,
  yR as su,
  Lo as sv,
  SR as sw,
  mR as sx,
  vR as sy,
  Uo as sz,
  y$ as t,
  pa as t$,
  GR as t0,
  tf as t1,
  qR as t2,
  rf as t3,
  ER as t4,
  of as t5,
  VR as t6,
  uf as t7,
  OR as t8,
  df as t9,
  oG as tA,
  ta as tB,
  aG as tC,
  uG as tD,
  cG as tE,
  ia as tF,
  dG as tG,
  pG as tH,
  lG as tI,
  sa as tJ,
  yG as tK,
  SG as tL,
  mG as tM,
  aa as tN,
  vG as tO,
  gG as tP,
  fG as tQ,
  ff as tR,
  AG as tS,
  If as tT,
  IG as tU,
  Qf as tV,
  $G as tW,
  ca as tX,
  QG as tY,
  CG as tZ,
  hG as t_,
  xR as ta,
  lf as tb,
  wR as tc,
  Sf as td,
  HR as te,
  vf as tf,
  NR as tg,
  No as th,
  WR as ti,
  jR as tj,
  KR as tk,
  jo as tl,
  ZR as tm,
  YR as tn,
  JR as to,
  Zo as tp,
  _R as tq,
  XR as tr,
  eG as ts,
  Jo as tt,
  tG as tu,
  nG as tv,
  iG as tw,
  Xo as tx,
  rG as ty,
  sG as tz,
  _I as u,
  Fa as u$,
  kG as u0,
  DG as u1,
  PG as u2,
  hf as u3,
  TG as u4,
  ya as u5,
  MG as u6,
  bG as u7,
  LG as u8,
  ma as u9,
  JG as uA,
  Pa as uB,
  _G as uC,
  XG as uD,
  eq as uE,
  bf as uF,
  tq as uG,
  Bf as uH,
  nq as uI,
  zf as uJ,
  iq as uK,
  Rf as uL,
  rq as uM,
  qf as uN,
  sq as uO,
  Ma as uP,
  oq as uQ,
  aq as uR,
  uq as uS,
  La as uT,
  cq as uU,
  dq as uV,
  pq as uW,
  Ua as uX,
  lq as uY,
  yq as uZ,
  Sq as u_,
  BG as ua,
  UG as ub,
  zG as uc,
  ga as ud,
  FG as ue,
  RG as uf,
  GG as ug,
  Aa as uh,
  qG as ui,
  EG as uj,
  VG as uk,
  $a as ul,
  OG as um,
  xG as un,
  wG as uo,
  Df as up,
  HG as uq,
  Tf as ur,
  NG as us,
  Ca as ut,
  WG as uu,
  jG as uv,
  KG as uw,
  ka as ux,
  ZG as uy,
  YG as uz,
  S$ as v,
  oA as v$,
  mq as v0,
  vq as v1,
  gq as v2,
  Ga as v3,
  fq as v4,
  Aq as v5,
  Iq as v6,
  Ea as v7,
  $q as v8,
  Qq as v9,
  Eq as vA,
  Vq as vB,
  Oq as vC,
  Za as vD,
  xq as vE,
  wq as vF,
  Hq as vG,
  _f as vH,
  Nq as vI,
  eA as vJ,
  Wq as vK,
  Ja as vL,
  jq as vM,
  Kq as vN,
  Zq as vO,
  nA as vP,
  Yq as vQ,
  Xa as vR,
  Jq as vS,
  _q as vT,
  Xq as vU,
  tu as vV,
  eE as vW,
  tE as vX,
  nE as vY,
  rA as vZ,
  iE as v_,
  Cq as va,
  Oa as vb,
  hq as vc,
  kq as vd,
  Dq as ve,
  wa as vf,
  Pq as vg,
  Tq as vh,
  Mq as vi,
  Vf as vj,
  bq as vk,
  xf as vl,
  Lq as vm,
  Hf as vn,
  Bq as vo,
  Wf as vp,
  Uq as vq,
  Kf as vr,
  zq as vs,
  Na as vt,
  Fq as vu,
  Rq as vv,
  Gq as vw,
  Yf as vx,
  qq as vy,
  ja as vz,
  m$ as w,
  NE as w$,
  rE as w0,
  uA as w1,
  sE as w2,
  dA as w3,
  oE as w4,
  iu as w5,
  aE as w6,
  uE as w7,
  cE as w8,
  su as w9,
  PE as wA,
  yu as wB,
  TE as wC,
  ME as wD,
  bE as wE,
  hA as wF,
  LE as wG,
  DA as wH,
  BE as wI,
  TA as wJ,
  UE as wK,
  bA as wL,
  zE as wM,
  mu as wN,
  FE as wO,
  RE as wP,
  GE as wQ,
  gu as wR,
  qE as wS,
  EE as wT,
  VE as wU,
  Au as wV,
  OE as wW,
  xE as wX,
  wE as wY,
  $u as wZ,
  HE as w_,
  dE as wa,
  pE as wb,
  lE as wc,
  lA as wd,
  yE as we,
  SA as wf,
  SE as wg,
  vA as wh,
  mE as wi,
  au as wj,
  vE as wk,
  gE as wl,
  fE as wm,
  cu as wn,
  AE as wo,
  IE as wp,
  $E as wq,
  pu as wr,
  QE as ws,
  CE as wt,
  hE as wu,
  fA as wv,
  kE as ww,
  IA as wx,
  DE as wy,
  QA as wz,
  g as x,
  BV as x$,
  WE as x0,
  Cu as x1,
  jE as x2,
  KE as x3,
  ZE as x4,
  ku as x5,
  YE as x6,
  JE as x7,
  _E as x8,
  Pu as x9,
  mV as xA,
  KA as xB,
  vV as xC,
  Uu as xD,
  gV as xE,
  fV as xF,
  AV as xG,
  Fu as xH,
  IV as xI,
  $V as xJ,
  QV as xK,
  YA as xL,
  CV as xM,
  _A as xN,
  hV as xO,
  eI as xP,
  kV as xQ,
  nI as xR,
  DV as xS,
  rI as xT,
  PV as xU,
  Gu as xV,
  TV as xW,
  MV as xX,
  bV as xY,
  Eu as xZ,
  LV as x_,
  XE as xa,
  eV as xb,
  tV as xc,
  Mu as xd,
  nV as xe,
  iV as xf,
  rV as xg,
  Lu as xh,
  sV as xi,
  oV as xj,
  aV as xk,
  BA as xl,
  uV as xm,
  zA as xn,
  cV as xo,
  RA as xp,
  dV as xq,
  qA as xr,
  pV as xs,
  VA as xt,
  lV as xu,
  xA as xv,
  yV as xw,
  HA as xx,
  SV as xy,
  WA as xz,
  v$ as y,
  $O as y$,
  UV as y0,
  Ou as y1,
  zV as y2,
  FV as y3,
  RV as y4,
  oI as y5,
  GV as y6,
  uI as y7,
  qV as y8,
  wu as y9,
  rO as yA,
  SI as yB,
  sO as yC,
  vI as yD,
  oO as yE,
  fI as yF,
  aO as yG,
  II as yH,
  uO as yI,
  tc as yJ,
  cO as yK,
  dO as yL,
  pO as yM,
  ic as yN,
  lO as yO,
  yO as yP,
  SO as yQ,
  sc as yR,
  mO as yS,
  vO as yT,
  gO as yU,
  qh as yV,
  ac as yW,
  fO as yX,
  AO as yY,
  IO as yZ,
  cc as y_,
  EV as ya,
  VV as yb,
  OV as yc,
  Nu as yd,
  xV as ye,
  wV as yf,
  HV as yg,
  dI as yh,
  NV as yi,
  ju as yj,
  WV as yk,
  jV as yl,
  KV as ym,
  Zu as yn,
  ZV as yo,
  YV as yp,
  JV as yq,
  Ju as yr,
  _V as ys,
  XV as yt,
  eO as yu,
  Xu as yv,
  tO as yw,
  nO as yx,
  iO as yy,
  lI as yz,
  g$ as z,
  dx as z$,
  QO as z0,
  CO as z1,
  pc as z2,
  hO as z3,
  kO as z4,
  DO as z5,
  QI as z6,
  PO as z7,
  hI as z8,
  TO as z9,
  $c as zA,
  WO as zB,
  jO as zC,
  KO as zD,
  RI as zE,
  ZO as zF,
  qI as zG,
  YO as zH,
  Cc as zI,
  JO as zJ,
  _O as zK,
  XO as zL,
  kc as zM,
  ex as zN,
  tx as zO,
  nx as zP,
  Pc as zQ,
  ix as zR,
  rx as zS,
  sx as zT,
  VI as zU,
  ox as zV,
  xI as zW,
  ax as zX,
  Mc as zY,
  ux as zZ,
  cx as z_,
  DI as za,
  MO as zb,
  TI as zc,
  bO as zd,
  yc as ze,
  LO as zf,
  BO as zg,
  UO as zh,
  bI as zi,
  zO as zj,
  BI as zk,
  FO as zl,
  mc as zm,
  RO as zn,
  GO as zo,
  qO as zp,
  gc as zq,
  EO as zr,
  VO as zs,
  OO as zt,
  zI as zu,
  xO as zv,
  Ac as zw,
  wO as zx,
  HO as zy,
  NO as zz
};
//# sourceMappingURL=graphql-generated-C7gdimYx.js.map
